const translations = {
  en: {
    // Dashboard / Owner UI
    studio_name: 'Maestra',
    moodboards: 'Moodboards',
    image_library: 'Image Library',
    new_board: '+ New Board',
    sign_out: 'Sign Out',
    no_boards_title: 'No moodboards yet',
    no_boards_text: 'Create your first moodboard to start curating visual experiences for your clients.',
    create_first_board: 'Create First Board',
    duplicate: 'Duplicate',
    delete: 'Delete',
    images: 'images',
    expires: 'Expires',
    settings: 'Settings',
    export_pdf: 'Export PDF',
    backup_zip: 'Backup ZIP',
    exports_panel_subtitle: 'The finished moodboard, ready to share.',
    export_pdf_subtitle: 'For your client.',
    backup_zip_subtitle: 'For your archive.',
    pdf_quota_remaining: '{remaining} of {limit} PDF exports remaining',
    zip_quota_remaining: '{remaining} of {limit} backups remaining',
    lock_board: 'Lock Board',
    unlock_board: 'Unlock Board',
    board_settings: 'Board Settings',
    boards_settings_title: 'Board Settings',
    boards_settings_subtitle: 'How your clients experience every board — atmosphere, texts and footer.',
    boards_settings_back: 'Boards',
    boards_settings_locked: 'Board customization is not available on your current plan.',
    workspace_board_settings_hint: 'Colours, client view texts and the footer live in Board Settings, inside the Boards module.',
    open_board_settings: 'Open Board Settings',
    workspace_logo_managed_hint: 'The logo itself is managed in Workspace Settings.',
    open_workspace_settings: 'Workspace Settings',
    cr_title: 'Creator Space',
    cr_eyebrow: 'Your external memory',
    cr_sub: 'Capture first. Organize later.',
    cr_back: 'Workspace',
    cr_capture_placeholder: 'What\u2019s on your mind? Just capture it\u2026',
    cr_capture_btn: 'Capture',
    cr_captured: 'Saved to Brain Dump',
    cr_today: 'Today',
    cr_this_week: 'This week',
    cr_waiting: 'Waiting for',
    cr_areas: 'Areas',
    cr_today_empty: 'Nothing needs you today.',
    cr_week_empty: 'A quiet week ahead.',
    cr_waiting_empty: 'Nothing is waiting on others.',
    cr_area_empty: 'Nothing here yet.',
    cr_search_placeholder: 'Search everything, including history\u2026',
    cr_no_results: 'Nothing found.',
    cr_results_for: 'Results for',
    cr_evolution: 'Evolution',
    cr_created: 'Created',
    cr_last_edited: 'Last edited',
    cr_add_note: 'Continue thinking\u2026',
    cr_add_decision: 'Save as decision',
    cr_note_placeholder: 'Add a thought \u2014 previous ones are never overwritten\u2026',
    cr_type: 'Type',
    cr_area: 'Area',
    cr_due: 'Due',
    cr_mark_done: 'Mark done',
    cr_reopen: 'Reopen',
    cr_delete: 'Delete',
    cr_delete_confirm: 'Delete this item and its whole history?',
    cr_no_type: 'Thought',
    cr_type_task: 'Task',
    cr_type_idea: 'Idea',
    cr_type_project: 'Project',
    cr_type_waiting: 'Waiting',
    cr_type_decision: 'Decision',
    cr_type_reference: 'Reference',
    cr_evo_created: 'First Idea',
    cr_evo_note: 'Added',
    cr_evo_decision: 'Decision',
    cr_evo_moved: 'Moved',
    cr_evo_status: 'Status',
    cr_evo_edit: 'Edited',
    cr_open: 'Open',
    cr_done: 'Done',
    cr_all: 'All',
    cr_save: 'Save',
    cr_decided: 'Decided',
    cr_todo: 'To do',
    cr_ideas_parked: 'Ideas parked',
    cr_other_items: 'Other',
    cr_project_label: 'Project',
    cr_no_project: 'None',
    cr_part_of: 'Part of',
    cr_add_decided_ph: 'Add a decision\u2026',
    cr_add_todo_ph: 'Add a task\u2026',
    cr_add_idea_ph: 'Park an idea\u2026',
    cr_evo_project: 'Assigned to Project',
    cr_evo_project_removed: 'Removed from Project',
    cr_evo_completed: 'Completed',
    cr_evo_reopened: 'Reopened',
    cr_evo_direction: 'Direction',
    cr_direction: 'Current direction',
    cr_direction_ph: 'Where is this heading?\u2026',
    cr_direction_empty: 'No direction yet \u2014 capture where this is heading.',
    cr_related: 'Related entries',
    cr_recent_decisions: 'Recently decided',
    cr_recent_activity: 'Recent activity',
    cr_your_timeline: 'Your timeline',
    cr_no_decisions: 'No decisions yet \u2014 they will gather here.',
    cr_no_timeline: 'A quiet month \u2014 nothing captured here.',
    cr_whats_on_mind: 'What\u2019s on your mind?',
    cr_capture_hint: 'It goes to Brain Dump. You can organize it later.',
    cr_continue_where: 'Continue where you left off',
    cr_continue: 'Continue',
    cr_open_entries: 'open entries',
    cr_active_projects: 'projects',
    cr_areas_intro: 'Dedicated spaces for every part of your life and work.',
    cr_nav_overview: 'Overview',
    cr_nav_projects: 'Projects',
    cr_nav_todo: 'To Do',
    cr_nav_ideas: 'Notes & Ideas',
    cr_current: 'Current',
    cr_superseded: 'Superseded',
    cr_superseded_plural: 'superseded',
    cr_mark_superseded: 'Mark as superseded',
    cr_make_current: 'Make current again',
    cr_area_desc_brain_dump: 'Your external inbox. Capture every thought instantly \u2014 organize it later. Nothing has to be categorized yet.',
    cr_area_desc_ecru: 'Ideas, marketing, offers, photography, Brand Aesthetic, Celebration Styling and everything related to your creative business.',
    cr_area_desc_home: 'Household tasks, shopping, repairs, home organization, documents and everything related to your home.',
    cr_area_desc_nataniel: 'School, appointments, activities, shopping, documents, ideas and everything related to your child.',
    cr_area_desc_money: 'Bills, subscriptions, payments, monthly expenses, invoices, finances and things to review or cancel.',
    cr_area_desc_life_admin: 'Official matters, insurance, contracts, letters, administration and everything that keeps life running.',
    cr_area_desc_idea_vault: 'Ideas worth keeping for the future. No pressure to act on them today.',
    cr_area_desc_wishlist: 'Things you want to buy for your home, studio, business or yourself. Save links, priorities and notes.',
    cr_area_desc_this_month: 'Temporary priorities and tasks that only matter this month. Review regularly and clear when finished.',
    cr_area_desc_someday: 'Ideas, dreams and plans for the future. Not a priority today, but worth remembering.',
    board_name: 'Board Name',
    client_name: 'Client Name',
    session_date: 'Project Date',
    link_expiration: 'Link Expiration (Days)',
    auto_lock: 'Auto-Lock Before Project Date (Days)',
    final_decision_mode: 'Final Decision Mode',
    final_decision_desc: 'Protect final selections behind a secure email invitation sent to your client.',
    final_enabled: 'Enabled — client can select finals',
    final_enable: 'Enable for client',
    // Final Decision Mode — secure invitation flow
    fd_status_active: 'Final mode active',
    fd_status_inactive: 'Final mode inactive',
    fd_enable_cta: 'Enable secure final approvals',
    fd_disable_cta: 'Disable Final mode',
    fd_resend: 'Resend invitation',
    fd_revoke: 'Revoke access',
    fd_modal_title: 'Enable secure final approvals',
    fd_modal_body: 'Final selections will require secure client access.\n\nYour client will receive a private invitation email.\nAll final decisions will be linked to their identity.',
    fd_modal_email_label: 'Client email',
    fd_modal_send: 'Send invitation',
    fd_modal_cancel: 'Cancel',
    fd_invited_label: 'Invited',
    fd_client_label: 'Client',
    fd_resecure_banner_title: 'Re-secure this board',
    fd_resecure_banner_body: 'Final mode was previously enabled without a secure invitation. Send your client a private email to continue.',
    fd_resecure_banner_cta: 'Send invitation',
    fd_audit_title: 'Approval activity',
    fd_audit_show: 'Show activity',
    fd_audit_hide: 'Hide activity',
    fd_audit_empty: 'No approval activity yet.',
    fd_audit_invited: 'Invitation sent',
    fd_audit_resent: 'Invitation resent',
    fd_audit_revoked: 'Access revoked',
    fd_audit_opened: 'Opened approval space',
    fd_audit_marked_final: 'Marked as final',
    fd_audit_unmarked_final: 'Removed from final',
    fd_audit_confirmed: 'Confirmed final direction',
    fd_audit_mode_disabled: 'Final mode disabled',
    fd_invalid_email: 'Please enter a valid email address.',
    fd_share_notice: 'Final selections are reviewed privately by the invited client.',
    final_decision_section_title: 'Final selections',
    fd_open_only_via_email: 'This approval space is private. Please open it from the invitation email.',
    fd_approval_eyebrow: 'Final approval space',
    fd_approval_signed_in_as: 'Signed in as',
    fd_approval_confirm_cta: 'Confirm final direction',
    fd_approval_confirmed_at: 'Direction confirmed on',
    fd_approval_link_invalid: 'This approval link is no longer active. Please ask your studio for a new invitation.',
    fd_approval_intro: 'You can mark your final preferences and confirm the direction when you\u2019re ready.',
    fd_approval_change_hint: 'You can change your selections anytime. Tap a final mark to remove it, or confirm again to update the timestamp.',
    fd_approval_reconfirm_cta: 'Update final direction',
    fd_mark_final: 'Mark as final',
    fd_unmark_final: 'Remove from final',
    client_language: 'Client Language',
    client_language_desc: 'Language displayed to the client viewing this board.',
    client_communication: 'Client communication',
    client_communication_desc: 'Allow notes and shared communication space',
    notes_enabled: 'Notes enabled',
    notes_hidden: 'Notes hidden',
    exports: 'Exports',
    actions: 'Actions',
    archive_board: 'Archive Board',
    restore_board: 'Restore Board',
    delete_board: 'Delete Board',
    workspace_language: 'Workspace Language',
    days: 'days',
    settings_editable_later: 'You can change these settings later in the board settings.',
    preview_as_client: 'View as client',
    // Onboarding — calm welcome card + empty-state helpers
    welcome_eyebrow: 'Welcome to Maestra',
    welcome_title: 'A private workspace for visual direction.',
    welcome_subtitle: 'A calm space for client collaboration, approvals and creative direction. Start by exploring how a client experiences a board, or create your own.',
    welcome_cta_explore: 'Explore Demo Board',
    welcome_cta_create: 'Create Your First Board',
    welcome_dismiss: 'Dismiss',
    empty_no_boards: 'Create your first client direction space.',
    empty_no_library: 'Your visual archive starts here.',
    empty_no_documents: 'Attach contracts, inspiration or project references.',
    empty_no_notes: 'Share direction, thoughts or important updates with your client.',
    empty_no_inspirations: 'Inspiration shared by your client appears here.',
    helper_library: 'Store and organize inspiration, references and reusable visuals.',
    helper_documents: 'Attach contracts, references or project materials for your client.',
    helper_notes: 'Share direction, thoughts or important updates with your client.',
    helper_pdf: 'Create a printable summary of selections, approvals and direction.',
    helper_zip: 'Archive the full board including images, notes and client decisions.',
    helper_lock: 'Prevent further reactions and approvals while keeping notes available.',
    helper_final: 'Secure selected choices before production or execution.',
    helper_client_access: 'Share your board openly or invite clients privately for approvals.',
    // Maestra Guide
    guide_nav_label: 'Maestra Guide',
    guide_intro: 'A quiet introduction to how Maestra works — at your own pace.',
    guide_empty_admin: 'No guide sections yet. Add the first one from Admin → Guide.',
    guide_empty_user: 'The studio guide is being prepared. Check back soon.',
    guide_recommended_for: 'Recommended for',
    // Settings — Restore Demo
    restore_demo_title: 'Restore Demo Board',
    restore_demo_desc: 'Bring back the example board so you can revisit how a finished workflow looks.',
    restore_demo_cta: 'Restore demo board',
    restore_demo_done: 'Demo board restored.',
    restore_demo_limit: 'Restore limit reached. Please contact support if you need help.',

    // BoardEditor chrome
    back: '← Back',
    exporting: 'Exporting...',
    generating: 'Generating...',
    // PDF export staged progress
    export_stage_preparing: 'Preparing images',
    export_stage_building: 'Building PDF',
    export_stage_finalizing: 'Finalizing file',
    export_stage_download: 'Download starting',
    export_long_wait_hint: 'Large boards can take a little longer. Please keep this window open.',
    export_failed_calm: 'The export could not be completed. Please try again in a moment.',
    client_link: 'Client link',
    status_open: 'Open',
    status_active: 'Active',
    status_expired: 'Expired',
    status_locked: 'Locked',
    available_until: 'Available until',
    closed_on: 'Closed',
    extend: 'Extend',
    reopen_board: 'Reopen board',
    show_link: 'Show link',
    hide_link: 'Hide link',
    copy_link: 'Copy link',
    copied: 'Copied',
    notify_client: 'Notify client',
    add_client_email_to_notify: 'Add client email to notify',
    note_to_client_title: 'A note to your client',
    note_to_client_subtitle: 'Optional. A personal line shown above your gallery.',
    note_to_client_placeholder: 'A personal note to your client…',
    editing_ellipsis: 'Editing…',
    saving_ellipsis: 'Saving…',
    saved: 'Saved',
    shared_client_space: 'Shared Client Space',
    shared_client_space_subtitle: 'This is how your client experiences the board and shared direction.',
    customize_client_view: 'Customize Client View',
    cv_edit_mode_banner: 'Editing client view — click any text on the page',
    cv_edit_done: 'Done',
    cv_edit_continue_below: 'Continue to board ↓',
    save_failed: 'Could not save',
    inline_advanced_options: 'Advanced ▾',
    client_view_editor_eyebrow: 'CLIENT VIEW EDITOR',
    client_view_editor_title: 'What your client sees',
    client_view_editor_subtitle: 'Shape the exact experience — changes save instantly.',
    client_view_editor_sections_soon: 'This panel holds visibility, order and advanced options. All texts are edited directly on the page.',
    cve_sections_eyebrow: 'SECTIONS',
    cve_sections_help: 'Show, hide and reorder the sections your client sees. Titles and descriptions are edited directly on the page.',
    cve_section_title_label: 'Section title',
    cve_section_description_label: 'Section description',
    card_gallery_section: 'Gallery',
    cve_gallery_title_placeholder: 'Optional heading above the images',
    cve_gallery_description_placeholder: 'Optional context — a short line under the heading',
    cve_use_workspace_defaults: 'Use Workspace Defaults',
    cve_workspace_defaults_on_hint: 'Section names come from Branding → Client View Texts. Turn off to customize this board only.',
    cve_workspace_defaults_off_hint: 'This board uses its own section names and descriptions.',
    cve_workspace_defaults_locked_hint: 'Available on Pro and Signature. All boards inherit the workspace defaults on your current plan.',
    cve_inherits_workspace_default: 'Inherits the workspace default.',
    inline_section_locked_hint: 'Inherits the workspace default. Turn off "Use Workspace Defaults" under Advanced to customize this board.',
    inline_texts_on_page_hint: 'Titles and texts are edited directly on the page.',
    cve_drag_section: 'Reorder section',
    cve_reorder_hint: 'Drag by ⋮⋮ to reorder sections.',
    gallery_add_section: 'Add section',
    gallery_new_section_default_title: 'New section',
    gallery_section_delete: 'Delete section',
    gallery_section_drag: 'Reorder section',
    gallery_section_desc_placeholder: 'Optional description',
    gallery_section_empty_hint: 'Use "Move to section" on any image to place it here.',
    gallery_section_delete_confirm: 'Delete this section? Its images stay on the board and drop to Uncategorized.',
    card_final_decision_section: 'Final Decision',
    cve_fd_active_hint: 'The Final Decision banner is a system notice and is not editable.',
    private_space_title: 'Private Space',
    private_space_hint: 'Visible only to you',
    private_notes_title: 'Private Notes',
    private_add_note: 'Add note',
    private_note_title_placeholder: 'Note title',
    private_note_placeholder: 'Write anything — ideas, shot list, reminders…',
    private_empty_notes: 'No notes yet — ideas, shot lists, reminders.',
    private_todo_title: 'To-Do / Reminders',
    private_todo_placeholder: 'Add a task and press Enter',
    private_gallery_title: 'Private Gallery',
    private_gallery_hint: 'Images & inspiration only you can see.',
    private_add_images: 'Add images',
    private_add_from_library: 'From library',
    private_delete: 'Delete',
    attach_from: 'Attach:',
    attach_document: 'Document',
    attach_gallery: 'Board images',
    attach_confirm: 'Attach',
    view_board_card: 'View board',
    attachment_removed: 'Document removed',
    doc_link: 'Link',
    no_documents_yet: 'No documents on this board yet',
    filter_active: 'Active',
    filter_expired: 'Expired',
    filter_all: 'All',
    // ── Client Space ──
    clients_nav: 'Clients',
    cs_title: 'Client Space',
    cs_subtitle: 'A private record of every collaboration — history, documents and boards, always at hand.',
    cs_back: 'Clients',
    cs_back_dashboard: 'Workspace',
    cs_new_client: '+ New client',
    cs_new_client_title: 'New client',
    cs_no_clients_title: 'No clients yet',
    cs_no_clients: 'Create your first client record — history, documents and boards will live here.',
    cs_not_found: 'Client not found.',
    cs_client_name: 'Name',
    cs_company: 'Company (optional)',
    cs_email: 'Email',
    cs_phone: 'Phone',
    cs_address: 'Address',
    cs_address_optional: 'Address (optional — you can add it later)',
    cs_meta_history: 'entries',
    cs_meta_boards: 'boards',
    cs_important_info: 'Important information',
    cs_since: 'Collaboration since',
    cs_open_record: 'Client record',
    // ── Workspace dashboard & modules ──
    wd_library: 'Library',
    wd_library_desc: 'All your inspirations, images and collections.',
    wd_clients: 'Clients',
    wd_clients_desc: 'Client cards, history, documents and memories.',
    wd_boards: 'Boards',
    wd_boards_desc: 'Collaborate with clients and bring ideas to life.',
    wd_creator: 'Creator Space',
    wd_creator_desc: 'Your space for ideas, planning and growth.',
    wd_home: 'Home',
    wd_soon: 'Soon',
    wd_greet_morning: 'Good morning',
    wd_greet_afternoon: 'Good afternoon',
    wd_greet_evening: 'Good evening',
    wd_workspace_sub: 'This is your creative workspace',
    wd_quote: 'Creativity is not a luxury. It\u2019s a way of life.',
    wd_bell: 'Client activity',
    modules_section: 'My modules',
    module_on: 'On',
    module_off: 'Off',
    modules_note: 'Modules you switch off disappear from your workspace entirely. Library is part of the core and always stays.',
    wd_greeting: 'Welcome to your studio.',
    wd_enter: 'Enter',
    cs_add: 'Add',
    cs_assign_short: 'Assign',
    cs_create_short: '+ New',
    cs_boards_empty_short: 'No boards yet — Client Space works independently, for history and documents alone.',
    cs_important_info_hint: 'Anything worth remembering — preferences, allergies, agreements, the way they like to work…',
    cs_email_action: 'Email',
    cs_call: 'Call',
    cs_map: 'Map',
    cs_tab_history: 'History',
    cs_tab_documents: 'Documents',
    cs_tab_boards: 'Boards',
    cs_search_history: 'Search title, notes, tags…',
    cs_search_clients: 'Search clients…',
    cs_export_zip: 'Export ZIP',
    cs_export_client: 'Download archive',
    cs_exporting: 'Preparing…',
    cs_export_failed: 'Export failed — please try again.',
    cs_clients_no_results: 'No clients match your search.',
    cs_add_entry: '+ Add entry',
    cs_add_entry_title: 'New history entry',
    cs_edit_entry: 'Edit entry',
    cs_history_empty: 'The story of this collaboration starts here — add the first entry.',
    cs_history_no_results: 'Nothing matches your search.',
    cs_entry_date: 'Date',
    cs_entry_title: 'Title',
    cs_entry_title_hint: 'e.g. First consultation, Lash refill, Brand workshop…',
    cs_entry_note: 'Note',
    cs_entry_tags: 'Tags (optional)',
    cs_entry_tags_hint: 'Type and press Enter',
    cs_entry_photos: 'Photos (optional)',
    cs_entry_link_board: 'Linked board (optional)',
    cs_entry_link_board_view: 'Board',
    cs_entry_link_documents: 'Linked documents (optional)',
    cs_none: 'None',
    cs_created: 'Created',
    cs_last_edited: 'Last edited',
    cs_edit_history: 'Edit history',
    cs_previous_version: 'Version until',
    cs_delete_entry_confirm: 'Delete this entry permanently?',
    cs_docs_empty: 'Contracts, briefs, inspiration files — everything about this client, in one calm place.',
    cs_upload_document: '+ Upload document',
    cs_upload_failed: 'Upload failed',
    cs_preview: 'Preview',
    cs_download: 'Download',
    cs_link_to_board: 'Link to board',
    cs_unlink_relabel: 'Board link',
    cs_remove: 'Remove',
    cs_doc_remove_confirm: 'Remove this document permanently?',
    cs_boards_empty: 'No boards assigned yet. Client Space works independently — keep the history and documents of this collaboration here, even without a board.',
    cs_create_board: '+ Create board',
    cs_assign_board: 'Assign existing board',
    cs_assign_pick: 'Assign a board',
    cs_no_assignable: 'Every board is already assigned to a client.',
    cs_unassign: 'Unassign',
    cs_board_created: 'Board created',
    cs_board_assigned: 'Board assigned',
    cs_delete_client: 'Delete client',
    cs_delete_client_confirm: 'Delete this client and their entire record? Boards stay untouched.',
    cs_save: 'Save',
    cs_cancel: 'Cancel',
    cs_create: 'Create',
    cs_edit: 'Edit',
    cs_close: 'Close',
    cs_delete: 'Delete',
    cs_deleted: 'Removed',
    cs_saved: 'Saved',
    filter_empty: 'Nothing here — adjust the filter above.',
    seen_label: 'Seen',
    cve_fd_inactive_hint: 'Final Decision is enabled through the secure invitation flow (Board Settings → Final Decision).',
    preview_as_client_inline: 'Preview as client',
    exit_client_preview: 'Exit preview',
    back_to_editing: 'Back to editing',
    client_preview_hint: 'Live preview — this is exactly what your client sees.',
    add_images: 'Add images',
    add_images_subtitle: 'Upload, library or external inspiration',
    drop_to_upload: 'Drop to upload',
    drag_drop_or_click: 'Drag & drop or click to upload',
    from_library: 'From library',
    add_via_link: 'Add via link',
    also_save_uploads: 'Also save uploads to library',
    reorder_images: 'Reorder images',
    manage_labels: 'Manage labels',
    no_images_yet: 'No images yet. Upload some or choose from your library.',
    add_external_image_urls: 'Add External Image URLs',
    // Documents / notes section chrome
    shared_communication_space: 'Shared communication space with your client',
    attach_project_materials: 'Attach project materials, contracts, inspirations — anything that helps the project.',
    upload_file: 'Upload file',
    // Settings sidebar inside BoardEditor
    client_email_label: 'Client email',
    used_for_client_notifications: 'Used for client notifications',
    send_test_to_me: 'Send test to me',
    client_details: 'Client Details',
    client_details_placeholder: 'Email, phone, address, notes...',
    auto_lock_label: 'Auto-lock before project date (days)',
    shared_decision_mode: 'Shared Decision Mode',
    shared_decision_desc: 'Allow two people to select preferences independently on this board.',
    shared_mode_enabled: 'Shared mode enabled',
    enable_shared_decisions: 'Enable shared decisions',
    person_1_name: 'Person 1 name',
    person_2_name: 'Person 2 name',
    client_uploads_enabled: 'Client uploads enabled',
    client_uploads_hidden: 'Client uploads hidden',
    documents_enabled: 'Documents enabled',
    documents_hidden: 'Documents hidden',
    client_notes_locked: 'Client Notes',
    client_uploads_locked: 'Client Uploads',
    documents_locked: 'Documents',
    internal_view_title: 'Internal view',
    internal_view_desc: 'Studio-side details, never shown to your client.',
    show_filenames_label: 'Show file names',
    show_filenames_hint: 'Useful for retouching, selection, and export workflows.',
    client_header_title: 'Client view header',
    client_header_desc: 'How the top of the page reads when your client opens the board.',
    show_board_title_label: 'Show board title',
    show_board_title_hint: 'Display the board name beneath the logo, above the welcome section.',
    board_subtitle_label: 'Subtitle (optional)',
    board_subtitle_placeholder: 'e.g. Concept Inspiration Board',
    board_subtitle_hint: 'A short line shown directly under the board title.',
    // Custom welcome (Pro / Signature)
    custom_welcome_title: 'Custom welcome',
    custom_welcome_desc: 'Override the welcome shown to your client — for this board only.',
    use_custom_welcome_label: 'Use custom welcome for this board',
    use_custom_welcome_hint: 'When off, this board uses your template welcome.',
    custom_welcome_title_label: 'Welcome title',
    custom_welcome_title_placeholder: 'e.g. Welcome, Anna & Daniel.',
    custom_welcome_description_label: 'Welcome description',
    custom_welcome_description_placeholder: 'e.g. This is the visual direction for your wedding.',
    custom_welcome_hint_label: 'Welcome hint',
    custom_welcome_hint_placeholder: 'e.g. Take your time. There are no wrong answers.',
    custom_welcome_fallback_hint: 'Leave any field empty to keep your template wording for that line.',
    // Board Cover Overlay (Studio / Signature)
    board_cover_panel_title: 'Board cover',
    board_cover_panel_desc: 'A cinematic full-screen entrance, shown before the client lands on the moodboard.',
    board_cover_enable_label: 'Enable Board Cover',
    board_cover_enable_hint: 'When off, your client lands directly on the board.',
    board_cover_title_label: 'Cover title',
    board_cover_title_placeholder: 'e.g. Maternity Experience',
    board_cover_subtitle_label: 'Cover subtitle',
    board_cover_subtitle_placeholder: 'e.g. Minimal concept · Spring 2026',
    board_cover_button_label: 'Button text',
    board_cover_button_placeholder: 'e.g. Explore Concept',
    board_cover_image_source_label: 'Cover image source',
    board_cover_source_first: 'First image from board',
    board_cover_source_custom: 'Custom cover image',
    board_cover_show_skip_label: 'Show small "Skip" link',
    board_cover_first_visit_only_label: 'Show cover only on first visit',
    enter_board: 'Enter Board',
    skip_cover: 'Skip',
    selected_image: 'Selected Image',
    section_label: 'Section Label',
    none_option: 'None',
    from_library_shared: 'From Library (shared across boards)',
    cover_image: 'Cover image',
    set_as_cover: 'Set as cover',
    cover_removed: 'Cover removed',
    cover_set: 'Set as cover',
    remove_from_board: 'Remove from Board',
    // Delete board modal — soft-delete: board moves to Recently Deleted for 30d
    delete_board_title: 'Move board to Recently Deleted',
    delete_board_warning: 'This board will be moved to Recently Deleted. It can be restored within 30 days by contacting support.',
    delete_permanently: 'Move to Recently Deleted',
    delete_board_confirmation: 'Board moved to Recently Deleted.\n\nIt can be restored within 30 days by contacting support.',
    // Extend modal
    reopen_board_title: 'Reopen Board',
    extend_board_title: 'Extend Board',
    extend_reopen_subtitle: 'The share link will remain the same. The client will regain access.',
    extend_subtitle: 'Extend the expiration date from today.',
    reopen_for: 'Reopen for',
    extend_by: 'Extend by',
    new_expiration: 'New expiration',
    same_share_link: 'Same share link',
    all_images_preserved: 'All images preserved',
    all_reactions_preserved: 'All reactions preserved',
    // Export PDF modal
    export_to_pdf_title: 'Export to PDF',
    export_preferences_subtitle: 'Choose your export preferences',
    export_content_label: 'Export Content',
    all_images_option: 'All images',
    export_entire_board: 'Export the entire board',
    client_selected_only: 'Client-selected only',
    client_selected_desc: 'Only ❤️ "I feel this" and 🤍 "Neutral" · Excludes ❌ "Not me"',
    include_unrated_images: 'Include unrated images',
    image_density_label: 'Image Density',
    density_1: '1 image per page',
    density_1_desc: 'Full focus · artwork / gallery-style · large margins',
    density_2: '2 images per page',
    density_2_desc: 'Editorial spread',
    density_4: '4 images per page',
    density_4_desc: 'Clean grid',
    density_6: '6 images per page',
    density_6_desc: 'Overview / reference mode',
    layout_style_label: 'Layout Style',
    layout_gallery: 'Gallery',
    layout_gallery_desc: 'Clean, minimal, artwork-focused',
    layout_editorial: 'Editorial',
    layout_editorial_desc: 'Elegant with labels and reactions',
    layout_reference: 'Reference',
    layout_reference_desc: 'Compact with full details',
    page_orientation_label: 'Page Orientation',
    orientation_portrait: 'Portrait',
    orientation_landscape: 'Landscape',
    include_in_export: 'Include in Export',
    include_client_notes: 'Client notes / comments under images',
    include_reactions_icons: 'Reaction icons under each image (❤️ / 🤍)',
    include_image_metadata: 'Image metadata (Pose / Light / Wardrobe)',
    include_document_confirmations: 'Document confirmations & timestamps',
    include_notes_thoughts: 'Notes & Thoughts',
    include_final_selections_label: 'Final Selections section',
    // UserSettings — high-level
    settings_title: 'Settings',
    editing_overrides_for: 'Editing overrides for',
    reset_all_to_default: 'Reset all to default',
    use_default: 'Use default',
    custom_label: 'Custom',
    default_label: 'Default',
    welcome_title_label: 'Welcome title',
    description_text_label: 'Description text',
    welcome_hint_label: 'Hint under description (italic)',
    custom_message_label: 'Custom message (optional)',
    instruction_section: 'Instruction Section',
    instruction_section_desc: 'Shown above the gallery in your client view. Edit per language — empty fields fall back to the template default.',
    instruction_text_label: 'Instruction text',
    reaction_hint_label: 'Reaction hint',
    save_branding: 'Save Branding',
    branding_saved: 'Branding saved',
    // UserSettings page sections
    back_to_workspace: '← Back to workspace',
    account_section: 'Account',
    brand_name_label: 'Brand name',
    brand_name_placeholder: 'Shown in client view, branding header, and exports',
    save_brand_name: 'Save brand name',
    saving_short: 'Saving…',
    email_label: 'Email',
    username_label: 'Username',
    status_label: 'Status',
    status_active_pill: 'Active',
    access_label: 'Access',
    days_remaining: 'days remaining',
    access_valid_until: 'Access valid until',
    unlimited_access: 'Unlimited access',
    request_extension: 'Request extension',
    usage_section: 'Usage',
    storage_label: 'Storage',
    boards_label: 'Boards',
    images_in_library: 'Images in library',
    language_section: 'Language',
    branding_section: 'Branding',
    logo_label: 'Logo',
    no_logo: 'No logo',
    upload_logo: 'Upload logo',
    remove_logo: 'Remove logo',
    logo_helper_primary: 'Best results are achieved with a transparent PNG logo.',
    logo_helper_secondary: 'For a clean premium presentation, avoid logos with white backgrounds.',
    upload_logo_cta: 'Upload your logo',
    upload_logo_hint: 'PNG, SVG, JPG · transparent background recommended',
    display_in_client_view: 'Display in client view',
    display_in_client_help: 'What to show in the board header',
    logo_and_name: 'Logo + brand name',
    logo_only: 'Logo only',
    brand_name_only: 'Brand name only',
    logo_size_label: 'Logo size',
    client_atmosphere: 'Client view atmosphere',
    client_atmosphere_help: 'Choose the mood your clients will experience when viewing shared boards.',
    atm_maestra: 'Maestra Default',
    atm_maestra_desc: 'Clean ivory warmth',
    atm_warm: 'Warm Sand',
    atm_warm_desc: 'Earthy, golden calm',
    atm_grey: 'Soft Grey',
    atm_grey_desc: 'Neutral elegance',
    atm_blue: 'Dusty Blue',
    atm_blue_desc: 'Cool, airy softness',
    atm_custom: 'Custom',
    atm_custom_desc: 'Your own atmosphere',
    client_view_texts: 'Client view texts',
    client_view_texts_desc: 'Customize how your workspace appears when clients open a shared board link. Edit each language separately — empty fields fall back to the template default.',
    only_fill_empty: 'Only fill empty fields',
    density_spacious: 'Spacious',
    density_spacious_sub: 'Approx. 1–2 images per page',
    density_spacious_desc: 'Elegant presentation with large spacing',
    density_balanced: 'Balanced',
    density_balanced_sub: 'Approx. 2–4 images per page',
    density_balanced_desc: 'Clean gallery-style layout',
    density_compact: 'Compact',
    density_compact_sub: 'Approx. 6–12 images per page',
    density_compact_desc: 'Adaptive overview grid for quick client review',
    image_density_label: 'PDF Density',
    custom_color_helper: "We'll derive a soft palette from this color.",
    branding_eyebrow: 'Design your client experience',
    branding_headline: 'Branding',
    card_brand_identity: 'Brand Identity',
    card_brand_identity_desc: 'Your logo and how your name appears at the top of every board.',
    card_client_experience: 'Client Experience',
    card_client_experience_desc: 'The mood your clients feel when opening a board.',
    card_client_view_texts: 'Client View Texts',
    card_instruction_section: 'Instruction Section',
    card_inspirations_section: 'Inspirations Section',
    inspirations_section_desc: 'Shown above the client\u2019s 10-image inspiration bay. Edit per language \u2014 empty fields fall back to the platform default.',
    card_notes_section: 'Notes Section',
    notes_section_desc: 'Heading and intro for the shared notes thread. Edit per language.',
    card_documents_section: 'Documents Section',
    documents_section_desc: 'Heading and intro above the project documents block. Edit per language.',
    inspirations_title_label: 'Inspirations title',
    inspirations_description_label: 'Inspirations description',
    notes_title_label: 'Notes title',
    notes_description_label: 'Notes description',
    documents_title_label: 'Documents title',
    documents_description_label: 'Documents description',
    card_footer: 'Footer',
    advanced_options: 'Advanced options',
    preview_open_btn: 'Live preview',
    preview_close_btn: 'Close',
    preview_lang_tag: 'Language',
    translate_from_en_to: 'Translate from EN →',
    translating_short: 'Translating…',
    translate_nothing_to_fill: 'Nothing to fill — every field already has a translation.',
    translate_fill_en_first: 'Fill the EN tab first — nothing to translate.',
    translate_no_results: 'Translator returned no results.',
    translate_failed: 'Translation failed.',
    translate_translated_n_to: 'Translated {n} field{s} to {lang}.',
    client_view_footer: 'Client view footer',
    client_view_footer_desc: 'Customize the footer on shared board pages. A subtle "created with maestra.space" attribution will always appear below.',
    footer_text_label: 'Footer text',
    footer_subtext_label: 'Footer subtext',
    optional: 'optional',
    link_label_label: 'Link label',
    link_url_label: 'Link URL',
    client_view_preview: 'Client view preview',
    support_access: 'Support access',
    support_access_desc: 'Allow admin support access',
    support_access_active_expires_in: 'Access active — expires in',
    support_access_disabled: 'Disabled',
    // Need help? — founder-led contact flow
    need_help_section: 'Need help?',
    need_help_body: 'Maestra is still built closely and intentionally. If you ever need help with your workspace or boards, you can reach out directly.',
    contact_maestra_btn: 'Contact Maestra',
    contact_modal_title: 'Write to Maestra.',
    contact_modal_subtitle: 'A direct line to the founder. Replies usually arrive within a day or two.',
    contact_field_message: 'Your message',
    contact_field_category: 'About',
    contact_field_board: 'Board (optional)',
    contact_board_none: 'None',
    contact_placeholder: 'Tell me what\'s on your mind…',
    contact_cat_workspace: 'Workspace help',
    contact_cat_board_recovery: 'Archived board recovery',
    contact_cat_technical: 'Technical issue',
    contact_cat_other: 'Other',
    contact_send: 'Send message',
    contact_sending: 'Sending…',
    contact_min_message: 'Please write at least a few words.',
    contact_send_failed: 'Could not send your message. Please try again.',
    contact_sent_title: 'Your message is on its way.',
    contact_sent_body: 'I read every message personally. You\'ll hear back soon, usually within a day or two.',
    reset_all_welcome_texts_tooltip: 'Reset all welcome texts back to the template default for every language',
    placeholder_welcome_title_eg: 'e.g. Welcome to your moodboard',
    placeholder_description_eg: 'e.g. Browse through the images and share your thoughts',
    placeholder_custom_message_eg: 'e.g. A personal note displayed above the gallery',
    placeholder_instruction_text_eg: 'e.g. Below you will find a curated selection prepared just for you.',
    placeholder_reaction_hint_eg: 'e.g. Tap to react · double-tap to mark a favourite',
    preview_welcome_title_default: 'Your moodboard is ready',
    preview_subtitle_default: 'Browse through the inspiration and share your feedback',
    preview_footer_placeholder: 'Platform footer will appear here. Set a custom footer above to personalize.',
    your_brand_name_placeholder: 'Your brand name',
    save_branding: 'Save branding',
    access_expired: 'Access expired',
    expires_today: 'Expires today',
    day_remaining: 'day remaining',
    access_ending_soon: 'Access ending soon',
    change: 'Change',
    remove: 'Remove',
    locale: 'en-GB',
    who_are_you: 'Who are you?',
    select_your_name: 'Select your name to start reviewing',
    drop_images_here: 'Drop images here...',
    uploading: 'Uploading...',

    // Client View
    welcome: 'Welcome.',
    client_intro: 'This is your private moodboard.\nA curated space to explore feeling, light and atmosphere — together.',
    client_hint: 'Please take your time. There are no right or wrong choices.',
    locked_title: 'This moodboard has been closed.',
    locked_subtitle: 'Thank you for all the choices and notes.\nI now have everything I need to move the project forward.',
    locked_helper: 'You can still view the board, but adding new reactions or changes has been turned off.',
    instruction_main: "Below you'll find a selection of images prepared for you.\nThey help me understand what feels right to you — intuitively, not intellectually.",
    instruction_react: 'Simply react to each image.',
    final_decision_prompt: 'Please select your final preferred options.',
    expired_title: 'This moodboard is no longer active.',
    archived_title: 'This board is no longer available.',
    expired_message: "Thank you for sharing your feeling.\nI've saved everything needed for your preparation.",

    // Reactions
    reaction_love: 'I feel this',
    reaction_neutral: 'Maybe',
    reaction_not_me: 'Not this',
    // Simple mode (Yes / Maybe / No)
    reaction_simple_yes: 'Yes',
    reaction_simple_maybe: 'Maybe',
    reaction_simple_no: 'No',
    // Decision mode (Agree / Not agree / Remove)
    reaction_decision_agree: 'Agree',
    reaction_decision_not_agree: 'Not agree',
    reaction_decision_remove: 'Remove',
    final_choice: '\u2605 Final choice',
    mark_final: '\u2606 Mark as final choice',
    add_note: '+ Add a note',
    comment_placeholder: 'You may add a short note if something stands out to you.',

    // Inspirations
    your_inspirations: 'Your inspirations',
    inspiration_intro: 'You may add up to 10 images that reflect your feeling.\nThis is not about perfection — only about resonance.',
    inspiration_hint: 'Please choose only what truly feels like you.',
    add_inspiration: 'Add inspiration',
    images_added: 'images added',
    max_inspirations: "You've reached the maximum of 10 inspirations.",
    max_inspirations_hint: 'This helps keep the direction clear and focused.',
    no_inspirations: 'No inspirations were added.',

    // Notes
    notes_title: 'Conversation',
    notes_subtitle: 'A shared space for reflections and ideas between you and the studio.',
    no_notes: 'No notes yet. Feel free to share your thoughts.',
    from_studio: 'From {brand}',
    from_named: 'From {name}',
    from_client_default: 'From Client',
    from_you: 'From you',
    note_placeholder: 'You may share a short thought if something feels important.',
    add_note_btn: 'Add Note',
    adding: 'Adding...',
    edit: 'Edit',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    notes_closed: 'Notes are now closed for this board.',
    delete_note_confirm: 'Delete this note?',
    yes_delete: 'Yes, delete',
    edited: '(edited)',

    // Documents
    documents_title: 'Project Documents',
    documents_subtitle: 'Materials prepared for your project',
    external_link: 'External link',
    open: 'Open',
    visit: 'Visit',
    i_have_read: 'I have read this',
    confirming: 'Confirming...',
    confirmed_on: 'Confirmed on',

    // Admin
    admin_panel: 'Admin Panel',
    users: 'Users',
    invite_user: 'Invite User',
    storage: 'Storage',
    limits: 'Limits',
    templates: 'Templates',
    active: 'Active',
    invited: 'Invited',
    deactivated: 'Deactivated',
    boards: 'Boards',
    documents: 'Documents',
    no_limit: 'No limit',
    activate: 'Activate',
    deactivate: 'Deactivate',
    back_to_dashboard: 'Back to Dashboard',
    platform_overview: 'Platform Overview',
    total_users: 'Total Users',
    total_boards: 'Total Boards',
    total_images: 'Total Images',
    total_documents: 'Total Documents',
    user_management: 'User Management',
    workspace_templates: 'Workspace Templates',
    create_template: 'Create Template',
    template_name: 'Template Name',
    default_labels: 'Default Labels',
    global_template: 'Global',
    copy_invite_link: 'Copy Invite Link',
    invite_link_copied: 'Invite link copied!',
    set_limits: 'Set Limits',
    max_storage_mb: 'Max Storage (MB)',
    max_boards_limit: 'Max Boards',
    unlimited: 'Unlimited',
    used: 'used',
    of: 'of',
    in_library: 'in library',
    across_boards: 'across boards',

    // ── Image Library ────────────────────────────────────────────────
    lib_title: 'Image Library',
    lib_back_to_moodboards: '\u2190 Back to Moodboards',
    lib_drop_active: 'Drop images here...',
    lib_drop_title: 'Drag & drop images to add to your library',
    lib_drop_subtitle: 'Images in the library can be reused across multiple moodboards',
    lib_uploading: 'Uploading...',
    lib_upload_tags_placeholder: 'Tags for next upload (comma-separated, e.g. portrait, outdoor)',
    lib_add_external_btn: '+ Add External Image URL',
    lib_add_external_title: 'Add External Image URL',
    lib_external_helper: "Paste a direct image URL (e.g., from Pinterest, Unsplash). Image won't be downloaded \u2014 only the link is saved.",
    lib_preview_label: 'Preview:',
    lib_adding: 'Adding...',
    lib_add_to_library: 'Add to Library',
    // — Refined two-step upload flow —
    lib_step_add_images: 'Add images',
    lib_step_add_tags: 'Add tags for this upload',
    lib_step_save: 'Save to library',
    lib_choose_files: 'Choose files',
    lib_or_separator: 'or',
    lib_add_from_link: 'Add from link',
    lib_pending_files_label: 'Selected',
    lib_pending_link_label: 'Link',
    lib_remove_pending: 'Remove',
    lib_clear_batch: 'Clear',
    lib_tags_for_batch_placeholder: 'Type a tag and press comma or Enter…',
    lib_tags_for_batch_help: 'These tags will apply to every image in this batch — files and link.',
    lib_recent_tags: 'Recent tags',
    lib_save_button_single: 'Add 1 image to Library',
    lib_save_button_many: 'Add {count} images to Library',
    lib_link_input_placeholder: 'https://i.pinimg.com/.../image.jpg',
    lib_filter_all: 'All',
    lib_filter_uploaded: 'Uploaded',
    lib_filter_external: 'External',
    lib_filter_used: 'Used',
    lib_filter_unused: 'Unused',
    lib_tags_label: 'Tags:',
    lib_collections_heading: 'Collections',
    lib_filters_label: 'Filters',
    lib_tags_heading: 'Filter by tags',
    lib_tags_search_placeholder: 'Search tags…',
    lib_clear_all: 'Clear all',
    lib_tags_all_hint: '(showing images with ALL selected tags)',
    lib_download_one_tag: 'Download "{tag}"',
    lib_download_n_tags: 'Download {count} tags',
    lib_exporting: 'Exporting...',
    lib_no_filtered_title: 'No {filter} images yet',
    lib_no_filtered_hint: 'Try a different filter, or upload new images and tag them so they appear here.',
    lib_empty_eyebrow: 'Image library',
    lib_empty_title: 'Your visual archive lives here.',
    lib_empty_body: 'Upload from your computer or paste a direct link. Images you save here can be reused across every project, without ever duplicating files.',
    lib_drag_to_reorder: 'Drag images to reorder',
    lib_selected_count: '{count} selected',
    lib_exit_select: 'Exit Select',
    lib_select_btn: 'Select',
    lib_reorder_btn: 'Reorder',
    lib_reorder_on: '\u2713 Reorder Mode ON',
    lib_show_details: 'Show Details',
    lib_details_title: 'Image Details',
    lib_close_details: 'Close details',
    lib_close_details_aria: 'Close image details',
    lib_external_ref_badge: 'External Reference',
    lib_uploaded_badge: 'Uploaded Image',
    lib_name_label: 'Name',
    lib_source_url_label: 'Source URL',
    lib_edit_url: 'Edit URL',
    lib_save_url: 'Save',
    lib_saving_url: 'Saving...',
    lib_url_load_error: 'Could not load image from URL',
    lib_url_ext_error: 'URL must end with .jpg, .png, .webp, or .gif',
    lib_usage_label: 'Usage',
    lib_used_in_n_moodboards: 'Used in {count} moodboard',
    lib_used_in_n_moodboards_plural: 'Used in {count} moodboards',
    lib_boards_using: 'Boards Using This Image',
    lib_tags_section_label: 'Tags',
    lib_no_tags: 'No tags',
    lib_edit_tags: 'Edit tags',
    lib_tags_comma_placeholder: 'Comma-separated tags',
    lib_delete_from_library: 'Delete from Library',
    lib_will_remove_from_n_boards: 'Will also remove from {count} board',
    lib_will_remove_from_n_boards_plural: 'Will also remove from {count} boards',
    lib_card_used_in_n: 'Used in {count} board',
    lib_card_used_in_n_plural: 'Used in {count} boards',
    lib_card_broken_link: 'Broken Link',
    lib_card_external: 'External',
    lib_card_demo: 'Sample',
    lib_card_image_unavailable: 'Image unavailable',
    lib_card_remove: 'Remove',
    lib_add_to_board_btn: '+ Board',
    // Library Collections (Phase 1/2)
    lib_collection_all: 'All',
    lib_collection_uncategorized: 'Uncategorized',
    lib_collection_new: 'New collection',
    lib_collection_new_placeholder: 'Collection name',
    lib_collection_rename: 'Rename',
    lib_collection_delete: 'Delete',
    lib_collection_delete_confirm: 'Delete this collection? Images stay in the library.',
    lib_add_to_board_short: 'Board',
    lib_pin_used_singular: 'In 1 board',
    lib_pin_used_plural: 'In {count} boards',
    // Library Preview Modal (Phase 3)
    lib_preview_title_label: 'Reference',
    lib_preview_untitled: 'Untitled reference',
    lib_preview_source_label: 'Source',
    lib_preview_source_uploaded: 'Uploaded to library',
    lib_preview_source_external: 'External URL',
    lib_preview_collections_label: 'Collections',
    lib_preview_no_collections: 'Not in any collection.',
    lib_preview_tags_label: 'Tags',
    lib_preview_no_tags: 'No tags yet.',
    lib_preview_usage_label: 'Usage',
    lib_preview_unused: 'Not yet used in any board.',
    lib_preview_edit: 'Edit',
    lib_preview_done: 'Done',
    lib_preview_action_add_to_board: 'Add to board',
    lib_preview_action_edit: 'Edit',
    lib_preview_action_download: 'Download',
    lib_preview_action_delete: 'Delete',
    // Bulk Action Bar (Phase 4)
    lib_bulk_selected_singular: 'selected',
    lib_bulk_selected_plural: 'selected',
    lib_bulk_select_all: 'Select all',
    lib_bulk_add_to_collection: 'Add to collection',
    lib_bulk_manage_collections: 'Manage collections',
    lib_bulk_move_here: 'Move',
    lib_bulk_move_confirm: 'Move {count} image(s) to "{name}"? They will be removed from all other collections.',
    toast_bulk_moved_to_collection: 'Moved {count} to {name}.',
    toast_bulk_removed_from_collection: 'Removed {count} from {name}.',
    lib_bulk_add_to_board: 'Add to board',
    lib_bulk_new_board: 'New board',
    // Duplicates finder
    lib_find_duplicates: 'Find duplicates',
    lib_duplicates_eyebrow: 'Library housekeeping',
    lib_duplicates_title: 'Find duplicates',
    lib_duplicates_scanning: 'Scanning your library...',
    lib_duplicates_none: 'Your library is clean — no duplicates found.',
    lib_duplicates_found: 'Found {dup} duplicates across {groups} groups.',
    lib_duplicates_description: 'We keep the oldest image in each group. Tags and collections from removed copies are merged onto the survivor. Client boards using duplicates are relinked to the survivor — no imagery lost.',
    lib_duplicates_same_file: 'same file',
    lib_duplicates_same_url: 'same link',
    lib_duplicates_same_filename: 'same filename',
    lib_duplicates_more_groups: '+ {n} more groups...',
    lib_duplicates_confirm: 'Remove duplicates',
    lib_duplicates_removing: 'Removing...',
    lib_duplicates_ok: 'OK',
    toast_duplicates_removed: 'Removed {count} duplicates.',
    toast_duplicates_failed: 'Could not remove duplicates.',
    lib_bulk_no_collections: 'No collections yet.',
    lib_bulk_add_tags: 'Add tags',
    lib_bulk_remove_tags: 'Remove tags',
    lib_bulk_tag_placeholder: 'tag1, tag2, ...',
    lib_bulk_tag_hint: 'Comma-separated',
    lib_bulk_apply: 'Apply',
    lib_bulk_delete: 'Delete',
    lib_bulk_cancel: 'Cancel',
    toast_bulk_added_to_collection: 'Added {count} to {name}.',
    toast_bulk_tags_added: 'Tagged {count} images.',
    toast_bulk_tags_removed: 'Removed tags from {count} images.',
    toast_bulk_action_failed: 'Bulk update failed.',
    lib_add_tag_title: 'Add tag',
    lib_add_tag_placeholder: 'Add tag...',
    lib_board_selector_title: 'Add to Board',
    lib_board_selector_single: 'Choose a board for this image',
    lib_board_selector_bulk: 'Add {count} image to a board',
    lib_board_selector_bulk_plural: 'Add {count} images to a board',
    lib_no_active_boards: 'No active boards found.',
    lib_create_new_board: 'Create New Board',
    lib_new_board_btn: '+ New Board',
    lib_no_client_label: 'No client',
    lib_images_label: 'images',
    lib_create_board_title: 'Create New Board',
    lib_create_board_with_selection: 'A new board will be created with {count} selected image.',
    lib_create_board_with_selection_plural: 'A new board will be created with {count} selected images.',
    lib_create_board_with_one: 'A new board will be created with 1 image.',
    lib_create_board_empty: 'Create an empty board.',
    lib_board_name_label: 'Board Name *',
    lib_board_name_placeholder: 'e.g. Spring Collection \u2014 Anna',
    lib_client_name_label: 'Client Name',
    lib_client_name_placeholder: 'e.g. Anna Kowalska',
    lib_creating: 'Creating...',
    lib_create_board: 'Create Board',
    lib_board_created_title: 'Board Created',
    lib_board_created_text: '{name} was created with {count} image.',
    lib_board_created_text_plural: '{name} was created with {count} images.',
    lib_stay_in_library: 'Stay in Library',
    lib_open_board: 'Open Board',
    lib_delete_title: 'Delete from Library?',
    lib_delete_used_warning: 'This image is used in {count} moodboard. Deleting it will remove it from all boards.',
    lib_delete_used_warning_plural: 'This image is used in {count} moodboards. Deleting it will remove it from all boards.',
    lib_delete_unused_text: 'This will permanently remove the image from your library.',
    lib_bulk_delete_title: 'Delete {count} selected image from the library?',
    lib_bulk_delete_title_plural: 'Delete {count} selected images from the library?',
    lib_bulk_delete_all_used: 'All {count} selected images are currently used in boards. Nothing will be deleted.',
    lib_bulk_delete_some: 'This will permanently remove {count} unused image from your library.',
    lib_bulk_delete_some_plural: 'This will permanently remove {count} unused images from your library.',
    lib_bulk_delete_skipped: '{count} selected image is used in boards and will be skipped.',
    lib_bulk_delete_skipped_plural: '{count} selected images are used in boards and will be skipped.',
    lib_deleting: 'Deleting...',
    lib_delete_n: 'Delete {count}',
    lib_dup_title: 'Duplicate Found',
    lib_dup_text: 'This image already exists in your library.',
    lib_dup_used_in_n: 'Used in {count} board',
    lib_dup_used_in_n_plural: 'Used in {count} boards',
    lib_dup_add_tags_label: 'Add tags to existing image (optional)',
    lib_dup_tag_placeholder: 'e.g. wedding, outdoor',
    lib_dup_upload_anyway: 'Upload Anyway',
    lib_dup_use_existing: 'Use Existing',

    // ── CreateBoardModal ─────────────────────────────────────────────
    cbm_title: 'Create New Moodboard',
    cbm_board_name: 'Board Name',
    cbm_board_name_placeholder: 'e.g., Spring Collection 2026',
    cbm_client_name: 'Client Name',
    cbm_client_name_placeholder: 'e.g., Sarah Johnson',
    cbm_project_date: 'Project Date (Optional)',
    cbm_autolock_hint: 'Board will auto-lock before this date',
    cbm_link_expires: 'Link Expires After',
    cbm_lock_before: 'Lock Before Project Date',
    cbm_days: '{n} days',
    cbm_editable_later: 'You can change these settings later in the board settings.',
    cbm_creating: 'Creating...',
    cbm_create_board: 'Create Board',
    // ── Board Type selection ─────────────────────────────────────────
    cbm_board_type_label: 'Board type',
    cbm_board_type_client: 'Client Board',
    cbm_board_type_client_desc: 'Collaborate with clients, collect feedback, and finalize decisions.',
    cbm_board_type_inspiration: 'Inspiration Board',
    cbm_board_type_inspiration_desc: 'Present a concept, mood, style, or visual direction.',
    bs_board_type_panel_title: 'Board Type',
    bs_board_type_inspiration_summary: 'A curated, presentation-only board — no collaboration features.',
    bs_board_type_client_summary: 'Full collaborative workspace with feedback, decisions, and documents.',
    bs_convert_to_client_btn: 'Convert to Client Board',
    bs_convert_confirm: 'Convert this Inspiration Board into a Client Board? This will enable collaboration, comments, uploads, documents, and approval workflows.',
    bs_converting: 'Converting...',
    bs_convert_success: 'Board converted to a Client Board.',
    bs_inspiration_features_hidden: 'These features are part of the Client Board experience. Convert this board to enable them.',
    concept_panel_title: 'Concept',
    concept_panel_desc: 'A short description shown at the top of the board — the mood, story, or direction this concept explores.',
    concept_description_label: 'Concept description',
    concept_description_placeholder: 'e.g. A study of soft afternoon light and natural materials for editorial portraits.',
    concept_description_hint: 'Displayed at the top of the board, under the title.',
    dash_section_client_title: 'CLIENT BOARDS',
    dash_section_client_subtitle: 'Active projects and client collaboration — feedback, decisions, and workflows.',
    dash_section_inspiration_title: 'INSPIRATION BOARDS',
    dash_section_inspiration_subtitle: 'Concepts, portfolio examples and visual direction.',
    dash_empty_client: 'Create your first Client Board.',
    dash_empty_inspiration: 'Create your first Inspiration Board.',

    // ── LibraryModal (Choose from Library) ───────────────────────────
    lm_title: 'Choose from Library',
    lm_subtitle: 'Select multiple images to add them at once',
    lm_no_match: 'No images match your filters',
    lm_empty: 'Your library is empty',
    lm_clear_filters: 'Clear filters',
    lm_select_status_count: '{count}{plus} images \u00b7 Tap to select',
    lm_select_status_one: '{count} image selected',
    lm_select_status_many: '{count} images selected',
    lm_select_visible: 'Select visible',
    lm_clear: 'Clear',
    lm_load_more: 'Load more images',
    lm_section_label_for_selected: 'Section Label for selected images',
    lm_section_none: 'None (no label)',
    lm_section_helper: 'All selected images will be added with this label',
    lm_select_images_btn: 'Select images',
    lm_add_one_to_board: 'Add {count} image to Board',
    lm_add_many_to_board: 'Add {count} images to Board',
    lm_density_label: 'Density',
    lm_density_comfortable: 'Comfortable',
    lm_density_compact: 'Compact',
    lm_density_tiny: 'Tiny',
    lm_filters_btn: 'Filters',
    lm_close_aria: 'Close',
    lm_ext_badge: 'Ext',
    lm_preview_aria: 'Preview at full size',
    lm_preview_close: 'Close preview',
    lm_preview_select: 'Select this image',
    lm_preview_deselect: 'Deselect',
    lm_preview_no_tags: 'No tags',
    notes_jump_to_input: 'Add a new note',
    nav_inspirations: 'Inspirations',
    nav_gallery: 'Gallery',
    nav_final_decisions: 'Final picks',
    nav_notes: 'Notes',
    nav_documents: 'Documents',
    lib_floating_n_selected: '{count} image selected',
    lib_floating_n_selected_plural: '{count} images selected',
    lib_select_all: 'Select All',
    lib_deselect_all: 'Deselect All',
    lib_add_to_board: 'Add to Board',
    lib_new_board_short: 'New Board',
    lib_delete_selected: 'Delete Selected',

    // ── Library toasts ───────────────────────────────────────────────
    toast_image_reused: 'Image reused successfully',
    toast_more_images_added: '{count} more image(s) added to library',
    toast_some_uploads_failed: 'Some uploads failed',
    toast_images_added: '{count} image(s) added to library',
    toast_upload_failed: 'Upload failed',
    toast_added_to_board_one: '{count} image added to "{board}"',
    toast_added_to_board_many: '{count} images added to "{board}"',
    toast_add_to_board_failed: 'Failed to add images to board',
    toast_board_limit_reached: "You've reached your current board limit.",
    toast_create_board_failed: 'Failed to create board',
    toast_reorder_failed: 'Failed to reorder images',
    toast_image_deleted_with_boards: 'Image deleted and removed from {count} board(s)',
    toast_image_deleted: 'Image deleted',
    toast_delete_failed: 'Failed to delete image',
    toast_bulk_deleted_with_skipped: '{count} image(s) deleted. {skipped} in use \u2014 skipped.',
    toast_bulk_all_used: 'Some selected images are used in boards and were not deleted.',
    toast_bulk_deleted: '{count} image(s) deleted from library',
    toast_bulk_no_deleted: 'No images deleted',
    toast_bulk_delete_failed: 'Bulk delete failed',
    toast_tags_updated: 'Tags updated',
    toast_tags_update_failed: 'Failed to update tags',
    toast_url_updated: 'Image URL updated',
    toast_url_update_failed: 'Failed to update URL',
    toast_library_export: 'Library export downloaded',
    toast_export_failed: 'Export failed',
    toast_external_added: 'External image added to library',
    toast_external_add_failed: 'Failed to add external image',

    // ── BatchUploadStatus ────────────────────────────────────────────
    batch_uploading: 'Uploading',
    batch_x_of_y: '{done} of {total}',
    batch_n_failed: '{count} failed',
    batch_n_remaining: '{count} remaining\u2026',
    batch_finishing: 'Finishing up\u2026',
    batch_upload_complete: 'Upload complete',
    batch_upload_finished: 'Upload finished',
    batch_dismiss_aria: 'Dismiss',
    batch_n_uploaded_one: '{count} image uploaded.',
    batch_n_uploaded_many: '{count} images uploaded.',
    batch_no_uploaded: 'No images uploaded.',
    batch_n_failed_text: '{count} failed.',
    batch_generic_error: 'A few files couldn\u2019t be uploaded. You can review and retry the ones you\u2019d like to keep.',
    batch_show_details: 'Show details \u25be',
    batch_hide_details: 'Hide details \u25b4',
    batch_more: '+ {count} more',
    batch_retry_failed: 'Retry failed',
    batch_close: 'Close',
    batch_dismiss: 'Dismiss',
    batch_failed_fallback: 'failed',
    batch_upload_failed_fallback: 'Upload failed',
  },

  pl: {
    studio_name: 'Maestra',
    moodboards: 'Moodboardy',
    image_library: 'Biblioteka',
    new_board: '+ Nowa tablica',
    sign_out: 'Wyloguj',
    no_boards_title: 'Brak moodboard\u00f3w',
    no_boards_text: 'Stw\u00f3rz sw\u00f3j pierwszy moodboard, aby rozpocz\u0105\u0107 kuracj\u0119 wizualnych do\u015bwiadcze\u0144 dla klient\u00f3w.',
    create_first_board: 'Stw\u00f3rz pierwsz\u0105 tablic\u0119',
    duplicate: 'Duplikuj',
    delete: 'Usu\u0144',
    images: 'zdj\u0119\u0107',
    expires: 'Wygasa',
    settings: 'Ustawienia',
    export_pdf: 'Eksport PDF',
    backup_zip: 'Kopia ZIP',
    exports_panel_subtitle: 'Gotowy moodboard, gotowy do wys\u0142ania.',
    export_pdf_subtitle: 'Dla klienta.',
    backup_zip_subtitle: 'Do Twojego archiwum.',
    pdf_quota_remaining: '{remaining} z {limit} eksport\u00f3w PDF pozosta\u0142o',
    zip_quota_remaining: '{remaining} z {limit} kopii pozosta\u0142o',
    lock_board: 'Zablokuj tablic\u0119',
    unlock_board: 'Odblokuj tablic\u0119',
    board_settings: 'Ustawienia tablicy',
    boards_settings_title: 'Ustawienia tablic',
    boards_settings_subtitle: 'Jak Twoi klienci doświadczają każdej tablicy — atmosfera, teksty i stopka.',
    boards_settings_back: 'Tablice',
    boards_settings_locked: 'Personalizacja tablic nie jest dostępna w Twoim obecnym planie.',
    workspace_board_settings_hint: 'Kolory, teksty widoku klienta i stopka znajdują się w Ustawieniach tablic, w module Tablice.',
    open_board_settings: 'Otwórz Ustawienia tablic',
    workspace_logo_managed_hint: 'Samo logo zarządzane jest w ustawieniach Workspace.',
    open_workspace_settings: 'Ustawienia Workspace',
    cr_title: 'Creator Space',
    cr_eyebrow: 'Twoja pami\u0119\u0107 zewn\u0119trzna',
    cr_sub: 'Najpierw zapisz. Porz\u0105dkuj p\u00f3\u017aniej.',
    cr_back: 'Workspace',
    cr_capture_placeholder: 'Co masz w g\u0142owie? Po prostu zapisz\u2026',
    cr_capture_btn: 'Zapisz',
    cr_captured: 'Zapisano do Brain Dump',
    cr_today: 'Dzisiaj',
    cr_this_week: 'W tym tygodniu',
    cr_waiting: 'Czekam na',
    cr_areas: 'Obszary',
    cr_today_empty: 'Dzi\u015b nic nie wymaga Twojej uwagi.',
    cr_week_empty: 'Spokojny tydzie\u0144 przed Tob\u0105.',
    cr_waiting_empty: 'Nic nie czeka po stronie innych.',
    cr_area_empty: 'Jeszcze nic tu nie ma.',
    cr_search_placeholder: 'Szukaj we wszystkim, tak\u017ce w historii\u2026',
    cr_no_results: 'Nic nie znaleziono.',
    cr_results_for: 'Wyniki dla',
    cr_evolution: 'Ewolucja',
    cr_created: 'Utworzono',
    cr_last_edited: 'Ostatnia zmiana',
    cr_add_note: 'Kontynuuj my\u015bl\u2026',
    cr_add_decision: 'Zapisz jako decyzj\u0119',
    cr_note_placeholder: 'Dopisz my\u015bl \u2014 wcze\u015bniejsze nigdy nie znikaj\u0105\u2026',
    cr_type: 'Typ',
    cr_area: 'Obszar',
    cr_due: 'Termin',
    cr_mark_done: 'Zrobione',
    cr_reopen: 'Otw\u00f3rz ponownie',
    cr_delete: 'Usu\u0144',
    cr_delete_confirm: 'Usun\u0105\u0107 t\u0119 rzecz wraz z ca\u0142\u0105 histori\u0105?',
    cr_no_type: 'My\u015bl',
    cr_type_task: 'Zadanie',
    cr_type_idea: 'Pomys\u0142',
    cr_type_project: 'Projekt',
    cr_type_waiting: 'Czekam',
    cr_type_decision: 'Decyzja',
    cr_type_reference: 'Do zachowania',
    cr_evo_created: 'Pierwszy pomys\u0142',
    cr_evo_note: 'Dopisano',
    cr_evo_decision: 'Decyzja',
    cr_evo_moved: 'Przeniesiono',
    cr_evo_status: 'Status',
    cr_evo_edit: 'Edycja',
    cr_open: 'Otwarte',
    cr_done: 'Zrobione',
    cr_all: 'Wszystko',
    cr_save: 'Zapisz',
    cr_decided: 'Ustalone',
    cr_todo: 'Do zrobienia',
    cr_ideas_parked: 'Pomys\u0142y od\u0142o\u017cone',
    cr_other_items: 'Pozosta\u0142e',
    cr_project_label: 'Projekt',
    cr_no_project: 'Brak',
    cr_part_of: 'Cz\u0119\u015b\u0107 projektu',
    cr_add_decided_ph: 'Dodaj ustalenie\u2026',
    cr_add_todo_ph: 'Dodaj zadanie\u2026',
    cr_add_idea_ph: 'Od\u0142\u00f3\u017c pomys\u0142\u2026',
    cr_evo_project: 'Przypisano do projektu',
    cr_evo_project_removed: 'Odpi\u0119to od projektu',
    cr_evo_completed: 'Uko\u0144czono',
    cr_evo_reopened: 'Otwarto ponownie',
    cr_evo_direction: 'Kierunek',
    cr_direction: 'Aktualny kierunek',
    cr_direction_ph: 'Dok\u0105d to zmierza?\u2026',
    cr_direction_empty: 'Jeszcze bez kierunku \u2014 zapisz, dok\u0105d to zmierza.',
    cr_related: 'Powi\u0105zane wpisy',
    cr_recent_decisions: 'Ostatnie decyzje',
    cr_recent_activity: 'Ostatnia aktywno\u015b\u0107',
    cr_your_timeline: 'Twoja o\u015b czasu',
    cr_no_decisions: 'Jeszcze brak decyzji \u2014 b\u0119d\u0105 si\u0119 tu zbiera\u0107.',
    cr_no_timeline: 'Spokojny miesi\u0105c \u2014 nic tu nie zapisano.',
    cr_whats_on_mind: 'Co masz w g\u0142owie?',
    cr_capture_hint: 'Trafi do Brain Dump. Uporz\u0105dkujesz p\u00f3\u017aniej.',
    cr_continue_where: 'Kontynuuj, gdzie sko\u0144czy\u0142a\u015b',
    cr_continue: 'Kontynuuj',
    cr_open_entries: 'otwarte wpisy',
    cr_active_projects: 'projekty',
    cr_areas_intro: 'Dedykowane przestrzenie dla ka\u017cdej cz\u0119\u015bci Twojego \u017cycia i pracy.',
    cr_nav_overview: 'Przegl\u0105d',
    cr_nav_projects: 'Projekty',
    cr_nav_todo: 'Do zrobienia',
    cr_nav_ideas: 'Notatki i pomys\u0142y',
    cr_current: 'Aktualna',
    cr_superseded: 'Zast\u0105piona',
    cr_superseded_plural: 'zast\u0105pione',
    cr_mark_superseded: 'Oznacz jako zast\u0105pion\u0105',
    cr_make_current: 'Przywr\u00f3\u0107 jako aktualn\u0105',
    cr_area_desc_brain_dump: 'Twoja zewn\u0119trzna skrzynka. Zapisuj ka\u017cd\u0105 my\u015bl od razu \u2014 uporz\u0105dkujesz p\u00f3\u017aniej. Nic nie musi by\u0107 jeszcze skategoryzowane.',
    cr_area_desc_ecru: 'Pomys\u0142y, marketing, oferty, fotografia, Brand Aesthetic, Celebration Styling i wszystko, co dotyczy Twojego kreatywnego biznesu.',
    cr_area_desc_home: 'Domowe zadania, zakupy, naprawy, organizacja, dokumenty i wszystko, co dotyczy domu.',
    cr_area_desc_nataniel: 'Szko\u0142a, terminy, zaj\u0119cia, zakupy, dokumenty, pomys\u0142y i wszystko, co dotyczy Twojego dziecka.',
    cr_area_desc_money: 'Rachunki, subskrypcje, p\u0142atno\u015bci, miesi\u0119czne wydatki, faktury, finanse i rzeczy do sprawdzenia lub anulowania.',
    cr_area_desc_life_admin: 'Sprawy urz\u0119dowe, ubezpieczenia, umowy, pisma, administracja i wszystko, co utrzymuje \u017cycie w biegu.',
    cr_area_desc_idea_vault: 'Pomys\u0142y warte zachowania na przysz\u0142o\u015b\u0107. Bez presji, by dzia\u0142a\u0107 dzi\u015b.',
    cr_area_desc_wishlist: 'Rzeczy do kupienia \u2014 do domu, studia, biznesu lub dla siebie. Zapisuj linki, priorytety i notatki.',
    cr_area_desc_this_month: 'Tymczasowe priorytety i zadania wa\u017cne tylko w tym miesi\u0105cu. Przegl\u0105daj regularnie i czy\u015b\u0107 po zako\u0144czeniu.',
    cr_area_desc_someday: 'Pomys\u0142y, marzenia i plany na przysz\u0142o\u015b\u0107. Nie priorytet dzi\u015b, ale warte pami\u0119tania.',
    board_name: 'Nazwa tablicy',
    client_name: 'Imi\u0119 klienta',
    session_date: 'Data projektu',
    link_expiration: 'Wa\u017cno\u015b\u0107 linku (dni)',
    auto_lock: 'Auto-blokada przed dat\u0105 projektu (dni)',
    final_decision_mode: 'Tryb finalnych wybor\u00f3w',
    final_decision_desc: 'Chro\u0144 finalne wybory za pomoc\u0105 prywatnego zaproszenia e-mail wys\u0142anego do klienta.',
    final_enabled: 'W\u0142\u0105czony — klient mo\u017ce wybiera\u0107',
    final_enable: 'W\u0142\u0105cz dla klienta',
    fd_status_active: 'Tryb finalny aktywny',
    fd_status_inactive: 'Tryb finalny nieaktywny',
    fd_enable_cta: 'W\u0142\u0105cz prywatne zatwierdzanie',
    fd_disable_cta: 'Wy\u0142\u0105cz tryb finalny',
    fd_resend: 'Wy\u015blij ponownie zaproszenie',
    fd_revoke: 'Cofnij dost\u0119p',
    fd_modal_title: 'W\u0142\u0105cz prywatne zatwierdzanie finaln\u0105 wersj\u0105',
    fd_modal_body: 'Finalne wybory b\u0119d\u0105 wymaga\u0142y prywatnego dost\u0119pu klienta.\n\nKlient otrzyma osobiste zaproszenie e-mail.\nWszystkie finalne decyzje b\u0119d\u0105 powi\u0105zane z jego to\u017csamo\u015bci\u0105.',
    fd_modal_email_label: 'E-mail klienta',
    fd_modal_send: 'Wy\u015blij zaproszenie',
    fd_modal_cancel: 'Anuluj',
    fd_invited_label: 'Zaproszony/a',
    fd_client_label: 'Klient',
    fd_resecure_banner_title: 'Zabezpiecz t\u0119 tablic\u0119 ponownie',
    fd_resecure_banner_body: 'Tryb finalny by\u0142 wcze\u015bniej w\u0142\u0105czony bez prywatnego zaproszenia. Wy\u015blij klientowi prywatny e-mail, aby kontynuowa\u0107.',
    fd_resecure_banner_cta: 'Wy\u015blij zaproszenie',
    fd_audit_title: 'Aktywno\u015b\u0107 zatwierdze\u0144',
    fd_audit_show: 'Poka\u017c aktywno\u015b\u0107',
    fd_audit_hide: 'Ukryj aktywno\u015b\u0107',
    fd_audit_empty: 'Brak aktywno\u015bci zatwierdze\u0144.',
    fd_audit_invited: 'Wys\u0142ano zaproszenie',
    fd_audit_resent: 'Ponownie wys\u0142ano zaproszenie',
    fd_audit_revoked: 'Cofni\u0119to dost\u0119p',
    fd_audit_opened: 'Otwarto przestrze\u0144 zatwierdze\u0144',
    fd_audit_marked_final: 'Oznaczono jako finalne',
    fd_audit_unmarked_final: 'Usuni\u0119to z finalnych',
    fd_audit_confirmed: 'Potwierdzono finalny kierunek',
    fd_audit_mode_disabled: 'Wy\u0142\u0105czono tryb finalny',
    fd_invalid_email: 'Podaj prawid\u0142owy adres e-mail.',
    fd_share_notice: 'Finalne wybory s\u0105 dost\u0119pne tylko dla zaproszonego klienta.',
    final_decision_section_title: 'Finalne wybory',
    fd_open_only_via_email: 'Ta przestrze\u0144 jest prywatna. Otw\u00f3rz j\u0105 z otrzymanego e-maila zaproszenia.',
    fd_approval_eyebrow: 'Prywatna przestrze\u0144 zatwierdze\u0144',
    fd_approval_signed_in_as: 'Zalogowany/a jako',
    fd_approval_confirm_cta: 'Potwierd\u017a finalny kierunek',
    fd_approval_confirmed_at: 'Kierunek potwierdzony',
    fd_approval_link_invalid: 'Ten link nie jest ju\u017c aktywny. Skontaktuj si\u0119 ze studiem, aby otrzyma\u0107 nowe zaproszenie.',
    fd_approval_intro: 'Mo\u017cesz oznaczy\u0107 finalne preferencje i potwierdzi\u0107 kierunek, gdy b\u0119dziesz gotowy/a.',
    fd_approval_change_hint: 'Mo\u017cesz zmienia\u0107 swoje wybory w dowolnej chwili. Kliknij ponownie zaznaczenie, aby je usun\u0105\u0107, lub potwierd\u017a ponownie, aby zaktualizowa\u0107 czas.',
    fd_approval_reconfirm_cta: 'Zaktualizuj finalny kierunek',
    fd_mark_final: 'Oznacz jako finalne',
    fd_unmark_final: 'Usu\u0144 z finalnych',
    client_language: 'J\u0119zyk klienta',
    client_language_desc: 'J\u0119zyk wy\u015bwietlany klientowi przegl\u0105daj\u0105cemu t\u0119 tablic\u0119.',
    client_communication: 'Komunikacja z klientem',
    client_communication_desc: 'Zezw\u00f3l na notatki i wsp\u00f3ln\u0105 przestrze\u0144 komunikacji',
    notes_enabled: 'Notatki w\u0142\u0105czone',
    notes_hidden: 'Notatki ukryte',
    exports: 'Eksporty',
    actions: 'Akcje',
    archive_board: 'Archiwizuj tablic\u0119',
    restore_board: 'Przywr\u00f3\u0107 tablic\u0119',
    delete_board: 'Usu\u0144 tablic\u0119',
    workspace_language: 'J\u0119zyk workspace',
    days: 'dni',
    settings_editable_later: 'Te ustawienia mo\u017cesz zmieni\u0107 p\u00f3\u017aniej w ustawieniach tablicy.',
    preview_as_client: 'Podgl\u0105d jak klient',

    // BoardEditor chrome
    back: '← Wr\u00f3\u0107',
    exporting: 'Eksportowanie...',
    generating: 'Generowanie...',
    export_stage_preparing: 'Przygotowywanie zdj\u0119\u0107',
    export_stage_building: 'Tworzenie pliku PDF',
    export_stage_finalizing: 'Finalizowanie pliku',
    export_stage_download: 'Rozpoczynanie pobierania',
    export_long_wait_hint: 'Wi\u0119ksze tablice mog\u0105 zaj\u0105\u0107 troch\u0119 wi\u0119cej czasu. Prosz\u0119, nie zamykaj okna.',
    export_failed_calm: 'Eksport nie m\u00f3g\u0142 zosta\u0107 uko\u0144czony. Spr\u00f3buj ponownie za chwil\u0119.',
    client_link: 'Link dla klienta',
    status_open: 'Otwarty',
    status_active: 'Aktywny',
    status_expired: 'Wygas\u0142',
    status_locked: 'Zablokowany',
    available_until: 'Dost\u0119pny do',
    closed_on: 'Zamkni\u0119ty',
    extend: 'Przed\u0142u\u017c',
    reopen_board: 'Otw\u00f3rz ponownie',
    show_link: 'Poka\u017c link',
    hide_link: 'Ukryj link',
    copy_link: 'Kopiuj link',
    copied: 'Skopiowano',
    notify_client: 'Powiadom klienta',
    add_client_email_to_notify: 'Dodaj email klienta, by powiadamia\u0107',
    note_to_client_title: 'Notatka dla klienta',
    note_to_client_subtitle: 'Opcjonalnie. Osobista wiadomo\u015b\u0107 wy\u015bwietlana nad galeri\u0105.',
    note_to_client_placeholder: 'Osobista notatka do klienta…',
    editing_ellipsis: 'Edytowanie…',
    saving_ellipsis: 'Zapisywanie…',
    saved: 'Zapisano',
    shared_client_space: 'Wsp\u00f3lna przestrze\u0144 z klientem',
    shared_client_space_subtitle: 'Tak klient widzi tablic\u0119 i wsp\u00f3lny kierunek projektu.',
    customize_client_view: 'Dostosuj widok klienta',
    cv_edit_mode_banner: 'Edytujesz widok klienta \u2014 kliknij dowolny tekst na stronie',
    cv_edit_done: 'Gotowe',
    cv_edit_continue_below: 'Przejd\u017a do tablicy \u2193',
    save_failed: 'Nie uda\u0142o si\u0119 zapisa\u0107',
    inline_advanced_options: 'Zaawansowane \u25be',
    client_view_editor_eyebrow: 'EDYTOR WIDOKU KLIENTA',
    client_view_editor_title: 'Co widzi Tw\u00f3j klient',
    client_view_editor_subtitle: 'Ukszta\u0142tuj dok\u0142adne wra\u017cenie \u2014 zmiany zapisuj\u0105 si\u0119 natychmiast.',
    client_view_editor_sections_soon: 'Ten panel zawiera widoczno\u015b\u0107, kolejno\u015b\u0107 i opcje zaawansowane. Wszystkie teksty edytujesz bezpo\u015brednio na stronie.',
    cve_sections_eyebrow: 'SEKCJE',
    cve_sections_help: 'Poka\u017c, ukryj i zmie\u0144 kolejno\u015b\u0107 sekcji, kt\u00f3re widzi klient. Tytu\u0142y i opisy edytujesz bezpo\u015brednio na stronie.',
    cve_section_title_label: 'Tytu\u0142 sekcji',
    cve_section_description_label: 'Opis sekcji',
    card_gallery_section: 'Galeria',
    cve_gallery_title_placeholder: 'Opcjonalny nag\u0142\u00f3wek nad zdj\u0119ciami',
    cve_gallery_description_placeholder: 'Opcjonalny kontekst \u2014 kr\u00f3tka linia pod nag\u0142\u00f3wkiem',
    cve_use_workspace_defaults: 'U\u017cyj domy\u015blnych ustawie\u0144 workspace',
    cve_workspace_defaults_on_hint: 'Nazwy sekcji pochodz\u0105 z Branding \u2192 Teksty widoku klienta. Wy\u0142\u0105cz, by dostosowa\u0107 tylko t\u0119 tablic\u0119.',
    cve_workspace_defaults_off_hint: 'Ta tablica u\u017cywa w\u0142asnych nazw sekcji i opis\u00f3w.',
    cve_workspace_defaults_locked_hint: 'Dost\u0119pne w planach Pro i Signature. Na Twoim obecnym planie wszystkie tablice dziedzicz\u0105 domy\u015blne ustawienia workspace.',
    cve_inherits_workspace_default: 'Dziedziczy domy\u015blne ustawienie workspace.',
    inline_section_locked_hint: 'Dziedziczy domy\u015blne ustawienie workspace. Wy\u0142\u0105cz \u201eU\u017cyj domy\u015blnych ustawie\u0144 workspace\u201d w Zaawansowanych, aby dostosowa\u0107 t\u0119 tablic\u0119.',
    inline_texts_on_page_hint: 'Tytu\u0142y i teksty edytujesz bezpo\u015brednio na stronie.',
    cve_drag_section: 'Zmie\u0144 kolejno\u015b\u0107 sekcji',
    cve_reorder_hint: 'Przeci\u0105gnij za ⋮⋮ aby zmieni\u0107 kolejno\u015b\u0107 sekcji.',
    gallery_add_section: 'Dodaj sekcj\u0119',
    gallery_new_section_default_title: 'Nowa sekcja',
    gallery_section_delete: 'Usu\u0144 sekcj\u0119',
    gallery_section_drag: 'Zmie\u0144 kolejno\u015b\u0107 sekcji',
    gallery_section_desc_placeholder: 'Opcjonalny opis',
    gallery_section_empty_hint: 'U\u017cyj \u201ePrzenie\u015b do sekcji\u201d na zdj\u0119ciu, by umie\u015bci\u0107 je tutaj.',
    gallery_section_delete_confirm: 'Usun\u0105\u0107 t\u0119 sekcj\u0119? Zdj\u0119cia zostan\u0105 na tablicy i wr\u00f3c\u0105 do puli \u201eBez kategorii\u201d.',
    card_final_decision_section: 'Final Decision',
    cve_fd_active_hint: 'Baner Final Decision to komunikat systemowy i nie podlega edycji.',
    private_space_title: 'Prywatna przestrze\u0144',
    private_space_hint: 'Widoczne tylko dla Ciebie',
    private_notes_title: 'Prywatne notatki',
    private_add_note: 'Dodaj notatk\u0119',
    private_note_title_placeholder: 'Tytu\u0142 notatki',
    private_note_placeholder: 'Zapisz cokolwiek \u2014 pomys\u0142y, list\u0119 uj\u0119\u0107, przypomnienia\u2026',
    private_empty_notes: 'Brak notatek \u2014 pomys\u0142y, listy uj\u0119\u0107, przypomnienia.',
    private_todo_title: 'Do zrobienia / Przypomnienia',
    private_todo_placeholder: 'Dodaj zadanie i naci\u015bnij Enter',
    private_gallery_title: 'Prywatna galeria',
    private_gallery_hint: 'Zdj\u0119cia i inspiracje, kt\u00f3re widzisz tylko Ty.',
    private_add_images: 'Dodaj zdj\u0119cia',
    private_add_from_library: 'Z biblioteki',
    private_delete: 'Usu\u0144',
    attach_from: 'Do\u0142\u0105cz:',
    attach_document: 'Dokument',
    attach_gallery: 'Zdj\u0119cia z tablicy',
    attach_confirm: 'Do\u0142\u0105cz',
    view_board_card: 'Zobacz tablic\u0119',
    attachment_removed: 'Dokument zosta\u0142 usuni\u0119ty',
    doc_link: 'Link',
    no_documents_yet: 'Na tej tablicy nie ma jeszcze dokument\u00f3w',
    filter_active: 'Aktywne',
    filter_expired: 'Wygas\u0142e',
    filter_all: 'Wszystkie',
    // ── Client Space ──
    clients_nav: 'Klienci',
    cs_title: 'Client Space',
    cs_subtitle: 'Prywatna kartoteka każdej współpracy — historia, dokumenty i tablice, zawsze pod ręką.',
    cs_back: 'Klienci',
    cs_back_dashboard: 'Workspace',
    cs_new_client: '+ Nowy klient',
    cs_new_client_title: 'Nowy klient',
    cs_no_clients_title: 'Brak klientów',
    cs_no_clients: 'Utwórz pierwszą kartotekę klienta — tu zamieszka historia, dokumenty i tablice.',
    cs_not_found: 'Nie znaleziono klienta.',
    cs_client_name: 'Imię i nazwisko / nazwa',
    cs_company: 'Firma (opcjonalnie)',
    cs_email: 'Email',
    cs_phone: 'Telefon',
    cs_address: 'Adres',
    cs_address_optional: 'Adres (opcjonalnie — możesz dodać później)',
    cs_meta_history: 'wpisów',
    cs_meta_boards: 'tablic',
    cs_important_info: 'Ważne informacje',
    cs_since: 'Współpraca od',
    cs_open_record: 'Kartoteka',
    // ── Workspace dashboard & modules ──
    wd_library: 'Biblioteka',
    wd_library_desc: 'Wszystkie Twoje inspiracje, obrazy i kolekcje.',
    wd_clients: 'Klienci',
    wd_clients_desc: 'Kartoteki klientów, historia, dokumenty i wspomnienia.',
    wd_boards: 'Tablice',
    wd_boards_desc: 'Współpracuj z klientami i ożywiaj pomysły.',
    wd_creator: 'Creator Space',
    wd_creator_desc: 'Twoja przestrzeń na pomysły, plany i rozwój.',
    wd_home: 'Start',
    wd_soon: 'Wkrótce',
    wd_greet_morning: 'Dzień dobry',
    wd_greet_afternoon: 'Dzień dobry',
    wd_greet_evening: 'Dobry wieczór',
    wd_workspace_sub: 'To Twój kreatywny workspace',
    wd_quote: 'Kreatywność to nie luksus. To sposób na życie.',
    wd_bell: 'Aktywność klientów',
    modules_section: 'Moje moduły',
    module_on: 'Włączony',
    module_off: 'Wyłączony',
    modules_note: 'Wyłączone moduły znikają z Twojego workspace całkowicie. Biblioteka jest częścią rdzenia i zostaje zawsze.',
    wd_greeting: 'Witaj w swoim studio.',
    wd_enter: 'Wejdź',
    cs_add: 'Dodaj',
    cs_assign_short: 'Przypisz',
    cs_create_short: '+ Nowa',
    cs_boards_empty_short: 'Brak tablic — Client Space działa niezależnie, dla samej historii i dokumentów.',
    cs_important_info_hint: 'Wszystko, co warto pamiętać — preferencje, alergie, ustalenia, sposób pracy…',
    cs_email_action: 'Email',
    cs_call: 'Zadzwoń',
    cs_map: 'Mapa',
    cs_tab_history: 'Historia',
    cs_tab_documents: 'Dokumenty',
    cs_tab_boards: 'Tablice',
    cs_search_history: 'Szukaj w tytułach, notatkach, tagach…',
    cs_search_clients: 'Szukaj klientów…',
    cs_export_zip: 'Pobierz ZIP',
    cs_export_client: 'Pobierz archiwum',
    cs_exporting: 'Przygotowuję…',
    cs_export_failed: 'Eksport nie powiódł się — spróbuj ponownie.',
    cs_clients_no_results: 'Żaden klient nie pasuje do wyszukiwania.',
    cs_add_entry: '+ Dodaj wpis',
    cs_add_entry_title: 'Nowy wpis w historii',
    cs_edit_entry: 'Edytuj wpis',
    cs_history_empty: 'Historia tej współpracy zaczyna się tutaj — dodaj pierwszy wpis.',
    cs_history_no_results: 'Nic nie pasuje do wyszukiwania.',
    cs_entry_date: 'Data',
    cs_entry_title: 'Tytuł',
    cs_entry_title_hint: 'np. Pierwsza konsultacja, Uzupełnienie rzęs, Warsztat brandowy…',
    cs_entry_note: 'Notatka',
    cs_entry_tags: 'Tagi (opcjonalnie)',
    cs_entry_tags_hint: 'Wpisz i naciśnij Enter',
    cs_entry_photos: 'Zdjęcia (opcjonalnie)',
    cs_entry_link_board: 'Powiązana tablica (opcjonalnie)',
    cs_entry_link_board_view: 'Tablica',
    cs_entry_link_documents: 'Powiązane dokumenty (opcjonalnie)',
    cs_none: 'Brak',
    cs_created: 'Utworzono',
    cs_last_edited: 'Ostatnia edycja',
    cs_edit_history: 'Historia edycji',
    cs_previous_version: 'Wersja do',
    cs_delete_entry_confirm: 'Usunąć ten wpis bezpowrotnie?',
    cs_docs_empty: 'Umowy, briefy, pliki inspiracji — wszystko o tym kliencie, w jednym spokojnym miejscu.',
    cs_upload_document: '+ Dodaj dokument',
    cs_upload_failed: 'Przesyłanie nie powiodło się',
    cs_preview: 'Podgląd',
    cs_download: 'Pobierz',
    cs_link_to_board: 'Połącz z tablicą',
    cs_unlink_relabel: 'Powiązanie',
    cs_remove: 'Usuń',
    cs_doc_remove_confirm: 'Usunąć ten dokument bezpowrotnie?',
    cs_boards_empty: 'Brak przypisanych tablic. Client Space działa niezależnie — prowadź tu historię i dokumenty tej współpracy, nawet bez tablicy.',
    cs_create_board: '+ Utwórz tablicę',
    cs_assign_board: 'Przypisz istniejącą tablicę',
    cs_assign_pick: 'Przypisz tablicę',
    cs_no_assignable: 'Każda tablica jest już przypisana do klienta.',
    cs_unassign: 'Odepnij',
    cs_board_created: 'Tablica utworzona',
    cs_board_assigned: 'Tablica przypisana',
    cs_delete_client: 'Usuń klienta',
    cs_delete_client_confirm: 'Usunąć tego klienta i całą kartotekę? Tablice pozostaną nietknięte.',
    cs_save: 'Zapisz',
    cs_cancel: 'Anuluj',
    cs_create: 'Utwórz',
    cs_edit: 'Edytuj',
    cs_close: 'Zamknij',
    cs_delete: 'Usuń',
    cs_deleted: 'Usunięto',
    cs_saved: 'Zapisano',
    filter_empty: 'Nic tu nie ma \u2014 zmie\u0144 filtr powy\u017cej.',
    seen_label: 'Wy\u015bwietlone',
    cve_fd_inactive_hint: 'Final Decision w\u0142\u0105czasz poprzez zabezpieczony przep\u0142yw zapro\u015be\u0144 (Ustawienia \u2192 Final Decision).',
    preview_as_client_inline: 'Podgl\u0105d jak klient',
    exit_client_preview: 'Zako\u0144cz podgl\u0105d',
    back_to_editing: 'Wr\u00f3\u0107 do edycji',
    client_preview_hint: 'Podgl\u0105d na \u017cywo \u2014 dok\u0142adnie to widzi Tw\u00f3j klient.',
    add_images: 'Dodaj zdj\u0119cia',
    add_images_subtitle: 'Wgraj, biblioteka lub zewn\u0119trzna inspiracja',
    drop_to_upload: 'Upu\u015b\u0107, aby wgra\u0107',
    drag_drop_or_click: 'Przeci\u0105gnij i upu\u015b\u0107 lub kliknij, by wgra\u0107',
    from_library: 'Z biblioteki',
    add_via_link: 'Dodaj przez link',
    also_save_uploads: 'Zapisuj r\u00f3wnie\u017c w bibliotece',
    reorder_images: 'Zmie\u0144 kolejno\u015b\u0107',
    manage_labels: 'Zarz\u0105dzaj etykietami',
    no_images_yet: 'Brak zdj\u0119\u0107. Dodaj nowe lub wybierz z biblioteki.',
    add_external_image_urls: 'Dodaj zewn\u0119trzne linki do zdj\u0119\u0107',
    shared_communication_space: 'Wsp\u00f3lna przestrze\u0144 komunikacji z klientem',
    attach_project_materials: 'Do\u0142\u0105cz materia\u0142y projektowe, umowy, inspiracje — wszystko, co pomaga w projekcie.',
    upload_file: 'Wgraj plik',
    // Settings sidebar inside BoardEditor
    client_email_label: 'Email klienta',
    used_for_client_notifications: 'U\u017cywany do powiadomie\u0144 klienta',
    send_test_to_me: 'Wy\u015blij test do mnie',
    client_details: 'Dane klienta',
    client_details_placeholder: 'Email, telefon, adres, notatki...',
    auto_lock_label: 'Auto-blokada przed dat\u0105 projektu (dni)',
    shared_decision_mode: 'Tryb wsp\u00f3lnych decyzji',
    shared_decision_desc: 'Pozw\u00f3l dw\u00f3m osobom niezale\u017cnie wybiera\u0107 preferencje na tej tablicy.',
    shared_mode_enabled: 'Tryb wsp\u00f3lny w\u0142\u0105czony',
    enable_shared_decisions: 'W\u0142\u0105cz wsp\u00f3lne decyzje',
    person_1_name: 'Imi\u0119 osoby 1',
    person_2_name: 'Imi\u0119 osoby 2',
    client_uploads_enabled: 'Wgrywanie przez klienta w\u0142\u0105czone',
    client_uploads_hidden: 'Wgrywanie przez klienta ukryte',
    documents_enabled: 'Dokumenty w\u0142\u0105czone',
    documents_hidden: 'Dokumenty ukryte',
    client_notes_locked: 'Notatki klienta',
    client_uploads_locked: 'Wgrywanie przez klienta',
    documents_locked: 'Dokumenty',
    internal_view_title: 'Widok wewn\u0119trzny',
    internal_view_desc: 'Szczeg\u00f3\u0142y po stronie studia, nigdy nie pokazywane klientowi.',
    show_filenames_label: 'Poka\u017c nazwy plik\u00f3w',
    show_filenames_hint: 'Przydatne przy retuszu, selekcji i przygotowaniu eksportu.',
    client_header_title: 'Nag\u0142\u00f3wek widoku klienta',
    client_header_desc: 'Jak wygl\u0105da g\u00f3rna cz\u0119\u015b\u0107 strony, gdy klient otwiera tablic\u0119.',
    show_board_title_label: 'Poka\u017c tytu\u0142 tablicy',
    show_board_title_hint: 'Wy\u015bwietl nazw\u0119 tablicy pod logo, nad sekcj\u0105 powitaln\u0105.',
    board_subtitle_label: 'Podtytu\u0142 (opcjonalnie)',
    board_subtitle_placeholder: 'np. Inspiracje koncepcyjne',
    board_subtitle_hint: 'Kr\u00f3tka linia pokazywana bezpo\u015brednio pod tytu\u0142em tablicy.',
    custom_welcome_title: 'Wiadomo\u015b\u0107 powitalna',
    custom_welcome_desc: 'Zmie\u0144 powitanie pokazywane klientowi — tylko dla tej tablicy.',
    use_custom_welcome_label: 'U\u017cyj niestandardowego powitania dla tej tablicy',
    use_custom_welcome_hint: 'Gdy wy\u0142\u0105czone, tablica u\u017cywa powitania z szablonu.',
    custom_welcome_title_label: 'Tytu\u0142 powitania',
    custom_welcome_title_placeholder: 'np. Witaj, Anno & Danielu.',
    custom_welcome_description_label: 'Opis powitania',
    custom_welcome_description_placeholder: 'np. To kierunek wizualny dla Twojego \u015blubu.',
    custom_welcome_hint_label: 'Wskaz\u00f3wka',
    custom_welcome_hint_placeholder: 'np. Nie \u015bpiesz si\u0119. Nie ma z\u0142ych odpowiedzi.',
    custom_welcome_fallback_hint: 'Zostaw pole puste, by zachowa\u0107 tekst z szablonu dla danej linii.',
    board_cover_panel_title: 'Strona ok\u0142adki',
    board_cover_panel_desc: 'Kinematograficzna pe\u0142noekranowa scena powitalna przed wej\u015bciem na moodboard.',
    board_cover_enable_label: 'W\u0142\u0105cz stron\u0119 ok\u0142adki',
    board_cover_enable_hint: 'Gdy wy\u0142\u0105czone, klient wchodzi bezpo\u015brednio na tablic\u0119.',
    board_cover_title_label: 'Tytu\u0142 ok\u0142adki',
    board_cover_title_placeholder: 'np. Sesja ci\u0105\u017cowa',
    board_cover_subtitle_label: 'Podtytu\u0142 ok\u0142adki',
    board_cover_subtitle_placeholder: 'np. Koncept minimalny · Wiosna 2026',
    board_cover_button_label: 'Tekst przycisku',
    board_cover_button_placeholder: 'np. Otw\u00f3rz koncept',
    board_cover_image_source_label: '\u0179r\u00f3d\u0142o obrazu ok\u0142adki',
    board_cover_source_first: 'Pierwsze zdj\u0119cie z tablicy',
    board_cover_source_custom: 'W\u0142asny obraz ok\u0142adki',
    board_cover_show_skip_label: 'Poka\u017c ma\u0142y link „Pomi\u0144"',
    board_cover_first_visit_only_label: 'Poka\u017c ok\u0142adk\u0119 tylko przy pierwszej wizycie',
    enter_board: 'Wejd\u017a',
    skip_cover: 'Pomi\u0144',
    selected_image: 'Wybrane zdj\u0119cie',
    section_label: 'Etykieta sekcji',
    none_option: 'Brak',
    from_library_shared: 'Z Biblioteki (wsp\u00f3lne dla tablic)',
    cover_image: 'Zdj\u0119cie ok\u0142adkowe',
    set_as_cover: 'Ustaw jako ok\u0142adk\u0119',
    cover_removed: 'Ok\u0142adka usuni\u0119ta',
    cover_set: 'Ustawiono jako ok\u0142adk\u0119',
    remove_from_board: 'Usu\u0144 z tablicy',
    // Delete board modal — soft-delete: board moves to Recently Deleted for 30d
    delete_board_title: 'Przenie\u015b do Ostatnio usuni\u0119tych',
    delete_board_warning: 'Ta tablica zostanie przeniesiona do Ostatnio usuni\u0119tych. Mo\u017cna j\u0105 przywr\u00f3ci\u0107 w ci\u0105gu 30 dni, kontaktuj\u0105c si\u0119 z pomoc\u0105 techniczn\u0105.',
    delete_permanently: 'Przenie\u015b do Ostatnio usuni\u0119tych',
    delete_board_confirmation: 'Tablica przeniesiona do Ostatnio usuni\u0119tych.\n\nMo\u017cna j\u0105 przywr\u00f3ci\u0107 w ci\u0105gu 30 dni, kontaktuj\u0105c si\u0119 z pomoc\u0105 techniczn\u0105.',
    // Extend modal
    reopen_board_title: 'Otw\u00f3rz ponownie tablic\u0119',
    extend_board_title: 'Przed\u0142u\u017c tablic\u0119',
    extend_reopen_subtitle: 'Link do udost\u0119pniania pozostanie taki sam. Klient odzyska dost\u0119p.',
    extend_subtitle: 'Przed\u0142u\u017c dat\u0119 wyga\u015bni\u0119cia od dzisiaj.',
    reopen_for: 'Otw\u00f3rz na',
    extend_by: 'Przed\u0142u\u017c o',
    new_expiration: 'Nowa data wyga\u015bni\u0119cia',
    same_share_link: 'Ten sam link',
    all_images_preserved: 'Wszystkie zdj\u0119cia zachowane',
    all_reactions_preserved: 'Wszystkie reakcje zachowane',
    // Export PDF modal
    export_to_pdf_title: 'Eksport do PDF',
    export_preferences_subtitle: 'Wybierz preferencje eksportu',
    export_content_label: 'Zawarto\u015b\u0107 eksportu',
    all_images_option: 'Wszystkie zdj\u0119cia',
    export_entire_board: 'Eksportuj ca\u0142\u0105 tablic\u0119',
    client_selected_only: 'Tylko wybrane przez klienta',
    client_selected_desc: 'Tylko ❤️ „To czuj\u0119” i \ud83e\udd0d „Neutralne” · Bez ❌ „Nie ja”',
    include_unrated_images: 'Uwzgl\u0119dnij nieocenione zdj\u0119cia',
    image_density_label: 'G\u0119sto\u015b\u0107 zdj\u0119\u0107',
    density_1: '1 zdj\u0119cie na stron\u0119',
    density_1_desc: 'Pe\u0142ny focus · galeria/dzie\u0142o sztuki · szerokie marginesy',
    density_2: '2 zdj\u0119cia na stron\u0119',
    density_2_desc: 'Uk\u0142ad redakcyjny',
    density_4: '4 zdj\u0119cia na stron\u0119',
    density_4_desc: 'Siatka minimalistyczna',
    density_6: '6 zdj\u0119\u0107 na stron\u0119',
    density_6_desc: 'Tryb przegl\u0105du / referencji',
    layout_style_label: 'Styl uk\u0142adu',
    layout_gallery: 'Galeria',
    layout_gallery_desc: 'Czysty, minimalny, skupiony na dziele',
    layout_editorial: 'Redakcyjny',
    layout_editorial_desc: 'Elegancki z etykietami i reakcjami',
    layout_reference: 'Referencyjny',
    layout_reference_desc: 'Kompaktowy z pe\u0142nymi detalami',
    page_orientation_label: 'Orientacja strony',
    orientation_portrait: 'Pionowa',
    orientation_landscape: 'Pozioma',
    include_in_export: 'Do\u0142\u0105cz w eksporcie',
    include_client_notes: 'Komentarze klienta pod zdj\u0119ciami',
    include_reactions_icons: 'Ikony reakcji pod ka\u017cdym zdj\u0119ciem (❤️ / \ud83e\udd0d)',
    include_image_metadata: 'Metadane zdj\u0119cia (Poza / \u015awiat\u0142o / Stylizacja)',
    include_document_confirmations: 'Potwierdzenia i daty dokument\u00f3w',
    include_notes_thoughts: 'Notatki i my\u015bli',
    include_final_selections_label: 'Sekcja finalnych wybor\u00f3w',
    // UserSettings
    settings_title: 'Ustawienia',
    editing_overrides_for: 'Edytujesz nadpisania dla',
    reset_all_to_default: 'Przywr\u00f3\u0107 wszystkie do domy\u015blnych',
    use_default: 'U\u017cyj domy\u015blnego',
    custom_label: 'W\u0142asne',
    default_label: 'Domy\u015blne',
    welcome_title_label: 'Tytu\u0142 powitalny',
    description_text_label: 'Tekst opisu',
    welcome_hint_label: 'Wskaz\u00f3wka pod opisem (kursywa)',
    custom_message_label: 'Wiadomo\u015b\u0107 (opcjonalna)',
    instruction_section: 'Sekcja instrukcji',
    instruction_section_desc: 'Wy\u015bwietlana nad galeri\u0105 w widoku klienta. Edytuj w ka\u017cdym j\u0119zyku — puste pola wracaj\u0105 do domy\u015blnych z szablonu.',
    instruction_text_label: 'Tekst instrukcji',
    reaction_hint_label: 'Wskaz\u00f3wka reakcji',
    save_branding: 'Zapisz brandowanie',
    branding_saved: 'Brandowanie zapisane',
    // UserSettings page sections
    back_to_workspace: '← Powr\u00f3t do workspace',
    account_section: 'Konto',
    brand_name_label: 'Nazwa marki',
    brand_name_placeholder: 'Wy\u015bwietlana w widoku klienta, nag\u0142\u00f3wku i eksportach',
    save_brand_name: 'Zapisz nazw\u0119 marki',
    saving_short: 'Zapisywanie…',
    email_label: 'Email',
    username_label: 'Nazwa u\u017cytkownika',
    status_label: 'Status',
    status_active_pill: 'Aktywny',
    access_label: 'Dost\u0119p',
    days_remaining: 'dni pozosta\u0142o',
    access_valid_until: 'Dost\u0119p wa\u017cny do',
    unlimited_access: 'Dost\u0119p nieograniczony',
    request_extension: 'Po\u015b ekstension',
    locale: 'pl-PL',
    usage_section: 'Zu\u017cycie',
    storage_label: 'Pami\u0119\u0107',
    boards_label: 'Tablice',
    images_in_library: 'Zdj\u0119cia w bibliotece',
    language_section: 'J\u0119zyk',
    branding_section: 'Branding',
    logo_label: 'Logo',
    no_logo: 'Brak loga',
    upload_logo: 'Wgraj logo',
    remove_logo: 'Usu\u0144 logo',
    logo_helper_primary: 'Najlepsze efekty osi\u0105ga si\u0119 z przezroczystym logo PNG.',
    logo_helper_secondary: 'Dla czystej, premium prezentacji unikaj logo z bia\u0142ym t\u0142em.',
    upload_logo_cta: 'Wgraj swoje logo',
    upload_logo_hint: 'PNG, SVG, JPG · zalecane przezroczyste t\u0142o',
    display_in_client_view: 'Wy\u015bwietl w widoku klienta',
    display_in_client_help: 'Co pokaza\u0107 w nag\u0142\u00f3wku tablicy',
    logo_and_name: 'Logo + nazwa marki',
    logo_only: 'Tylko logo',
    brand_name_only: 'Tylko nazwa marki',
    logo_size_label: 'Rozmiar loga',
    client_atmosphere: 'Atmosfera widoku klienta',
    client_atmosphere_help: 'Wybierz nastr\u00f3j, jaki Twoi klienci poczuj\u0105 podczas przegl\u0105dania udost\u0119pnionych tablic.',
    atm_maestra: 'Domy\u015blny Maestra',
    atm_maestra_desc: 'Czysty, ko\u015bciany',
    atm_warm: 'Ciep\u0142y piasek',
    atm_warm_desc: 'Ziemisty, z\u0142oty spok\u00f3j',
    atm_grey: 'Mi\u0119kki szary',
    atm_grey_desc: 'Neutralna elegancja',
    atm_blue: 'Zakurzony niebieski',
    atm_blue_desc: 'Ch\u0142odna lekko\u015b\u0107',
    atm_custom: 'W\u0142asny',
    atm_custom_desc: 'Twoja w\u0142asna atmosfera',
    client_view_texts: 'Teksty widoku klienta',
    client_view_texts_desc: 'Dostosuj, jak Twoje workspace wygl\u0105da, gdy klient otwiera udost\u0119pniony link. Edytuj ka\u017cdy j\u0119zyk osobno — puste pola wracaj\u0105 do domy\u015blnych z szablonu.',
    only_fill_empty: 'Wype\u0142nij tylko puste pola',
    density_spacious: 'Przestronny',
    density_spacious_sub: 'Ok. 1–2 zdj\u0119cia na stronie',
    density_spacious_desc: 'Elegancka prezentacja z du\u017cymi marginesami',
    density_balanced: 'Zr\u00f3wnowa\u017cony',
    density_balanced_sub: 'Ok. 2–4 zdj\u0119cia na stronie',
    density_balanced_desc: 'Czysty uk\u0142ad galerii',
    density_compact: 'Kompaktowy',
    density_compact_sub: 'Ok. 6–12 zdj\u0119\u0107 na stronie',
    density_compact_desc: 'Adaptacyjna siatka przegl\u0105dowa dla szybkiego przegl\u0105du klienta',
    image_density_label: 'G\u0119sto\u015b\u0107 PDF',
    custom_color_helper: 'Stworzymy delikatn\u0105 palet\u0119 na podstawie tego koloru.',
    branding_eyebrow: 'Zaprojektuj do\u015bwiadczenie klienta',
    branding_headline: 'Branding',
    card_brand_identity: 'To\u017csamo\u015b\u0107 marki',
    card_brand_identity_desc: 'Twoje logo i spos\u00f3b, w jaki nazwa marki pojawia si\u0119 na ka\u017cdej tablicy.',
    card_client_experience: 'Do\u015bwiadczenie klienta',
    card_client_experience_desc: 'Nastr\u00f3j, kt\u00f3ry poczuj\u0105 Twoi klienci po otwarciu tablicy.',
    card_client_view_texts: 'Teksty widoku klienta',
    card_instruction_section: 'Sekcja instrukcji',
    card_inspirations_section: 'Sekcja inspiracji',
    inspirations_section_desc: 'Wy\u015bwietlane nad polem 10 inspiracji klienta. Edytuj osobno dla ka\u017cdego j\u0119zyka — puste pola przyjmuj\u0105 warto\u015b\u0107 domy\u015bln\u0105.',
    card_notes_section: 'Sekcja notatek',
    notes_section_desc: 'Nag\u0142\u00f3wek i wprowadzenie do wsp\u00f3lnych notatek. Edytuj osobno dla ka\u017cdego j\u0119zyka.',
    card_documents_section: 'Sekcja dokument\u00f3w',
    documents_section_desc: 'Nag\u0142\u00f3wek i wprowadzenie nad dokumentami projektu. Edytuj osobno dla ka\u017cdego j\u0119zyka.',
    inspirations_title_label: 'Tytu\u0142 inspiracji',
    inspirations_description_label: 'Opis inspiracji',
    notes_title_label: 'Tytu\u0142 notatek',
    notes_description_label: 'Opis notatek',
    documents_title_label: 'Tytu\u0142 dokument\u00f3w',
    documents_description_label: 'Opis dokument\u00f3w',
    card_footer: 'Stopka',
    advanced_options: 'Opcje zaawansowane',
    preview_open_btn: 'Podgl\u0105d na \u017cywo',
    preview_close_btn: 'Zamknij',
    preview_lang_tag: 'J\u0119zyk',
    translate_from_en_to: 'Przet\u0142umacz z EN →',
    translating_short: 'T\u0142umaczenie…',
    translate_nothing_to_fill: 'Nic do uzupe\u0142nienia — ka\u017cde pole ma ju\u017c t\u0142umaczenie.',
    translate_fill_en_first: 'Najpierw wype\u0142nij zak\u0142adk\u0119 EN — nie ma czego t\u0142umaczy\u0107.',
    translate_no_results: 'T\u0142umacz nie zwr\u00f3ci\u0142 wynik\u00f3w.',
    translate_failed: 'T\u0142umaczenie nie powiod\u0142o si\u0119.',
    translate_translated_n_to: 'Przet\u0142umaczono {n} p\u00f3l na {lang}.',
    client_view_footer: 'Stopka widoku klienta',
    client_view_footer_desc: 'Dostosuj stopk\u0119 na stronach udost\u0119pnionych tablic. Subtelna informacja „created with maestra.space” zawsze pojawi si\u0119 poni\u017cej.',
    footer_text_label: 'Tekst stopki',
    footer_subtext_label: 'Podtekst stopki',
    optional: 'opcjonalnie',
    link_label_label: 'Etykieta linku',
    link_url_label: 'URL linku',
    client_view_preview: 'Podgl\u0105d widoku klienta',
    support_access: 'Dost\u0119p wsparcia',
    // Need help? — founder-led contact flow
    need_help_section: 'Potrzebujesz pomocy?',
    need_help_body: 'Maestra wci\u0105\u017c jest budowana z uwag\u0105 i intencj\u0105. Je\u015bli kiedykolwiek potrzebujesz pomocy z workspace lub tablicami, mo\u017cesz napisa\u0107 bezpo\u015brednio.',
    contact_maestra_btn: 'Skontaktuj si\u0119 z Maestr\u0105',
    contact_modal_title: 'Napisz do Maestry.',
    contact_modal_subtitle: 'Bezpo\u015bredni kontakt z za\u0142o\u017cycielk\u0105. Odpowied\u017a zwykle przychodzi w ci\u0105gu jednego–dw\u00f3ch dni.',
    contact_field_message: 'Twoja wiadomo\u015b\u0107',
    contact_field_category: 'Dotyczy',
    contact_field_board: 'Tablica (opcjonalnie)',
    contact_board_none: '\u017badne',
    contact_placeholder: 'Napisz, co masz na my\u015bli…',
    contact_cat_workspace: 'Pomoc z workspace',
    contact_cat_board_recovery: 'Przywr\u00f3cenie archiwalnej tablicy',
    contact_cat_technical: 'Problem techniczny',
    contact_cat_other: 'Inne',
    contact_send: 'Wy\u015blij wiadomo\u015b\u0107',
    contact_sending: 'Wysy\u0142am…',
    contact_min_message: 'Napisz, prosz\u0119, cho\u0107 kilka s\u0142\u00f3w.',
    contact_send_failed: 'Nie uda\u0142o si\u0119 wys\u0142a\u0107 wiadomo\u015bci. Spr\u00f3buj ponownie.',
    contact_sent_title: 'Twoja wiadomo\u015b\u0107 jest w drodze.',
    contact_sent_body: 'Czytam ka\u017cd\u0105 wiadomo\u015b\u0107 osobi\u015bcie. Wkr\u00f3tce si\u0119 odezw\u0119, zwykle w ci\u0105gu jednego–dw\u00f3ch dni.',
    support_access_desc: 'Zezw\u00f3l administratorowi na dost\u0119p wsparcia',
    support_access_active_expires_in: 'Dost\u0119p aktywny — wygasa za',
    support_access_disabled: 'Wy\u0142\u0105czone',
    reset_all_welcome_texts_tooltip: 'Przywr\u00f3\u0107 wszystkie teksty powitalne do domy\u015blnych z szablonu dla ka\u017cdego j\u0119zyka',
    placeholder_welcome_title_eg: 'np. Witaj na swoim moodboardzie',
    placeholder_description_eg: 'np. Przejrzyj zdj\u0119cia i podziel si\u0119 swoimi przemy\u015bleniami',
    placeholder_custom_message_eg: 'np. Osobista wiadomo\u015b\u0107 wy\u015bwietlana nad galeri\u0105',
    placeholder_instruction_text_eg: 'np. Poni\u017cej znajdziesz starannie dobrany wyb\u00f3r przygotowany dla Ciebie.',
    placeholder_reaction_hint_eg: 'np. Dotknij, aby zareagowa\u0107 · dwukrotnie dotknij, by oznaczy\u0107 ulubione',
    preview_welcome_title_default: 'Tw\u00f3j moodboard jest gotowy',
    preview_subtitle_default: 'Przejrzyj inspiracje i podziel si\u0119 swoj\u0105 opini\u0105',
    preview_footer_placeholder: 'Tutaj pojawi si\u0119 stopka platformy. Ustaw w\u0142asn\u0105 stopk\u0119 powy\u017cej, aby j\u0105 spersonalizowa\u0107.',
    your_brand_name_placeholder: 'Nazwa Twojej marki',
    who_are_you: 'Kim jeste\u015b?',
    select_your_name: 'Wybierz swoje imi\u0119, aby rozpocz\u0105\u0107',
    drop_images_here: 'Upu\u015b\u0107 zdj\u0119cia tutaj...',
    uploading: 'Wgrywanie...',

    welcome: 'Witaj.',
    client_intro: 'To Tw\u00f3j prywatny moodboard.\nPrzestrze\u0144 do wsp\u00f3lnego odkrywania nastroju, \u015bwiat\u0142a i atmosfery.',
    client_hint: 'Nie \u015bpiesz si\u0119. Nie ma dobrych ani z\u0142ych odpowiedzi.',
    locked_title: 'Ten moodboard zosta\u0142 ju\u017c zamkni\u0119ty.',
    locked_subtitle: 'Dzi\u0119kuj\u0119 za wszystkie wybory i wskaz\u00f3wki.\nMam ju\u017c wszystko, czego potrzebuj\u0119 do dalszego przygotowania projektu.',
    locked_helper: 'Mo\u017cesz nadal przegl\u0105da\u0107 tablic\u0119, ale dodawanie nowych reakcji i zmian zosta\u0142o wy\u0142\u0105czone.',
    instruction_main: 'Poni\u017cej znajdziesz wyb\u00f3r zdj\u0119\u0107 przygotowanych specjalnie dla Ciebie.\nPomagaj\u0105 mi zrozumie\u0107, co do Ciebie przemawia — intuicyjnie, nie intelektualnie.',
    instruction_react: 'Po prostu zareaguj na ka\u017cde zdj\u0119cie.',
    final_decision_prompt: 'Prosz\u0119, wybierz swoje finalne preferencje.',
    expired_title: 'Ten moodboard nie jest ju\u017c aktywny.',
    archived_title: 'Ta tablica nie jest ju\u017c dost\u0119pna.',
    expired_message: 'Dzi\u0119kuj\u0119 za podzielenie si\u0119 swoim odczuciem.\nZapisa\u0142am wszystko, co potrzebne do przygotowa\u0144.',

    reaction_love: 'To czuj\u0119',
    reaction_neutral: 'Mo\u017ce',
    reaction_not_me: 'Nie to',
    reaction_simple_yes: 'Tak',
    reaction_simple_maybe: 'Mo\u017ce',
    reaction_simple_no: 'Nie',
    reaction_decision_agree: 'Zgadzam si\u0119',
    reaction_decision_not_agree: 'Nie zgadzam si\u0119',
    reaction_decision_remove: 'Usu\u0144',
    final_choice: '★ Finalny wyb\u00f3r',
    mark_final: '☆ Oznacz jako finalny',
    add_note: '+ Dodaj notatk\u0119',
    comment_placeholder: 'Mo\u017cesz doda\u0107 kr\u00f3tk\u0105 notatk\u0119, je\u015bli co\u015b Ci\u0119 poruszy\u0142o.',

    your_inspirations: 'Twoje inspiracje',
    inspiration_intro: 'Mo\u017cesz doda\u0107 do 10 zdj\u0119\u0107, kt\u00f3re odzwierciedlaj\u0105 Twoje odczucie.\nNie chodzi o perfekcj\u0119 — tylko o rezonans.',
    inspiration_hint: 'Wybierz tylko to, co naprawd\u0119 czujesz jako swoje.',
    add_inspiration: 'Dodaj inspiracj\u0119',
    images_added: 'zdj\u0119\u0107 dodanych',
    max_inspirations: 'Osi\u0105gni\u0119to maksymaln\u0105 liczb\u0119 10 inspiracji.',
    max_inspirations_hint: 'To pomaga utrzyma\u0107 jasny i sp\u00f3jny kierunek.',
    no_inspirations: 'Nie dodano \u017cadnych inspiracji.',

    notes_title: 'Konwersacja',
    notes_subtitle: 'Wsp\u00f3lna przestrze\u0144 na refleksje i pomys\u0142y mi\u0119dzy Tob\u0105 a studiem.',
    no_notes: 'Brak notatek. Podziel si\u0119 swoimi przemy\u015bleniami.',
    from_studio: 'Od {brand}',
    from_named: 'Od {name}',
    from_client_default: 'Od klienta',
    from_you: 'Od Ciebie',
    note_placeholder: 'Mo\u017cesz napisa\u0107 kr\u00f3tk\u0105 my\u015bl, je\u015bli co\u015b wydaje Ci si\u0119 wa\u017cne.',
    add_note_btn: 'Dodaj notatk\u0119',
    adding: 'Dodawanie...',
    edit: 'Edytuj',
    save: 'Zapisz',
    saving: 'Zapisywanie...',
    cancel: 'Anuluj',
    notes_closed: 'Notatki s\u0105 ju\u017c zamkni\u0119te dla tej tablicy.',
    delete_note_confirm: 'Usun\u0105\u0107 t\u0119 notatk\u0119?',
    yes_delete: 'Tak, usu\u0144',
    edited: '(edytowano)',

    documents_title: 'Dokumenty projektu',
    documents_subtitle: 'Materia\u0142y przygotowane do Twojego projektu',
    external_link: 'Link zewn\u0119trzny',
    open: 'Otw\u00f3rz',
    visit: 'Odwied\u017a',
    i_have_read: 'Zapozna\u0142am si\u0119',
    confirming: 'Potwierdzanie...',
    confirmed_on: 'Potwierdzone',

    // Admin
    admin_panel: 'Panel Admina',
    users: 'Uzytkownicy',
    invite_user: 'Zapros uzytkownika',
    storage: 'Przestrzen',
    limits: 'Limity',
    templates: 'Szablony',
    active: 'Aktywny',
    invited: 'Zaproszony',
    deactivated: 'Dezaktywowany',
    boards: 'Tablice',
    documents: 'Dokumenty',
    no_limit: 'Bez limitu',
    activate: 'Aktywuj',
    deactivate: 'Dezaktywuj',
    back_to_dashboard: 'Powrot do panelu',
    platform_overview: 'Przeglad platformy',
    total_users: 'Uzytkownicy',
    total_boards: 'Tablice',
    total_images: 'Zdjecia',
    total_documents: 'Dokumenty',
    user_management: 'Zarzadzanie uzytkownikami',
    workspace_templates: 'Szablony workspace',
    create_template: 'Stworz szablon',
    template_name: 'Nazwa szablonu',
    default_labels: 'Domyslne etykiety',
    global_template: 'Globalny',
    copy_invite_link: 'Skopiuj link zaproszenia',
    invite_link_copied: 'Link skopiowany!',
    set_limits: 'Ustaw limity',
    max_storage_mb: 'Max przestrzen (MB)',
    max_boards_limit: 'Max tablic',
    unlimited: 'Bez limitu',
    used: 'uzyte',
    of: 'z',
    in_library: 'w bibliotece',
    across_boards: 'we wszystkich tablicach',

    // ── Image Library ────────────────────────────────────────────────
    lib_title: 'Biblioteka zdj\u0119\u0107',
    lib_back_to_moodboards: '← Powr\u00f3t do moodboard\u00f3w',
    lib_drop_active: 'Upu\u015b\u0107 zdj\u0119cia tutaj...',
    lib_drop_title: 'Przeci\u0105gnij i upu\u015b\u0107 zdj\u0119cia, aby doda\u0107 do biblioteki',
    lib_drop_subtitle: 'Zdj\u0119cia z biblioteki mo\u017cesz wykorzystywa\u0107 w wielu moodboardach',
    lib_uploading: 'Wysy\u0142anie...',
    lib_upload_tags_placeholder: 'Tagi dla kolejnego uploadu (oddzielone przecinkami, np. portret, plener)',
    lib_add_external_btn: '+ Dodaj zewn\u0119trzny link do zdj\u0119cia',
    lib_add_external_title: 'Dodaj zewn\u0119trzny link do zdj\u0119cia',
    lib_external_helper: 'Wklej bezpo\u015bredni link do zdj\u0119cia (np. z Pinterest, Unsplash). Zdj\u0119cie nie zostanie pobrane — zapisywany jest tylko link.',
    lib_preview_label: 'Podgl\u0105d:',
    lib_adding: 'Dodawanie...',
    lib_add_to_library: 'Dodaj do biblioteki',
    // — Refined two-step upload flow —
    lib_step_add_images: 'Dodaj zdj\u0119cia',
    lib_step_add_tags: 'Dodaj tagi do tego uploadu',
    lib_step_save: 'Zapisz do biblioteki',
    lib_choose_files: 'Wybierz pliki',
    lib_or_separator: 'lub',
    lib_add_from_link: 'Dodaj z linku',
    lib_pending_files_label: 'Wybrane',
    lib_pending_link_label: 'Link',
    lib_remove_pending: 'Usu\u0144',
    lib_clear_batch: 'Wyczy\u015b\u0107',
    lib_tags_for_batch_placeholder: 'Wpisz tag i naci\u015bnij przecinek lub Enter…',
    lib_tags_for_batch_help: 'Te tagi zostan\u0105 przypisane do ka\u017cdego zdj\u0119cia w tym uploadzie — plik\u00f3w i linku.',
    lib_recent_tags: 'Ostatnio u\u017cywane',
    lib_save_button_single: 'Dodaj 1 zdj\u0119cie do biblioteki',
    lib_save_button_many: 'Dodaj {count} zdj\u0119\u0107 do biblioteki',
    lib_link_input_placeholder: 'https://i.pinimg.com/.../image.jpg',
    lib_filter_all: 'Wszystkie',
    lib_filter_uploaded: 'Wgrane',
    lib_filter_external: 'Zewn\u0119trzne',
    lib_filter_used: 'U\u017cywane',
    lib_filter_unused: 'Nieu\u017cywane',
    lib_tags_label: 'Tagi:',
    lib_collections_heading: 'Kolekcje',
    lib_filters_label: 'Filtry',
    lib_tags_heading: 'Filtruj po tagach',
    lib_tags_search_placeholder: 'Szukaj tagów…',
    lib_clear_all: 'Wyczy\u015b\u0107 wszystko',
    lib_tags_all_hint: '(pokazuj\u0119 zdj\u0119cia ze WSZYSTKIMI wybranymi tagami)',
    lib_download_one_tag: 'Pobierz „{tag}"',
    lib_download_n_tags: 'Pobierz {count} tag\u00f3w',
    lib_exporting: 'Eksportowanie...',
    lib_no_filtered_title: 'Brak zdj\u0119\u0107: {filter}',
    lib_no_filtered_hint: 'Spr\u00f3buj innego filtra lub wgraj nowe zdj\u0119cia i otaguj je, aby pojawi\u0142y si\u0119 tutaj.',
    lib_empty_eyebrow: 'Biblioteka zdj\u0119\u0107',
    lib_empty_title: 'Tu mieszka Twoje wizualne archiwum.',
    lib_empty_body: 'Wgraj zdj\u0119cia z komputera lub wklej bezpo\u015bredni link. Zapisane tu zdj\u0119cia mo\u017cesz wykorzysta\u0107 w ka\u017cdym projekcie — bez duplikowania plik\u00f3w.',
    lib_drag_to_reorder: 'Przeci\u0105gnij, aby zmieni\u0107 kolejno\u015b\u0107',
    lib_selected_count: 'Wybrano: {count}',
    lib_exit_select: 'Wyjd\u017a z trybu wyboru',
    lib_select_btn: 'Wybierz',
    lib_reorder_btn: 'Zmie\u0144 kolejno\u015b\u0107',
    lib_reorder_on: '✓ Tryb zmiany kolejno\u015bci W\u0141.',
    lib_show_details: 'Poka\u017c szczeg\u00f3\u0142y',
    lib_details_title: 'Szczeg\u00f3\u0142y zdj\u0119cia',
    lib_close_details: 'Zamknij szczeg\u00f3\u0142y',
    lib_close_details_aria: 'Zamknij szczeg\u00f3\u0142y zdj\u0119cia',
    lib_external_ref_badge: 'Zewn\u0119trzny link',
    lib_uploaded_badge: 'Wgrane zdj\u0119cie',
    lib_name_label: 'Nazwa',
    lib_source_url_label: '\u0179r\u00f3d\u0142owy URL',
    lib_edit_url: 'Edytuj URL',
    lib_save_url: 'Zapisz',
    lib_saving_url: 'Zapisywanie...',
    lib_url_load_error: 'Nie uda\u0142o si\u0119 za\u0142adowa\u0107 zdj\u0119cia z tego adresu',
    lib_url_ext_error: 'URL musi ko\u0144czy\u0107 si\u0119 na .jpg, .png, .webp lub .gif',
    lib_usage_label: 'Wykorzystanie',
    lib_used_in_n_moodboards: 'Wykorzystane w {count} moodboardzie',
    lib_used_in_n_moodboards_plural: 'Wykorzystane w {count} moodboardach',
    lib_boards_using: 'Tablice korzystaj\u0105ce z tego zdj\u0119cia',
    lib_tags_section_label: 'Tagi',
    lib_no_tags: 'Brak tag\u00f3w',
    lib_edit_tags: 'Edytuj tagi',
    lib_tags_comma_placeholder: 'Tagi oddzielone przecinkami',
    lib_delete_from_library: 'Usu\u0144 z biblioteki',
    lib_will_remove_from_n_boards: 'Usunie r\u00f3wnie\u017c z {count} tablicy',
    lib_will_remove_from_n_boards_plural: 'Usunie r\u00f3wnie\u017c z {count} tablic',
    lib_card_used_in_n: 'U\u017cywane w {count} tablicy',
    lib_card_used_in_n_plural: 'U\u017cywane w {count} tablicach',
    lib_card_broken_link: 'Zepsuty link',
    lib_card_external: 'Zewn\u0119trzne',
    lib_card_demo: 'Przyk\u0142ad',
    lib_card_image_unavailable: 'Zdj\u0119cie niedost\u0119pne',
    lib_card_remove: 'Usu\u0144',
    lib_add_to_board_btn: '+ Tablica',
    // Library Collections (Phase 1/2)
    lib_collection_all: 'Wszystkie',
    lib_collection_uncategorized: 'Bez kategorii',
    lib_collection_new: 'Nowa kolekcja',
    lib_collection_new_placeholder: 'Nazwa kolekcji',
    lib_collection_rename: 'Zmie\u0144 nazw\u0119',
    lib_collection_delete: 'Usu\u0144',
    lib_collection_delete_confirm: 'Usun\u0105\u0107 t\u0119 kolekcj\u0119? Zdj\u0119cia pozostan\u0105 w bibliotece.',
    lib_add_to_board_short: 'Tablica',
    lib_pin_used_singular: 'W 1 tablicy',
    lib_pin_used_plural: 'W {count} tablicach',
    // Library Preview Modal (Phase 3)
    lib_preview_title_label: 'Referencja',
    lib_preview_untitled: 'Referencja bez tytu\u0142u',
    lib_preview_source_label: '\u0179r\u00f3d\u0142o',
    lib_preview_source_uploaded: 'Wgrane do biblioteki',
    lib_preview_source_external: 'Zewn\u0119trzny link',
    lib_preview_collections_label: 'Kolekcje',
    lib_preview_no_collections: 'Nie nale\u017cy do \u017cadnej kolekcji.',
    lib_preview_tags_label: 'Tagi',
    lib_preview_no_tags: 'Brak tag\u00f3w.',
    lib_preview_usage_label: 'Wykorzystanie',
    lib_preview_unused: 'Jeszcze nieu\u017cywane w \u017cadnej tablicy.',
    lib_preview_edit: 'Edytuj',
    lib_preview_done: 'Gotowe',
    lib_preview_action_add_to_board: 'Dodaj do tablicy',
    lib_preview_action_edit: 'Edytuj',
    lib_preview_action_download: 'Pobierz',
    lib_preview_action_delete: 'Usu\u0144',
    // Bulk Action Bar (Phase 4)
    lib_bulk_selected_singular: 'wybrano',
    lib_bulk_selected_plural: 'wybrano',
    lib_bulk_select_all: 'Zaznacz wszystko',
    lib_bulk_add_to_collection: 'Dodaj do kolekcji',
    lib_bulk_manage_collections: 'Zarz\u0105dzaj kolekcjami',
    lib_bulk_move_here: 'Przenie\u015b',
    lib_bulk_move_confirm: 'Przenie\u015b\u0107 {count} obraz(\u00f3w) do \u201e{name}\u201d? Zostan\u0105 usuni\u0119te ze wszystkich pozosta\u0142ych kolekcji.',
    toast_bulk_moved_to_collection: 'Przeniesiono {count} do {name}.',
    toast_bulk_removed_from_collection: 'Usuni\u0119to {count} z {name}.',
    lib_bulk_add_to_board: 'Dodaj do tablicy',
    lib_bulk_new_board: 'Nowa tablica',
    // Duplicates finder
    lib_find_duplicates: 'Znajd\u017a duplikaty',
    lib_duplicates_eyebrow: 'Porz\u0105dek w bibliotece',
    lib_duplicates_title: 'Znajd\u017a duplikaty',
    lib_duplicates_scanning: 'Skanowanie biblioteki...',
    lib_duplicates_none: 'Twoja biblioteka jest czysta \u2014 nie znaleziono duplikat\u00f3w.',
    lib_duplicates_found: 'Znaleziono {dup} duplikat\u00f3w w {groups} grupach.',
    lib_duplicates_description: 'W ka\u017cdej grupie zachowamy najstarsze zdj\u0119cie. Tagi i kolekcje z pozosta\u0142ych kopii zostan\u0105 przeniesione na oryginale. Tablice klienta, kt\u00f3re u\u017cywa\u0142y duplikatu, zostan\u0105 przepi\u0119te na oryginale \u2014 bez utraty imagerii.',
    lib_duplicates_same_file: 'ten sam plik',
    lib_duplicates_same_url: 'ten sam link',
    lib_duplicates_same_filename: 'ta sama nazwa pliku',
    lib_duplicates_more_groups: '+ {n} kolejnych grup...',
    lib_duplicates_confirm: 'Usu\u0144 duplikaty',
    lib_duplicates_removing: 'Usuwanie...',
    lib_duplicates_ok: 'OK',
    toast_duplicates_removed: 'Usuni\u0119to {count} duplikat\u00f3w.',
    toast_duplicates_failed: 'Nie uda\u0142o si\u0119 usun\u0105\u0107 duplikat\u00f3w.',
    lib_bulk_no_collections: 'Brak kolekcji.',
    lib_bulk_add_tags: 'Dodaj tagi',
    lib_bulk_remove_tags: 'Usu\u0144 tagi',
    lib_bulk_tag_placeholder: 'tag1, tag2, ...',
    lib_bulk_tag_hint: 'Rozdzielone przecinkiem',
    lib_bulk_apply: 'Zastosuj',
    lib_bulk_delete: 'Usu\u0144',
    lib_bulk_cancel: 'Anuluj',
    toast_bulk_added_to_collection: 'Dodano {count} do {name}.',
    toast_bulk_tags_added: 'Otagowano {count} zdj\u0119\u0107.',
    toast_bulk_tags_removed: 'Usuni\u0119to tagi z {count} zdj\u0119\u0107.',
    toast_bulk_action_failed: 'Nie uda\u0142o si\u0119 zaktualizowa\u0107.',
    lib_add_tag_title: 'Dodaj tag',
    lib_add_tag_placeholder: 'Dodaj tag...',
    lib_board_selector_title: 'Dodaj do tablicy',
    lib_board_selector_single: 'Wybierz tablic\u0119 dla tego zdj\u0119cia',
    lib_board_selector_bulk: 'Dodaj {count} zdj\u0119cie do tablicy',
    lib_board_selector_bulk_plural: 'Dodaj {count} zdj\u0119\u0107 do tablicy',
    lib_no_active_boards: 'Brak aktywnych tablic.',
    lib_create_new_board: 'Stw\u00f3rz now\u0105 tablic\u0119',
    lib_new_board_btn: '+ Nowa tablica',
    lib_no_client_label: 'Brak klienta',
    lib_images_label: 'zdj\u0119\u0107',
    lib_create_board_title: 'Stw\u00f3rz now\u0105 tablic\u0119',
    lib_create_board_with_selection: 'Nowa tablica zostanie utworzona z {count} wybranym zdj\u0119ciem.',
    lib_create_board_with_selection_plural: 'Nowa tablica zostanie utworzona z {count} wybranymi zdj\u0119ciami.',
    lib_create_board_with_one: 'Nowa tablica zostanie utworzona z 1 zdj\u0119ciem.',
    lib_create_board_empty: 'Stw\u00f3rz pust\u0105 tablic\u0119.',
    lib_board_name_label: 'Nazwa tablicy *',
    lib_board_name_placeholder: 'np. Wiosenna kolekcja — Anna',
    lib_client_name_label: 'Imi\u0119 klientki/klienta',
    lib_client_name_placeholder: 'np. Anna Kowalska',
    lib_creating: 'Tworzenie...',
    lib_create_board: 'Stw\u00f3rz tablic\u0119',
    lib_board_created_title: 'Tablica utworzona',
    lib_board_created_text: '{name} utworzono z {count} zdj\u0119ciem.',
    lib_board_created_text_plural: '{name} utworzono z {count} zdj\u0119ciami.',
    lib_stay_in_library: 'Zosta\u0144 w bibliotece',
    lib_open_board: 'Otw\u00f3rz tablic\u0119',
    lib_delete_title: 'Usun\u0105\u0107 z biblioteki?',
    lib_delete_used_warning: 'To zdj\u0119cie jest wykorzystywane w {count} moodboardzie. Usuni\u0119cie zdj\u0119cia usunie je ze wszystkich tablic.',
    lib_delete_used_warning_plural: 'To zdj\u0119cie jest wykorzystywane w {count} moodboardach. Usuni\u0119cie zdj\u0119cia usunie je ze wszystkich tablic.',
    lib_delete_unused_text: 'Trwale usunie zdj\u0119cie z Twojej biblioteki.',
    lib_bulk_delete_title: 'Usun\u0105\u0107 {count} wybrane zdj\u0119cie z biblioteki?',
    lib_bulk_delete_title_plural: 'Usun\u0105\u0107 {count} wybranych zdj\u0119\u0107 z biblioteki?',
    lib_bulk_delete_all_used: 'Wszystkie {count} wybranych zdj\u0119\u0107 s\u0105 obecnie u\u017cywane w tablicach. Nic nie zostanie usuni\u0119te.',
    lib_bulk_delete_some: 'Trwale usunie {count} nieu\u017cywane zdj\u0119cie z biblioteki.',
    lib_bulk_delete_some_plural: 'Trwale usunie {count} nieu\u017cywanych zdj\u0119\u0107 z biblioteki.',
    lib_bulk_delete_skipped: '{count} wybrane zdj\u0119cie jest u\u017cywane w tablicach i zostanie pomini\u0119te.',
    lib_bulk_delete_skipped_plural: '{count} wybranych zdj\u0119\u0107 jest u\u017cywanych w tablicach i zostan\u0105 pomini\u0119te.',
    lib_deleting: 'Usuwanie...',
    lib_delete_n: 'Usu\u0144 {count}',
    lib_dup_title: 'Znaleziono duplikat',
    lib_dup_text: 'To zdj\u0119cie ju\u017c istnieje w Twojej bibliotece.',
    lib_dup_used_in_n: 'U\u017cywane w {count} tablicy',
    lib_dup_used_in_n_plural: 'U\u017cywane w {count} tablicach',
    lib_dup_add_tags_label: 'Dodaj tagi do istniej\u0105cego zdj\u0119cia (opcjonalnie)',
    lib_dup_tag_placeholder: 'np. \u015blub, plener',
    lib_dup_upload_anyway: 'Wgraj mimo to',
    lib_dup_use_existing: 'U\u017cyj istniej\u0105cego',

    // ── CreateBoardModal ─────────────────────────────────────────────
    cbm_title: 'Stw\u00f3rz nowy moodboard',
    cbm_board_name: 'Nazwa tablicy',
    cbm_board_name_placeholder: 'np. Wiosenna kolekcja 2026',
    cbm_client_name: 'Imi\u0119 klientki/klienta',
    cbm_client_name_placeholder: 'np. Anna Kowalska',
    cbm_project_date: 'Data sesji (opcjonalnie)',
    cbm_autolock_hint: 'Tablica zablokuje si\u0119 automatycznie przed t\u0105 dat\u0105',
    cbm_link_expires: 'Link wygasa po',
    cbm_lock_before: 'Zablokuj przed dat\u0105 sesji',
    cbm_days: '{n} dni',
    cbm_editable_later: 'Te ustawienia mo\u017cesz p\u00f3\u017aniej zmieni\u0107 w ustawieniach tablicy.',
    cbm_creating: 'Tworzenie...',
    cbm_create_board: 'Stw\u00f3rz tablic\u0119',
    // ── Board Type selection ─────────────────────────────────────────
    cbm_board_type_label: 'Typ tablicy',
    cbm_board_type_client: 'Tablica Klienta',
    cbm_board_type_client_desc: 'Wsp\u00f3\u0142pracuj z klientem, zbieraj opinie i finalizuj decyzje.',
    cbm_board_type_inspiration: 'Tablica Inspiracji',
    cbm_board_type_inspiration_desc: 'Zaprezentuj koncept, nastr\u00f3j, styl lub kierunek wizualny.',
    bs_board_type_panel_title: 'Typ tablicy',
    bs_board_type_inspiration_summary: 'Wyselekcjonowana, tylko prezentacyjna tablica — bez funkcji wsp\u00f3\u0142pracy.',
    bs_board_type_client_summary: 'Pe\u0142na tablica wsp\u00f3\u0142pracy z opiniami, decyzjami i dokumentami.',
    bs_convert_to_client_btn: 'Przekszta\u0142\u0107 w Tablic\u0119 Klienta',
    bs_convert_confirm: 'Przekszta\u0142ci\u0107 t\u0119 Tablic\u0119 Inspiracji w Tablic\u0119 Klienta? W\u0142\u0105czy to komentarze, uploady, dokumenty i workflow akceptacji.',
    bs_converting: 'Przekszta\u0142canie...',
    bs_convert_success: 'Tablica przekszta\u0142cona w Tablic\u0119 Klienta.',
    bs_inspiration_features_hidden: 'Te funkcje s\u0105 cz\u0119\u015bci\u0105 Tablicy Klienta. Przekszta\u0142\u0107 t\u0119 tablic\u0119, aby je w\u0142\u0105czy\u0107.',
    concept_panel_title: 'Koncept',
    concept_panel_desc: 'Kr\u00f3tki opis wy\u015bwietlany u g\u00f3ry tablicy — nastr\u00f3j, historia lub kierunek tego konceptu.',
    concept_description_label: 'Opis konceptu',
    concept_description_placeholder: 'np. Studium mi\u0119kkiego popo\u0142udniowego \u015bwiat\u0142a i naturalnych materia\u0142\u00f3w do edytorialnych portret\u00f3w.',
    concept_description_hint: 'Wy\u015bwietlany u g\u00f3ry tablicy, pod tytu\u0142em.',
    dash_section_client_title: 'TABLICE KLIENTA',
    dash_section_client_subtitle: 'Aktywne projekty i wsp\u00f3\u0142praca z klientem — opinie, decyzje i workflowy.',
    dash_section_inspiration_title: 'TABLICE INSPIRACJI',
    dash_section_inspiration_subtitle: 'Koncepty, portfolio i kierunki wizualne.',
    dash_empty_client: 'Stw\u00f3rz swoj\u0105 pierwsz\u0105 Tablic\u0119 Klienta.',
    dash_empty_inspiration: 'Stw\u00f3rz swoj\u0105 pierwsz\u0105 Tablic\u0119 Inspiracji.',

    // ── LibraryModal (Choose from Library) ───────────────────────────
    lm_title: 'Wybierz z biblioteki',
    lm_subtitle: 'Zaznacz kilka zdj\u0119\u0107, aby doda\u0107 je naraz',
    lm_no_match: 'Brak zdj\u0119\u0107 pasuj\u0105cych do filtr\u00f3w',
    lm_empty: 'Twoja biblioteka jest pusta',
    lm_clear_filters: 'Wyczy\u015b\u0107 filtry',
    lm_select_status_count: '{count}{plus} zdj\u0119\u0107 · Dotknij, aby zaznaczy\u0107',
    lm_select_status_one: 'Wybrano {count} zdj\u0119cie',
    lm_select_status_many: 'Wybrano {count} zdj\u0119\u0107',
    lm_select_visible: 'Zaznacz widoczne',
    lm_clear: 'Wyczy\u015b\u0107',
    lm_load_more: 'Za\u0142aduj wi\u0119cej zdj\u0119\u0107',
    lm_section_label_for_selected: 'Etykieta sekcji dla wybranych zdj\u0119\u0107',
    lm_section_none: 'Brak (bez etykiety)',
    lm_section_helper: 'Wszystkie zaznaczone zdj\u0119cia zostan\u0105 dodane z t\u0105 etykiet\u0105',
    lm_select_images_btn: 'Wybierz zdj\u0119cia',
    lm_add_one_to_board: 'Dodaj {count} zdj\u0119cie do tablicy',
    lm_add_many_to_board: 'Dodaj {count} zdj\u0119\u0107 do tablicy',
    lm_density_label: 'G\u0119sto\u015b\u0107',
    lm_density_comfortable: 'Komfortowo',
    lm_density_compact: 'Kompaktowo',
    lm_density_tiny: 'Drobno',
    lm_filters_btn: 'Filtry',
    lm_close_aria: 'Zamknij',
    lm_ext_badge: 'Zew',
    lm_preview_aria: 'Podejrzyj w pe\u0142nym rozmiarze',
    lm_preview_close: 'Zamknij podgl\u0105d',
    lm_preview_select: 'Wybierz to zdj\u0119cie',
    lm_preview_deselect: 'Odznacz',
    lm_preview_no_tags: 'Brak tag\u00f3w',
    notes_jump_to_input: 'Dodaj now\u0105 notatk\u0119',
    nav_inspirations: 'Inspiracje',
    nav_gallery: 'Galeria',
    nav_final_decisions: 'Wyb\u00f3r fina\u0142owy',
    nav_notes: 'Notatki',
    nav_documents: 'Dokumenty',
    lib_floating_n_selected: 'Wybrano {count} zdj\u0119cie',
    lib_floating_n_selected_plural: 'Wybrano {count} zdj\u0119\u0107',
    lib_select_all: 'Zaznacz wszystko',
    lib_deselect_all: 'Odznacz wszystko',
    lib_add_to_board: 'Dodaj do tablicy',
    lib_new_board_short: 'Nowa tablica',
    lib_delete_selected: 'Usu\u0144 zaznaczone',

    // ── Library toasts ───────────────────────────────────────────────
    toast_image_reused: 'Zdj\u0119cie wykorzystane ponownie',
    toast_more_images_added: 'Dodano kolejnych {count} zdj\u0119\u0107 do biblioteki',
    toast_some_uploads_failed: 'Niekt\u00f3re uploady si\u0119 nie powiod\u0142y',
    toast_images_added: 'Dodano {count} zdj\u0119\u0107 do biblioteki',
    toast_upload_failed: 'Upload nie powi\u00f3d\u0142 si\u0119',
    toast_added_to_board_one: 'Dodano {count} zdj\u0119cie do „{board}"',
    toast_added_to_board_many: 'Dodano {count} zdj\u0119\u0107 do „{board}"',
    toast_add_to_board_failed: 'Nie uda\u0142o si\u0119 doda\u0107 zdj\u0119\u0107 do tablicy',
    toast_board_limit_reached: 'Osi\u0105gni\u0119to bie\u017c\u0105cy limit tablic.',
    toast_create_board_failed: 'Nie uda\u0142o si\u0119 utworzy\u0107 tablicy',
    toast_reorder_failed: 'Nie uda\u0142o si\u0119 zmieni\u0107 kolejno\u015bci zdj\u0119\u0107',
    toast_image_deleted_with_boards: 'Zdj\u0119cie usuni\u0119te i wyj\u0119te z {count} tablicy/tablic',
    toast_image_deleted: 'Zdj\u0119cie usuni\u0119te',
    toast_delete_failed: 'Nie uda\u0142o si\u0119 usun\u0105\u0107 zdj\u0119cia',
    toast_bulk_deleted_with_skipped: 'Usuni\u0119to {count} zdj\u0119\u0107. {skipped} w u\u017cyciu — pomini\u0119to.',
    toast_bulk_all_used: 'Wybrane zdj\u0119cia s\u0105 u\u017cywane w tablicach i nie zosta\u0142y usuni\u0119te.',
    toast_bulk_deleted: 'Usuni\u0119to {count} zdj\u0119\u0107 z biblioteki',
    toast_bulk_no_deleted: 'Nie usuni\u0119to \u017cadnych zdj\u0119\u0107',
    toast_bulk_delete_failed: 'Masowe usuwanie nie powiod\u0142o si\u0119',
    toast_tags_updated: 'Tagi zaktualizowane',
    toast_tags_update_failed: 'Nie uda\u0142o si\u0119 zaktualizowa\u0107 tag\u00f3w',
    toast_url_updated: 'URL zdj\u0119cia zaktualizowany',
    toast_url_update_failed: 'Nie uda\u0142o si\u0119 zaktualizowa\u0107 URL',
    toast_library_export: 'Eksport biblioteki pobrany',
    toast_export_failed: 'Eksport nie powi\u00f3d\u0142 si\u0119',
    toast_external_added: 'Zewn\u0119trzne zdj\u0119cie dodane do biblioteki',
    toast_external_add_failed: 'Nie uda\u0142o si\u0119 doda\u0107 zewn\u0119trznego zdj\u0119cia',

    // ── BatchUploadStatus ────────────────────────────────────────────
    batch_uploading: 'Wysy\u0142anie',
    batch_x_of_y: '{done} z {total}',
    batch_n_failed: '{count} nieudanych',
    batch_n_remaining: 'Pozosta\u0142o: {count}…',
    batch_finishing: 'Ko\u0144czenie…',
    batch_upload_complete: 'Upload zako\u0144czony',
    batch_upload_finished: 'Upload zako\u0144czony',
    batch_dismiss_aria: 'Zamknij',
    batch_n_uploaded_one: 'Wgrano {count} zdj\u0119cie.',
    batch_n_uploaded_many: 'Wgrano {count} zdj\u0119\u0107.',
    batch_no_uploaded: 'Nie wgrano \u017cadnych zdj\u0119\u0107.',
    batch_n_failed_text: '{count} nieudanych.',
    batch_generic_error: 'Kilku plik\u00f3w nie uda\u0142o si\u0119 wgra\u0107. Mo\u017cesz je przejrze\u0107 i ponowi\u0107 te, kt\u00f3re chcesz zachowa\u0107.',
    batch_show_details: 'Poka\u017c szczeg\u00f3\u0142y ▾',
    batch_hide_details: 'Ukryj szczeg\u00f3\u0142y ▴',
    batch_more: '+ {count} wi\u0119cej',
    batch_retry_failed: 'Pon\u00f3w nieudane',
    batch_close: 'Zamknij',
    batch_dismiss: 'Zamknij',
    batch_failed_fallback: 'nieudane',
    batch_upload_failed_fallback: 'Upload nie powi\u00f3d\u0142 si\u0119',
  },

  de: {
    studio_name: 'Maestra',
    moodboards: 'Moodboards',
    image_library: 'Bilderbibliothek',
    new_board: '+ Neues Board',
    sign_out: 'Abmelden',
    no_boards_title: 'Noch keine Moodboards',
    no_boards_text: 'Erstelle dein erstes Moodboard, um visuelle Erlebnisse f\u00fcr deine Kunden zu kuratieren.',
    create_first_board: 'Erstes Board erstellen',
    duplicate: 'Duplizieren',
    delete: 'L\u00f6schen',
    images: 'Bilder',
    expires: 'L\u00e4uft ab',
    settings: 'Einstellungen',
    export_pdf: 'PDF Export',
    backup_zip: 'Backup ZIP',
    exports_panel_subtitle: 'Das fertige Moodboard, bereit zum Teilen.',
    export_pdf_subtitle: 'Für Ihren Kunden.',
    backup_zip_subtitle: 'Für Ihr Archiv.',
    pdf_quota_remaining: '{remaining} von {limit} PDF-Exports übrig',
    zip_quota_remaining: '{remaining} von {limit} Backups übrig',
    lock_board: 'Board sperren',
    unlock_board: 'Board entsperren',
    board_settings: 'Board-Einstellungen',
    boards_settings_title: 'Board-Einstellungen',
    boards_settings_subtitle: 'Wie deine Kunden jedes Board erleben — Atmosphäre, Texte und Fußzeile.',
    boards_settings_back: 'Boards',
    boards_settings_locked: 'Die Board-Anpassung ist in deinem aktuellen Plan nicht verfügbar.',
    workspace_board_settings_hint: 'Farben, Texte der Kundenansicht und die Fußzeile findest du in den Board-Einstellungen im Modul Boards.',
    open_board_settings: 'Board-Einstellungen öffnen',
    workspace_logo_managed_hint: 'Das Logo selbst wird in den Workspace-Einstellungen verwaltet.',
    open_workspace_settings: 'Workspace-Einstellungen',
    cr_title: 'Creator Space',
    cr_eyebrow: 'Dein externes Ged\u00e4chtnis',
    cr_sub: 'Erst festhalten. Sp\u00e4ter ordnen.',
    cr_back: 'Workspace',
    cr_capture_placeholder: 'Was geht dir durch den Kopf? Einfach festhalten\u2026',
    cr_capture_btn: 'Festhalten',
    cr_captured: 'Im Brain Dump gespeichert',
    cr_today: 'Heute',
    cr_this_week: 'Diese Woche',
    cr_waiting: 'Warten auf',
    cr_areas: 'Bereiche',
    cr_today_empty: 'Heute braucht dich nichts.',
    cr_week_empty: 'Eine ruhige Woche liegt vor dir.',
    cr_waiting_empty: 'Nichts wartet auf andere.',
    cr_area_empty: 'Hier ist noch nichts.',
    cr_search_placeholder: 'Alles durchsuchen, auch die Historie\u2026',
    cr_no_results: 'Nichts gefunden.',
    cr_results_for: 'Ergebnisse f\u00fcr',
    cr_evolution: 'Evolution',
    cr_created: 'Erstellt',
    cr_last_edited: 'Zuletzt bearbeitet',
    cr_add_note: 'Weiterdenken\u2026',
    cr_add_decision: 'Als Entscheidung speichern',
    cr_note_placeholder: 'F\u00fcge einen Gedanken hinzu \u2014 fr\u00fchere werden nie \u00fcberschrieben\u2026',
    cr_type: 'Typ',
    cr_area: 'Bereich',
    cr_due: 'F\u00e4llig',
    cr_mark_done: 'Erledigt',
    cr_reopen: 'Wieder \u00f6ffnen',
    cr_delete: 'L\u00f6schen',
    cr_delete_confirm: 'Diesen Eintrag mit seiner ganzen Historie l\u00f6schen?',
    cr_no_type: 'Gedanke',
    cr_type_task: 'Aufgabe',
    cr_type_idea: 'Idee',
    cr_type_project: 'Projekt',
    cr_type_waiting: 'Warten',
    cr_type_decision: 'Entscheidung',
    cr_type_reference: 'Referenz',
    cr_evo_created: 'Erste Idee',
    cr_evo_note: 'Hinzugef\u00fcgt',
    cr_evo_decision: 'Entscheidung',
    cr_evo_moved: 'Verschoben',
    cr_evo_status: 'Status',
    cr_evo_edit: 'Bearbeitet',
    cr_open: 'Offen',
    cr_done: 'Erledigt',
    cr_all: 'Alle',
    cr_save: 'Speichern',
    cr_decided: 'Entschieden',
    cr_todo: 'Zu erledigen',
    cr_ideas_parked: 'Geparkte Ideen',
    cr_other_items: 'Weitere',
    cr_project_label: 'Projekt',
    cr_no_project: 'Kein',
    cr_part_of: 'Teil von',
    cr_add_decided_ph: 'Entscheidung hinzuf\u00fcgen\u2026',
    cr_add_todo_ph: 'Aufgabe hinzuf\u00fcgen\u2026',
    cr_add_idea_ph: 'Idee parken\u2026',
    cr_evo_project: 'Projekt zugewiesen',
    cr_evo_project_removed: 'Vom Projekt gel\u00f6st',
    cr_evo_completed: 'Erledigt',
    cr_evo_reopened: 'Wieder ge\u00f6ffnet',
    cr_evo_direction: 'Richtung',
    cr_direction: 'Aktuelle Richtung',
    cr_direction_ph: 'Wohin f\u00fchrt das?\u2026',
    cr_direction_empty: 'Noch keine Richtung \u2014 halte fest, wohin es f\u00fchrt.',
    cr_related: 'Verkn\u00fcpfte Eintr\u00e4ge',
    cr_recent_decisions: 'Zuletzt entschieden',
    cr_recent_activity: 'Letzte Aktivit\u00e4t',
    cr_your_timeline: 'Deine Zeitachse',
    cr_no_decisions: 'Noch keine Entscheidungen \u2014 sie sammeln sich hier.',
    cr_no_timeline: 'Ein ruhiger Monat \u2014 hier wurde nichts festgehalten.',
    cr_whats_on_mind: 'Was geht dir durch den Kopf?',
    cr_capture_hint: 'Es landet im Brain Dump. Ordnen kannst du sp\u00e4ter.',
    cr_continue_where: 'Mach weiter, wo du aufgeh\u00f6rt hast',
    cr_continue: 'Weiter',
    cr_open_entries: 'offene Eintr\u00e4ge',
    cr_active_projects: 'Projekte',
    cr_areas_intro: 'Eigene R\u00e4ume f\u00fcr jeden Teil deines Lebens und deiner Arbeit.',
    cr_nav_overview: '\u00dcbersicht',
    cr_nav_projects: 'Projekte',
    cr_nav_todo: 'Zu erledigen',
    cr_nav_ideas: 'Notizen & Ideen',
    cr_current: 'Aktuell',
    cr_superseded: 'Ersetzt',
    cr_superseded_plural: 'ersetzt',
    cr_mark_superseded: 'Als ersetzt markieren',
    cr_make_current: 'Wieder aktuell machen',
    cr_area_desc_brain_dump: 'Dein externer Eingang. Halte jeden Gedanken sofort fest \u2014 ordnen kannst du sp\u00e4ter. Nichts muss schon kategorisiert sein.',
    cr_area_desc_ecru: 'Ideen, Marketing, Angebote, Fotografie, Brand Aesthetic, Celebration Styling und alles rund um dein kreatives Business.',
    cr_area_desc_home: 'Haushaltsaufgaben, Eink\u00e4ufe, Reparaturen, Organisation, Dokumente und alles rund um dein Zuhause.',
    cr_area_desc_nataniel: 'Schule, Termine, Aktivit\u00e4ten, Eink\u00e4ufe, Dokumente, Ideen und alles rund um dein Kind.',
    cr_area_desc_money: 'Rechnungen, Abos, Zahlungen, monatliche Ausgaben, Finanzen und Dinge zum Pr\u00fcfen oder K\u00fcndigen.',
    cr_area_desc_life_admin: 'Beh\u00f6rden, Versicherungen, Vertr\u00e4ge, Briefe, Verwaltung und alles, was das Leben am Laufen h\u00e4lt.',
    cr_area_desc_idea_vault: 'Ideen, die es wert sind, f\u00fcr die Zukunft aufbewahrt zu werden. Kein Druck, heute zu handeln.',
    cr_area_desc_wishlist: 'Dinge, die du kaufen m\u00f6chtest \u2014 f\u00fcr Zuhause, Studio, Business oder dich selbst. Mit Links, Priorit\u00e4ten und Notizen.',
    cr_area_desc_this_month: 'Vor\u00fcbergehende Priorit\u00e4ten und Aufgaben, die nur diesen Monat z\u00e4hlen. Regelm\u00e4\u00dfig durchsehen und aufr\u00e4umen.',
    cr_area_desc_someday: 'Ideen, Tr\u00e4ume und Pl\u00e4ne f\u00fcr die Zukunft. Heute keine Priorit\u00e4t, aber wert, erinnert zu werden.',
    board_name: 'Board-Name',
    client_name: 'Kundenname',
    session_date: 'Projektdatum',
    link_expiration: 'Link-Ablauf (Tage)',
    auto_lock: 'Auto-Sperre vor Projektdatum (Tage)',
    final_decision_mode: 'Finale Auswahl',
    final_decision_desc: 'Sch\u00fctze finale Auswahlen \u00fcber eine sichere E-Mail-Einladung an deinen Kunden.',
    final_enabled: 'Aktiviert \u2014 Kunde kann ausw\u00e4hlen',
    final_enable: 'F\u00fcr Kunden aktivieren',
    fd_status_active: 'Finale Auswahl aktiv',
    fd_status_inactive: 'Finale Auswahl inaktiv',
    fd_enable_cta: 'Sichere finale Freigabe aktivieren',
    fd_disable_cta: 'Finale Auswahl deaktivieren',
    fd_resend: 'Einladung erneut senden',
    fd_revoke: 'Zugang widerrufen',
    fd_modal_title: 'Sichere finale Freigabe aktivieren',
    fd_modal_body: 'Finale Auswahlen erfordern einen sicheren Kundenzugang.\n\nDein Kunde erh\u00e4lt eine private Einladungs-E-Mail.\nAlle finalen Entscheidungen werden mit der Identit\u00e4t verkn\u00fcpft.',
    fd_modal_email_label: 'Kunden-E-Mail',
    fd_modal_send: 'Einladung senden',
    fd_modal_cancel: 'Abbrechen',
    fd_invited_label: 'Eingeladen',
    fd_client_label: 'Kunde',
    fd_resecure_banner_title: 'Dieses Board erneut sichern',
    fd_resecure_banner_body: 'Die finale Auswahl war zuvor ohne sichere Einladung aktiviert. Sende deinem Kunden eine private E-Mail, um fortzufahren.',
    fd_resecure_banner_cta: 'Einladung senden',
    fd_audit_title: 'Freigabe-Aktivit\u00e4t',
    fd_audit_show: 'Aktivit\u00e4t anzeigen',
    fd_audit_hide: 'Aktivit\u00e4t ausblenden',
    fd_audit_empty: 'Noch keine Freigabe-Aktivit\u00e4t.',
    fd_audit_invited: 'Einladung gesendet',
    fd_audit_resent: 'Einladung erneut gesendet',
    fd_audit_revoked: 'Zugang widerrufen',
    fd_audit_opened: 'Freigabe-Bereich ge\u00f6ffnet',
    fd_audit_marked_final: 'Als final markiert',
    fd_audit_unmarked_final: 'Aus Final entfernt',
    fd_audit_confirmed: 'Finale Richtung best\u00e4tigt',
    fd_audit_mode_disabled: 'Finale Auswahl deaktiviert',
    fd_invalid_email: 'Bitte gib eine g\u00fcltige E-Mail-Adresse ein.',
    fd_share_notice: 'Finale Auswahlen werden privat vom eingeladenen Kunden gepr\u00fcft.',
    final_decision_section_title: 'Finale Auswahlen',
    fd_open_only_via_email: 'Dieser Bereich ist privat. Bitte \u00f6ffne ihn aus der Einladungs-E-Mail.',
    fd_approval_eyebrow: 'Privater Freigabe-Bereich',
    fd_approval_signed_in_as: 'Angemeldet als',
    fd_approval_confirm_cta: 'Finale Richtung best\u00e4tigen',
    fd_approval_confirmed_at: 'Richtung best\u00e4tigt am',
    fd_approval_link_invalid: 'Dieser Freigabe-Link ist nicht mehr aktiv. Bitte frage dein Studio nach einer neuen Einladung.',
    fd_approval_intro: 'Du kannst deine finalen Favoriten markieren und die Richtung best\u00e4tigen, wenn du bereit bist.',
    fd_approval_change_hint: 'Du kannst deine Auswahl jederzeit \u00e4ndern. Tippe erneut auf eine Markierung, um sie zu entfernen, oder best\u00e4tige erneut, um den Zeitstempel zu aktualisieren.',
    fd_approval_reconfirm_cta: 'Finale Richtung aktualisieren',
    fd_mark_final: 'Als final markieren',
    fd_unmark_final: 'Aus Final entfernen',
    client_language: 'Kundensprache',
    client_language_desc: 'Sprache, die dem Kunden beim Betrachten dieses Boards angezeigt wird.',
    client_communication: 'Kundenkommunikation',
    client_communication_desc: 'Notizen und gemeinsamen Kommunikationsraum erlauben',
    notes_enabled: 'Notizen aktiviert',
    notes_hidden: 'Notizen ausgeblendet',
    exports: 'Exporte',
    actions: 'Aktionen',
    archive_board: 'Board archivieren',
    restore_board: 'Board wiederherstellen',
    delete_board: 'Board l\u00f6schen',
    workspace_language: 'Workspace-Sprache',
    days: 'Tage',
    settings_editable_later: 'Diese Einstellungen kannst du sp\u00e4ter in den Board-Einstellungen \u00e4ndern.',
    preview_as_client: 'Als Kunde ansehen',

    // BoardEditor chrome
    back: '← Zur\u00fcck',
    exporting: 'Exportieren...',
    generating: 'Erstellen...',
    export_stage_preparing: 'Bilder werden vorbereitet',
    export_stage_building: 'PDF wird erstellt',
    export_stage_finalizing: 'Datei wird fertiggestellt',
    export_stage_download: 'Download startet',
    export_long_wait_hint: 'Gro\u00dfe Boards k\u00f6nnen etwas l\u00e4nger dauern. Bitte halte dieses Fenster ge\u00f6ffnet.',
    export_failed_calm: 'Der Export konnte nicht abgeschlossen werden. Bitte versuche es gleich noch einmal.',
    client_link: 'Kunden-Link',
    status_open: 'Offen',
    status_active: 'Aktiv',
    status_expired: 'Abgelaufen',
    status_locked: 'Gesperrt',
    available_until: 'Verf\u00fcgbar bis',
    closed_on: 'Geschlossen',
    extend: 'Verl\u00e4ngern',
    reopen_board: 'Board wieder \u00f6ffnen',
    show_link: 'Link anzeigen',
    hide_link: 'Link verbergen',
    copy_link: 'Link kopieren',
    copied: 'Kopiert',
    notify_client: 'Kunde benachrichtigen',
    add_client_email_to_notify: 'Kunden-Email f\u00fcr Benachrichtigung hinzuf\u00fcgen',
    note_to_client_title: 'Eine Notiz an deinen Kunden',
    note_to_client_subtitle: 'Optional. Eine pers\u00f6nliche Zeile \u00fcber deiner Galerie.',
    note_to_client_placeholder: 'Eine pers\u00f6nliche Notiz an deinen Kunden…',
    editing_ellipsis: 'Bearbeiten…',
    saving_ellipsis: 'Speichern…',
    saved: 'Gespeichert',
    shared_client_space: 'Gemeinsamer Kundenbereich',
    shared_client_space_subtitle: 'So erlebt dein Kunde das Board und die gemeinsame Richtung.',
    customize_client_view: 'Kundenansicht anpassen',
    cv_edit_mode_banner: 'Kundenansicht bearbeiten \u2014 klicke auf einen beliebigen Text',
    cv_edit_done: 'Fertig',
    cv_edit_continue_below: 'Weiter zum Board \u2193',
    save_failed: 'Konnte nicht gespeichert werden',
    inline_advanced_options: 'Erweitert \u25be',
    client_view_editor_eyebrow: 'KUNDENANSICHT-EDITOR',
    client_view_editor_title: 'Was dein Kunde sieht',
    client_view_editor_subtitle: 'Gestalte das genaue Erlebnis \u2014 \u00c4nderungen werden sofort gespeichert.',
    client_view_editor_sections_soon: 'Dieses Panel enth\u00e4lt Sichtbarkeit, Reihenfolge und erweiterte Optionen. Alle Texte werden direkt auf der Seite bearbeitet.',
    cve_sections_eyebrow: 'ABSCHNITTE',
    cve_sections_help: 'Zeige, verstecke und ordne die Abschnitte, die dein Kunde sieht. Titel und Beschreibungen werden direkt auf der Seite bearbeitet.',
    cve_section_title_label: 'Abschnitts-Titel',
    cve_section_description_label: 'Abschnitts-Beschreibung',
    card_gallery_section: 'Galerie',
    cve_gallery_title_placeholder: 'Optionale \u00dcberschrift \u00fcber den Bildern',
    cve_gallery_description_placeholder: 'Optionaler Kontext \u2014 eine kurze Zeile unter der \u00dcberschrift',
    cve_use_workspace_defaults: 'Workspace-Standards verwenden',
    cve_workspace_defaults_on_hint: 'Abschnittsnamen kommen aus Branding \u2192 Kundenansicht-Texte. Ausschalten, um nur dieses Board anzupassen.',
    cve_workspace_defaults_off_hint: 'Dieses Board verwendet eigene Abschnittsnamen und -beschreibungen.',
    cve_workspace_defaults_locked_hint: 'Verf\u00fcgbar in Pro und Signature. Auf deinem aktuellen Plan erben alle Boards die Workspace-Standards.',
    cve_inherits_workspace_default: 'Erbt den Workspace-Standard.',
    inline_section_locked_hint: 'Erbt den Workspace-Standard. Schalte \u201eWorkspace-Standards verwenden\u201c unter Erweitert aus, um dieses Board anzupassen.',
    inline_texts_on_page_hint: 'Titel und Texte werden direkt auf der Seite bearbeitet.',
    cve_drag_section: 'Abschnitt neu anordnen',
    cve_reorder_hint: 'Zieh am ⋮⋮ um Abschnitte neu anzuordnen.',
    gallery_add_section: 'Abschnitt hinzuf\u00fcgen',
    gallery_new_section_default_title: 'Neuer Abschnitt',
    gallery_section_delete: 'Abschnitt l\u00f6schen',
    gallery_section_drag: 'Abschnitt neu anordnen',
    gallery_section_desc_placeholder: 'Optionale Beschreibung',
    gallery_section_empty_hint: 'Nutze \u201eIn Abschnitt verschieben\u201d bei einem Bild, um es hier zu platzieren.',
    gallery_section_delete_confirm: 'Diesen Abschnitt l\u00f6schen? Die Bilder bleiben auf dem Board und wandern zu \u201eOhne Kategorie\u201d.',
    card_final_decision_section: 'Final Decision',
    cve_fd_active_hint: 'Das Final-Decision-Banner ist ein Systemhinweis und nicht bearbeitbar.',
    private_space_title: 'Privater Bereich',
    private_space_hint: 'Nur für dich sichtbar',
    private_notes_title: 'Private Notizen',
    private_add_note: 'Notiz hinzufügen',
    private_note_title_placeholder: 'Titel der Notiz',
    private_note_placeholder: 'Schreibe alles auf — Ideen, Shotlist, Erinnerungen…',
    private_empty_notes: 'Noch keine Notizen — Ideen, Shotlists, Erinnerungen.',
    private_todo_title: 'To-Do / Erinnerungen',
    private_todo_placeholder: 'Aufgabe eingeben und Enter drücken',
    private_gallery_title: 'Private Galerie',
    private_gallery_hint: 'Bilder & Inspiration, die nur du siehst.',
    private_add_images: 'Bilder hinzufügen',
    private_delete: 'Löschen',
    attach_from: 'Anh\u00e4ngen:',
    attach_document: 'Dokument',
    attach_gallery: 'Board-Bilder',
    attach_confirm: 'Anh\u00e4ngen',
    view_board_card: 'Board ansehen',
    attachment_removed: 'Dokument wurde entfernt',
    doc_link: 'Link',
    no_documents_yet: 'Noch keine Dokumente auf diesem Board',
    filter_active: 'Aktive',
    filter_expired: 'Abgelaufene',
    filter_all: 'Alle',
    // ── Client Space ──
    clients_nav: 'Kunden',
    cs_title: 'Client Space',
    cs_subtitle: 'Eine private Akte jeder Zusammenarbeit — Historie, Dokumente und Boards, immer griffbereit.',
    cs_back: 'Kunden',
    cs_back_dashboard: 'Workspace',
    cs_new_client: '+ Neuer Kunde',
    cs_new_client_title: 'Neuer Kunde',
    cs_no_clients_title: 'Noch keine Kunden',
    cs_no_clients: 'Lege die erste Kundenakte an — hier leben Historie, Dokumente und Boards.',
    cs_not_found: 'Kunde nicht gefunden.',
    cs_client_name: 'Name',
    cs_company: 'Firma (optional)',
    cs_email: 'E-Mail',
    cs_phone: 'Telefon',
    cs_address: 'Adresse',
    cs_address_optional: 'Adresse (optional — kannst du später ergänzen)',
    cs_meta_history: 'Einträge',
    cs_meta_boards: 'Boards',
    cs_important_info: 'Wichtige Informationen',
    cs_since: 'Zusammenarbeit seit',
    cs_open_record: 'Kundenakte',
    // ── Workspace dashboard & modules ──
    wd_library: 'Bibliothek',
    wd_library_desc: 'Alle deine Inspirationen, Bilder und Sammlungen.',
    wd_clients: 'Kunden',
    wd_clients_desc: 'Kundenakten, Historie, Dokumente und Erinnerungen.',
    wd_boards: 'Boards',
    wd_boards_desc: 'Arbeite mit Kunden zusammen und erwecke Ideen zum Leben.',
    wd_creator: 'Creator Space',
    wd_creator_desc: 'Dein Raum für Ideen, Planung und Wachstum.',
    wd_home: 'Start',
    wd_soon: 'Bald',
    wd_greet_morning: 'Guten Morgen',
    wd_greet_afternoon: 'Guten Tag',
    wd_greet_evening: 'Guten Abend',
    wd_workspace_sub: 'Das ist dein kreativer Workspace',
    wd_quote: 'Kreativität ist kein Luxus. Sie ist eine Lebensart.',
    wd_bell: 'Kundenaktivität',
    modules_section: 'Meine Module',
    module_on: 'An',
    module_off: 'Aus',
    modules_note: 'Ausgeschaltete Module verschwinden vollständig aus deinem Workspace. Die Bibliothek gehört zum Kern und bleibt immer.',
    wd_greeting: 'Willkommen in deinem Studio.',
    wd_enter: 'Eintreten',
    cs_add: 'Hinzufügen',
    cs_assign_short: 'Zuweisen',
    cs_create_short: '+ Neu',
    cs_boards_empty_short: 'Noch keine Boards — der Client Space funktioniert unabhängig, für Historie und Dokumente allein.',
    cs_important_info_hint: 'Alles, was man sich merken sollte — Vorlieben, Allergien, Vereinbarungen, Arbeitsweise…',
    cs_email_action: 'E-Mail',
    cs_call: 'Anrufen',
    cs_map: 'Karte',
    cs_tab_history: 'Historie',
    cs_tab_documents: 'Dokumente',
    cs_tab_boards: 'Boards',
    cs_search_history: 'In Titeln, Notizen, Tags suchen…',
    cs_search_clients: 'Kunden suchen…',
    cs_export_zip: 'ZIP exportieren',
    cs_export_client: 'Archiv herunterladen',
    cs_exporting: 'Wird vorbereitet…',
    cs_export_failed: 'Export fehlgeschlagen — bitte erneut versuchen.',
    cs_clients_no_results: 'Kein Kunde passt zu deiner Suche.',
    cs_add_entry: '+ Eintrag hinzufügen',
    cs_add_entry_title: 'Neuer Historieneintrag',
    cs_edit_entry: 'Eintrag bearbeiten',
    cs_history_empty: 'Die Geschichte dieser Zusammenarbeit beginnt hier — füge den ersten Eintrag hinzu.',
    cs_history_no_results: 'Nichts passt zu deiner Suche.',
    cs_entry_date: 'Datum',
    cs_entry_title: 'Titel',
    cs_entry_title_hint: 'z. B. Erstberatung, Lash Refill, Brand Workshop…',
    cs_entry_note: 'Notiz',
    cs_entry_tags: 'Tags (optional)',
    cs_entry_tags_hint: 'Tippen und Enter drücken',
    cs_entry_photos: 'Fotos (optional)',
    cs_entry_link_board: 'Verknüpftes Board (optional)',
    cs_entry_link_board_view: 'Board',
    cs_entry_link_documents: 'Verknüpfte Dokumente (optional)',
    cs_none: 'Keine',
    cs_created: 'Erstellt',
    cs_last_edited: 'Zuletzt bearbeitet',
    cs_edit_history: 'Bearbeitungsverlauf',
    cs_previous_version: 'Version bis',
    cs_delete_entry_confirm: 'Diesen Eintrag endgültig löschen?',
    cs_docs_empty: 'Verträge, Briefings, Inspirationsdateien — alles über diesen Kunden an einem ruhigen Ort.',
    cs_upload_document: '+ Dokument hochladen',
    cs_upload_failed: 'Upload fehlgeschlagen',
    cs_preview: 'Vorschau',
    cs_download: 'Herunterladen',
    cs_link_to_board: 'Mit Board verknüpfen',
    cs_unlink_relabel: 'Board-Link',
    cs_remove: 'Entfernen',
    cs_doc_remove_confirm: 'Dieses Dokument endgültig entfernen?',
    cs_boards_empty: 'Noch keine Boards zugewiesen. Der Client Space funktioniert unabhängig — führe hier Historie und Dokumente, auch ohne Board.',
    cs_create_board: '+ Board erstellen',
    cs_assign_board: 'Bestehendes Board zuweisen',
    cs_assign_pick: 'Board zuweisen',
    cs_no_assignable: 'Jedes Board ist bereits einem Kunden zugewiesen.',
    cs_unassign: 'Lösen',
    cs_board_created: 'Board erstellt',
    cs_board_assigned: 'Board zugewiesen',
    cs_delete_client: 'Kunde löschen',
    cs_delete_client_confirm: 'Diesen Kunden und die gesamte Akte löschen? Boards bleiben unberührt.',
    cs_save: 'Speichern',
    cs_cancel: 'Abbrechen',
    cs_create: 'Erstellen',
    cs_edit: 'Bearbeiten',
    cs_close: 'Schließen',
    cs_delete: 'Löschen',
    cs_deleted: 'Entfernt',
    cs_saved: 'Gespeichert',
    filter_empty: 'Nichts hier \u2014 passe den Filter oben an.',
    seen_label: 'Gesehen',
    cve_fd_inactive_hint: 'Final Decision wird \u00fcber den sicheren Einladungs-Flow aktiviert (Einstellungen \u2192 Final Decision).',
    preview_as_client_inline: 'Als Kunde ansehen',
    exit_client_preview: 'Vorschau beenden',
    back_to_editing: 'Zur\u00fcck zur Bearbeitung',
    client_preview_hint: 'Live-Vorschau \u2014 genau das sieht dein Kunde.',
    add_images: 'Bilder hinzuf\u00fcgen',
    add_images_subtitle: 'Hochladen, Bibliothek oder externe Inspiration',
    drop_to_upload: 'Zum Hochladen ablegen',
    drag_drop_or_click: 'Ziehen & ablegen oder klicken, um hochzuladen',
    from_library: 'Aus Bibliothek',
    add_via_link: 'Per Link hinzuf\u00fcgen',
    also_save_uploads: 'Uploads auch in Bibliothek speichern',
    reorder_images: 'Bilder neu anordnen',
    manage_labels: 'Labels verwalten',
    no_images_yet: 'Noch keine Bilder. Lade welche hoch oder w\u00e4hle aus deiner Bibliothek.',
    add_external_image_urls: 'Externe Bild-URLs hinzuf\u00fcgen',
    shared_communication_space: 'Gemeinsamer Kommunikationsraum mit deinem Kunden',
    attach_project_materials: 'F\u00fcge Projektmaterialien, Vertr\u00e4ge, Inspirationen bei \u2014 alles, was dem Projekt hilft.',
    upload_file: 'Datei hochladen',
    // Settings sidebar inside BoardEditor
    client_email_label: 'Kunden-Email',
    used_for_client_notifications: 'F\u00fcr Kunden-Benachrichtigungen verwendet',
    send_test_to_me: 'Test an mich senden',
    client_details: 'Kunden-Details',
    client_details_placeholder: 'E-Mail, Telefon, Adresse, Notizen...',
    auto_lock_label: 'Auto-Sperre vor Projektdatum (Tage)',
    shared_decision_mode: 'Gemeinsamer Entscheidungsmodus',
    shared_decision_desc: 'Erlaubt zwei Personen, ihre Pr\u00e4ferenzen unabh\u00e4ngig auf diesem Board zu w\u00e4hlen.',
    shared_mode_enabled: 'Gemeinsamer Modus aktiviert',
    enable_shared_decisions: 'Gemeinsame Entscheidungen aktivieren',
    person_1_name: 'Name Person 1',
    person_2_name: 'Name Person 2',
    client_uploads_enabled: 'Kunden-Uploads aktiviert',
    client_uploads_hidden: 'Kunden-Uploads ausgeblendet',
    documents_enabled: 'Dokumente aktiviert',
    documents_hidden: 'Dokumente ausgeblendet',
    client_notes_locked: 'Kunden-Notizen',
    client_uploads_locked: 'Kunden-Uploads',
    documents_locked: 'Dokumente',
    internal_view_title: 'Interne Ansicht',
    internal_view_desc: 'Studio-interne Details, niemals f\u00fcr deinen Kunden sichtbar.',
    show_filenames_label: 'Dateinamen anzeigen',
    show_filenames_hint: 'N\u00fctzlich f\u00fcr Retusche, Auswahl und Export-Vorbereitung.',
    client_header_title: 'Kopfbereich der Kundenansicht',
    client_header_desc: 'Wie der obere Teil der Seite wirkt, wenn dein Kunde das Board \u00f6ffnet.',
    show_board_title_label: 'Board-Titel anzeigen',
    show_board_title_hint: 'Zeige den Board-Namen unter dem Logo, \u00fcber dem Willkommens-Bereich.',
    board_subtitle_label: 'Untertitel (optional)',
    board_subtitle_placeholder: 'z. B. Konzept-Inspiration',
    board_subtitle_hint: 'Eine kurze Zeile direkt unter dem Board-Titel.',
    custom_welcome_title: 'Eigene Begr\u00fc\u00dfung',
    custom_welcome_desc: '\u00dcberschreibe die Begr\u00fc\u00dfung deines Kunden — nur f\u00fcr dieses Board.',
    use_custom_welcome_label: 'Eigene Begr\u00fc\u00dfung f\u00fcr dieses Board verwenden',
    use_custom_welcome_hint: 'Wenn aus, verwendet das Board die Vorlagen-Begr\u00fc\u00dfung.',
    custom_welcome_title_label: 'Begr\u00fc\u00dfungstitel',
    custom_welcome_title_placeholder: 'z. B. Willkommen, Anna & Daniel.',
    custom_welcome_description_label: 'Begr\u00fc\u00dfungsbeschreibung',
    custom_welcome_description_placeholder: 'z. B. Das ist die visuelle Richtung f\u00fcr eure Hochzeit.',
    custom_welcome_hint_label: 'Hinweis',
    custom_welcome_hint_placeholder: 'z. B. Nimm dir Zeit. Es gibt keine falschen Antworten.',
    custom_welcome_fallback_hint: 'Lass ein Feld leer, um die Vorlagen-Formulierung f\u00fcr diese Zeile zu behalten.',
    board_cover_panel_title: 'Board-Cover',
    board_cover_panel_desc: 'Eine kinematografische Vollbild-Begr\u00fc\u00dfung, bevor dein Kunde auf dem Moodboard landet.',
    board_cover_enable_label: 'Board-Cover aktivieren',
    board_cover_enable_hint: 'Wenn aus, landet dein Kunde direkt auf dem Board.',
    board_cover_title_label: 'Cover-Titel',
    board_cover_title_placeholder: 'z. B. Schwangerschafts-Shooting',
    board_cover_subtitle_label: 'Cover-Untertitel',
    board_cover_subtitle_placeholder: 'z. B. Minimal Concept · Fr\u00fchling 2026',
    board_cover_button_label: 'Button-Text',
    board_cover_button_placeholder: 'z. B. Konzept entdecken',
    board_cover_image_source_label: 'Cover-Bildquelle',
    board_cover_source_first: 'Erstes Bild vom Board',
    board_cover_source_custom: 'Eigenes Cover-Bild',
    board_cover_show_skip_label: 'Kleinen „\u00dcberspringen"-Link zeigen',
    board_cover_first_visit_only_label: 'Cover nur beim ersten Besuch zeigen',
    enter_board: 'Board \u00f6ffnen',
    skip_cover: '\u00dcberspringen',
    selected_image: 'Ausgew\u00e4hltes Bild',
    section_label: 'Abschnitts-Label',
    none_option: 'Keines',
    from_library_shared: 'Aus Bibliothek (geteilt \u00fcber Boards)',
    cover_image: 'Cover-Bild',
    set_as_cover: 'Als Cover festlegen',
    cover_removed: 'Cover entfernt',
    cover_set: 'Als Cover festgelegt',
    remove_from_board: 'Vom Board entfernen',
    // Delete board modal — soft-delete: board moves to Recently Deleted for 30d
    delete_board_title: 'In K\u00fcrzlich gel\u00f6scht verschieben',
    delete_board_warning: 'Dieses Board wird in K\u00fcrzlich gel\u00f6scht verschoben. Es kann innerhalb von 30 Tagen \u00fcber den Support wiederhergestellt werden.',
    delete_permanently: 'In K\u00fcrzlich gel\u00f6scht verschieben',
    delete_board_confirmation: 'Board in K\u00fcrzlich gel\u00f6scht verschoben.\n\nEs kann innerhalb von 30 Tagen \u00fcber den Support wiederhergestellt werden.',
    // Extend modal
    reopen_board_title: 'Board wieder \u00f6ffnen',
    extend_board_title: 'Board verl\u00e4ngern',
    extend_reopen_subtitle: 'Der Share-Link bleibt gleich. Der Kunde bekommt erneut Zugriff.',
    extend_subtitle: 'Verl\u00e4ngere das Ablaufdatum ab heute.',
    reopen_for: 'Wieder \u00f6ffnen f\u00fcr',
    extend_by: 'Verl\u00e4ngern um',
    new_expiration: 'Neues Ablaufdatum',
    same_share_link: 'Gleicher Share-Link',
    all_images_preserved: 'Alle Bilder erhalten',
    all_reactions_preserved: 'Alle Reaktionen erhalten',
    // Export PDF modal
    export_to_pdf_title: 'Als PDF exportieren',
    export_preferences_subtitle: 'W\u00e4hle deine Export-Einstellungen',
    export_content_label: 'Export-Inhalt',
    all_images_option: 'Alle Bilder',
    export_entire_board: 'Das gesamte Board exportieren',
    client_selected_only: 'Nur vom Kunden gew\u00e4hlt',
    client_selected_desc: 'Nur \u2764\ufe0f \u201eDas f\u00fchle ich\u201c und \ud83e\udd0d \u201eNeutral\u201c \u00b7 Ohne \u274c \u201eNicht ich\u201c',
    include_unrated_images: 'Unbewertete Bilder einbeziehen',
    image_density_label: 'Bild-Dichte',
    density_1: '1 Bild pro Seite',
    density_1_desc: 'Voller Fokus \u00b7 Galerie / Artwork \u00b7 gro\u00dfe R\u00e4nder',
    density_2: '2 Bilder pro Seite',
    density_2_desc: 'Redaktioneller Spread',
    density_4: '4 Bilder pro Seite',
    density_4_desc: 'Klares Raster',
    density_6: '6 Bilder pro Seite',
    density_6_desc: '\u00dcberblick / Referenz-Modus',
    layout_style_label: 'Layout-Stil',
    layout_gallery: 'Galerie',
    layout_gallery_desc: 'Sauber, minimal, auf das Werk fokussiert',
    layout_editorial: 'Redaktionell',
    layout_editorial_desc: 'Elegant mit Labels und Reaktionen',
    layout_reference: 'Referenz',
    layout_reference_desc: 'Kompakt mit allen Details',
    page_orientation_label: 'Seitenausrichtung',
    orientation_portrait: 'Hochformat',
    orientation_landscape: 'Querformat',
    include_in_export: 'In Export einbeziehen',
    include_client_notes: 'Kunden-Notizen / Kommentare unter Bildern',
    include_reactions_icons: 'Reaktions-Icons unter jedem Bild (\u2764\ufe0f / \ud83e\udd0d)',
    include_image_metadata: 'Bild-Metadaten (Pose / Licht / Outfit)',
    include_document_confirmations: 'Dokument-Best\u00e4tigungen & Zeitstempel',
    include_notes_thoughts: 'Notizen & Gedanken',
    include_final_selections_label: 'Finale Auswahl',
    // UserSettings
    settings_title: 'Einstellungen',
    editing_overrides_for: '\u00dcberschreibungen f\u00fcr',
    reset_all_to_default: 'Alle auf Standard zur\u00fccksetzen',
    use_default: 'Standard verwenden',
    custom_label: 'Individuell',
    default_label: 'Standard',
    welcome_title_label: 'Willkommenstitel',
    description_text_label: 'Beschreibungstext',
    welcome_hint_label: 'Hinweis unter der Beschreibung (kursiv)',
    custom_message_label: 'Nachricht (optional)',
    instruction_section: 'Instruktions-Abschnitt',
    instruction_section_desc: '\u00dcber der Galerie in der Kunden-Ansicht. Bearbeite pro Sprache \u2014 leere Felder greifen auf Template-Standard zur\u00fcck.',
    instruction_text_label: 'Instruktionstext',
    reaction_hint_label: 'Reaktions-Hinweis',
    save_branding: 'Branding speichern',
    branding_saved: 'Branding gespeichert',
    // UserSettings page sections
    back_to_workspace: '← Zur\u00fcck zum Workspace',
    account_section: 'Konto',
    brand_name_label: 'Markenname',
    brand_name_placeholder: 'In Kunden-Ansicht, Branding-Header und Exporten sichtbar',
    save_brand_name: 'Markennamen speichern',
    saving_short: 'Speichern…',
    email_label: 'Email',
    username_label: 'Benutzername',
    status_label: 'Status',
    status_active_pill: 'Aktiv',
    access_label: 'Zugang',
    days_remaining: 'Tage verbleibend',
    access_valid_until: 'Zugang g\u00fcltig bis',
    unlimited_access: 'Unbegrenzter Zugang',
    request_extension: 'Verl\u00e4ngerung anfragen',
    locale: 'de-DE',
    usage_section: 'Nutzung',
    storage_label: 'Speicher',
    boards_label: 'Boards',
    images_in_library: 'Bilder in Bibliothek',
    language_section: 'Sprache',
    branding_section: 'Branding',
    logo_label: 'Logo',
    no_logo: 'Kein Logo',
    upload_logo: 'Logo hochladen',
    remove_logo: 'Logo entfernen',
    logo_helper_primary: 'Die besten Ergebnisse erzielst du mit einem transparenten PNG-Logo.',
    logo_helper_secondary: 'F\u00fcr eine saubere, premium Pr\u00e4sentation vermeide Logos mit wei\u00dfem Hintergrund.',
    upload_logo_cta: 'Lade dein Logo hoch',
    upload_logo_hint: 'PNG, SVG, JPG \u00b7 transparenter Hintergrund empfohlen',
    display_in_client_view: 'In Kunden-Ansicht anzeigen',
    display_in_client_help: 'Was im Board-Header gezeigt wird',
    logo_and_name: 'Logo + Markenname',
    logo_only: 'Nur Logo',
    brand_name_only: 'Nur Markenname',
    logo_size_label: 'Logo-Gr\u00f6\u00dfe',
    client_atmosphere: 'Kunden-Ansicht-Atmosph\u00e4re',
    client_atmosphere_help: 'W\u00e4hle die Stimmung, die deine Kunden beim Betrachten der geteilten Boards erleben.',
    atm_maestra: 'Maestra Standard',
    atm_maestra_desc: 'Klarer, elfenbeinfarbener W\u00e4rmeton',
    atm_warm: 'Warmer Sand',
    atm_warm_desc: 'Erdig, goldene Ruhe',
    atm_grey: 'Sanftes Grau',
    atm_grey_desc: 'Neutrale Eleganz',
    atm_blue: 'Staubblau',
    atm_blue_desc: 'K\u00fchle, luftige Weichheit',
    atm_custom: 'Individuell',
    atm_custom_desc: 'Deine eigene Atmosph\u00e4re',
    client_view_texts: 'Kunden-Ansicht-Texte',
    client_view_texts_desc: 'Passe an, wie dein Workspace erscheint, wenn Kunden einen geteilten Board-Link \u00f6ffnen. Bearbeite jede Sprache separat \u2014 leere Felder fallen auf Template-Standard zur\u00fcck.',
    only_fill_empty: 'Nur leere Felder f\u00fcllen',
    density_spacious: 'Gro\u00dfz\u00fcgig',
    density_spacious_sub: 'Ca. 1–2 Bilder pro Seite',
    density_spacious_desc: 'Elegante Pr\u00e4sentation mit gro\u00dfen Abst\u00e4nden',
    density_balanced: 'Ausgewogen',
    density_balanced_sub: 'Ca. 2–4 Bilder pro Seite',
    density_balanced_desc: 'Klares Galerie-Layout',
    density_compact: 'Kompakt',
    density_compact_sub: 'Ca. 6–12 Bilder pro Seite',
    density_compact_desc: 'Adaptives \u00dcbersichtsraster f\u00fcr schnellen Kundenreview',
    image_density_label: 'PDF-Dichte',
    custom_color_helper: 'Wir leiten eine sanfte Palette aus dieser Farbe ab.',
    branding_eyebrow: 'Gestalte das Kundenerlebnis',
    branding_headline: 'Branding',
    card_brand_identity: 'Markenidentit\u00e4t',
    card_brand_identity_desc: 'Dein Logo und wie dein Name am Anfang jedes Boards erscheint.',
    card_client_experience: 'Kundenerlebnis',
    card_client_experience_desc: 'Die Stimmung, die deine Kunden beim \u00d6ffnen eines Boards sp\u00fcren.',
    card_client_view_texts: 'Kunden-Ansicht-Texte',
    card_instruction_section: 'Instruktions-Abschnitt',
    card_inspirations_section: 'Inspirationen-Abschnitt',
    inspirations_section_desc: '\u00dcber dem Inspirationsbereich des Kunden (bis zu 10 Bilder) sichtbar. Pro Sprache bearbeitbar \u2014 leere Felder greifen auf den Plattform-Standard zur\u00fcck.',
    card_notes_section: 'Notizen-Abschnitt',
    notes_section_desc: '\u00dcberschrift und Einleitung des gemeinsamen Notizenbereichs. Pro Sprache bearbeitbar.',
    card_documents_section: 'Dokumenten-Abschnitt',
    documents_section_desc: '\u00dcberschrift und Einleitung \u00fcber den Projektdokumenten. Pro Sprache bearbeitbar.',
    inspirations_title_label: 'Titel der Inspirationen',
    inspirations_description_label: 'Beschreibung der Inspirationen',
    notes_title_label: 'Titel der Notizen',
    notes_description_label: 'Beschreibung der Notizen',
    documents_title_label: 'Titel der Dokumente',
    documents_description_label: 'Beschreibung der Dokumente',
    card_footer: 'Footer',
    advanced_options: 'Erweiterte Optionen',
    preview_open_btn: 'Live-Vorschau',
    preview_close_btn: 'Schlie\u00dfen',
    preview_lang_tag: 'Sprache',
    translate_from_en_to: '\u00dcbersetzen von EN \u2192',
    translating_short: '\u00dcbersetzen…',
    translate_nothing_to_fill: 'Nichts zu f\u00fcllen \u2014 jedes Feld hat bereits eine \u00dcbersetzung.',
    translate_fill_en_first: 'F\u00fclle zuerst den EN-Tab \u2014 nichts zu \u00fcbersetzen.',
    translate_no_results: '\u00dcbersetzer hat keine Ergebnisse zur\u00fcckgegeben.',
    translate_failed: '\u00dcbersetzung fehlgeschlagen.',
    translate_translated_n_to: '{n} Felder ins {lang} \u00fcbersetzt.',
    client_view_footer: 'Kunden-Ansicht-Footer',
    client_view_footer_desc: 'Passe den Footer auf geteilten Board-Seiten an. Ein dezenter \u201ecreated with maestra.space\u201c-Hinweis erscheint immer unten.',
    footer_text_label: 'Footer-Text',
    footer_subtext_label: 'Footer-Untertext',
    optional: 'optional',
    link_label_label: 'Link-Beschriftung',
    link_url_label: 'Link-URL',
    client_view_preview: 'Kunden-Ansicht-Vorschau',
    support_access: 'Support-Zugang',
    // Need help? — founder-led contact flow
    need_help_section: 'Brauchen Sie Hilfe?',
    need_help_body: 'Maestra wird weiterhin sorgf\u00e4ltig und mit Bedacht entwickelt. Sollten Sie jemals Hilfe mit Ihrem Workspace oder Ihren Boards ben\u00f6tigen, k\u00f6nnen Sie sich direkt melden.',
    contact_maestra_btn: 'Maestra kontaktieren',
    contact_modal_title: 'Schreiben Sie an Maestra.',
    contact_modal_subtitle: 'Ein direkter Draht zur Gr\u00fcnderin. Antworten kommen meist innerhalb von ein bis zwei Tagen.',
    contact_field_message: 'Ihre Nachricht',
    contact_field_category: 'Betrifft',
    contact_field_board: 'Board (optional)',
    contact_board_none: 'Keines',
    contact_placeholder: 'Sagen Sie mir, was Ihnen auf dem Herzen liegt…',
    contact_cat_workspace: 'Hilfe zum Workspace',
    contact_cat_board_recovery: 'Wiederherstellung eines archivierten Boards',
    contact_cat_technical: 'Technisches Problem',
    contact_cat_other: 'Sonstiges',
    contact_send: 'Nachricht senden',
    contact_sending: 'Wird gesendet…',
    contact_min_message: 'Bitte schreiben Sie zumindest ein paar Worte.',
    contact_send_failed: 'Die Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    contact_sent_title: 'Ihre Nachricht ist unterwegs.',
    contact_sent_body: 'Ich lese jede Nachricht pers\u00f6nlich. Sie h\u00f6ren bald von mir, meist innerhalb von ein bis zwei Tagen.',
    support_access_desc: 'Admin-Support-Zugang erlauben',
    support_access_active_expires_in: 'Zugang aktiv — läuft ab in',
    support_access_disabled: 'Deaktiviert',
    reset_all_welcome_texts_tooltip: 'Alle Willkommenstexte für jede Sprache auf den Template-Standard zurücksetzen',
    placeholder_welcome_title_eg: 'z. B. Willkommen auf deinem Moodboard',
    placeholder_description_eg: 'z. B. Sieh dir die Bilder an und teile deine Gedanken',
    placeholder_custom_message_eg: 'z. B. Eine persönliche Notiz über der Galerie',
    placeholder_instruction_text_eg: 'z. B. Unten findest du eine kuratierte Auswahl, die für dich vorbereitet wurde.',
    placeholder_reaction_hint_eg: 'z. B. Tippen für Reaktion · doppelt tippen für Favorit',
    preview_welcome_title_default: 'Dein Moodboard ist bereit',
    preview_subtitle_default: 'Sieh dir die Inspirationen an und teile dein Feedback',
    preview_footer_placeholder: 'Hier erscheint der Plattform-Footer. Stelle oben einen eigenen Footer ein, um ihn anzupassen.',
    your_brand_name_placeholder: 'Dein Markenname',
    who_are_you: 'Wer bist du?',
    select_your_name: 'W\u00e4hle deinen Namen, um zu beginnen',
    drop_images_here: 'Bilder hier ablegen...',
    uploading: 'Hochladen...',

    welcome: 'Willkommen.',
    client_intro: 'Dies ist dein privates Moodboard.\nEin kuratierter Raum, um Stimmung, Licht und Atmosph\u00e4re \u2014 gemeinsam zu entdecken.',
    client_hint: 'Nimm dir Zeit. Es gibt keine richtigen oder falschen Entscheidungen.',
    locked_title: 'Dieses Moodboard wurde geschlossen.',
    locked_subtitle: 'Danke f\u00fcr alle Entscheidungen und Hinweise.\nIch habe nun alles, was ich brauche, um das Projekt weiter vorzubereiten.',
    locked_helper: 'Du kannst die Tafel weiterhin ansehen, aber neue Reaktionen oder \u00c4nderungen sind nun deaktiviert.',
    instruction_main: 'Unten findest du eine Auswahl an Bildern, die f\u00fcr dich vorbereitet wurden.\nSie helfen mir zu verstehen, was sich f\u00fcr dich richtig anf\u00fchlt \u2014 intuitiv, nicht intellektuell.',
    instruction_react: 'Reagiere einfach auf jedes Bild.',
    final_decision_prompt: 'Bitte w\u00e4hle deine finalen Pr\u00e4ferenzen.',
    expired_title: 'Dieses Moodboard ist nicht mehr aktiv.',
    archived_title: 'Dieses Board ist nicht mehr verf\u00fcgbar.',
    expired_message: 'Danke f\u00fcr das Teilen deiner Eindr\u00fccke.\nIch habe alles gespeichert, was f\u00fcr deine Vorbereitung n\u00f6tig ist.',

    reaction_love: 'Das f\u00fchle ich',
    reaction_neutral: 'Vielleicht',
    reaction_not_me: 'Nicht das',
    reaction_simple_yes: 'Ja',
    reaction_simple_maybe: 'Vielleicht',
    reaction_simple_no: 'Nein',
    reaction_decision_agree: 'Einverstanden',
    reaction_decision_not_agree: 'Nicht einverstanden',
    reaction_decision_remove: 'Entfernen',
    final_choice: '\u2605 Finale Wahl',
    mark_final: '\u2606 Als final markieren',
    add_note: '+ Notiz hinzuf\u00fcgen',
    comment_placeholder: 'Du kannst eine kurze Notiz hinzuf\u00fcgen, wenn dir etwas auff\u00e4llt.',

    your_inspirations: 'Deine Inspirationen',
    inspiration_intro: 'Du kannst bis zu 10 Bilder hinzuf\u00fcgen, die dein Gef\u00fchl widerspiegeln.\nEs geht nicht um Perfektion \u2014 nur um Resonanz.',
    inspiration_hint: 'W\u00e4hle nur das, was sich wirklich nach dir anf\u00fchlt.',
    add_inspiration: 'Inspiration hinzuf\u00fcgen',
    images_added: 'Bilder hinzugef\u00fcgt',
    max_inspirations: 'Du hast das Maximum von 10 Inspirationen erreicht.',
    max_inspirations_hint: 'Das hilft, die Richtung klar und fokussiert zu halten.',
    no_inspirations: 'Keine Inspirationen hinzugef\u00fcgt.',

    notes_title: 'Konversation',
    notes_subtitle: 'Ein gemeinsamer Raum f\u00fcr Reflexionen und Ideen zwischen dir und dem Studio.',
    no_notes: 'Noch keine Notizen. Teile gerne deine Gedanken.',
    from_studio: 'Von {brand}',
    from_named: 'Von {name}',
    from_client_default: 'Vom Kunden',
    from_you: 'Von dir',
    note_placeholder: 'Du kannst einen kurzen Gedanken teilen, wenn etwas wichtig erscheint.',
    add_note_btn: 'Notiz hinzuf\u00fcgen',
    adding: 'Wird hinzugef\u00fcgt...',
    edit: 'Bearbeiten',
    save: 'Speichern',
    saving: 'Wird gespeichert...',
    cancel: 'Abbrechen',
    notes_closed: 'Notizen sind f\u00fcr dieses Board geschlossen.',
    delete_note_confirm: 'Diese Notiz l\u00f6schen?',
    yes_delete: 'Ja, l\u00f6schen',
    edited: '(bearbeitet)',

    documents_title: 'Projektdokumente',
    documents_subtitle: 'F\u00fcr dein Projekt vorbereitete Materialien',
    external_link: 'Externer Link',
    open: '\u00d6ffnen',
    visit: 'Besuchen',
    i_have_read: 'Ich habe dies gelesen',
    confirming: 'Best\u00e4tigung...',
    confirmed_on: 'Best\u00e4tigt am',

    // Admin
    admin_panel: 'Admin-Bereich',
    users: 'Benutzer',
    invite_user: 'Benutzer einladen',
    storage: 'Speicher',
    limits: 'Limits',
    templates: 'Vorlagen',
    active: 'Aktiv',
    invited: 'Eingeladen',
    deactivated: 'Deaktiviert',
    boards: 'Boards',
    documents: 'Dokumente',
    no_limit: 'Kein Limit',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    back_to_dashboard: 'Zur\u00fcck zum Dashboard',
    platform_overview: 'Plattform-\u00dcbersicht',
    total_users: 'Benutzer gesamt',
    total_boards: 'Boards gesamt',
    total_images: 'Bilder gesamt',
    total_documents: 'Dokumente gesamt',
    user_management: 'Benutzerverwaltung',
    workspace_templates: 'Workspace-Vorlagen',
    create_template: 'Vorlage erstellen',
    template_name: 'Vorlagenname',
    default_labels: 'Standard-Labels',
    global_template: 'Global',
    copy_invite_link: 'Einladungslink kopieren',
    invite_link_copied: 'Link kopiert!',
    set_limits: 'Limits festlegen',
    max_storage_mb: 'Max Speicher (MB)',
    max_boards_limit: 'Max Boards',
    unlimited: 'Unbegrenzt',
    used: 'benutzt',
    of: 'von',
    in_library: 'in Bibliothek',
    across_boards: 'über alle Boards',

    // ── Image Library ────────────────────────────────────────────────
    lib_title: 'Bilderbibliothek',
    lib_back_to_moodboards: '← Zurück zu Moodboards',
    lib_drop_active: 'Bilder hier ablegen...',
    lib_drop_title: 'Bilder per Drag & Drop zur Bibliothek hinzufügen',
    lib_drop_subtitle: 'Bilder aus der Bibliothek können in mehreren Moodboards verwendet werden',
    lib_uploading: 'Wird hochgeladen...',
    lib_upload_tags_placeholder: 'Tags für nächsten Upload (kommagetrennt, z. B. Portrait, Outdoor)',
    lib_add_external_btn: '+ Externe Bild-URL hinzufügen',
    lib_add_external_title: 'Externe Bild-URL hinzufügen',
    lib_external_helper: 'Füge eine direkte Bild-URL ein (z. B. von Pinterest, Unsplash). Das Bild wird nicht heruntergeladen — nur der Link wird gespeichert.',
    lib_preview_label: 'Vorschau:',
    lib_adding: 'Hinzufügen...',
    lib_add_to_library: 'Zur Bibliothek hinzufügen',
    // — Refined two-step upload flow —
    lib_step_add_images: 'Bilder hinzufügen',
    lib_step_add_tags: 'Tags für diesen Upload',
    lib_step_save: 'In der Bibliothek speichern',
    lib_choose_files: 'Dateien auswählen',
    lib_or_separator: 'oder',
    lib_add_from_link: 'Per Link hinzufügen',
    lib_pending_files_label: 'Ausgewählt',
    lib_pending_link_label: 'Link',
    lib_remove_pending: 'Entfernen',
    lib_clear_batch: 'Leeren',
    lib_tags_for_batch_placeholder: 'Tag eingeben und Komma oder Enter drücken…',
    lib_tags_for_batch_help: 'Diese Tags werden allen Bildern dieses Uploads zugewiesen — Dateien und Link.',
    lib_recent_tags: 'Zuletzt verwendet',
    lib_save_button_single: '1 Bild zur Bibliothek hinzufügen',
    lib_save_button_many: '{count} Bilder zur Bibliothek hinzufügen',
    lib_link_input_placeholder: 'https://i.pinimg.com/.../image.jpg',
    lib_filter_all: 'Alle',
    lib_filter_uploaded: 'Hochgeladen',
    lib_filter_external: 'Extern',
    lib_filter_used: 'Verwendet',
    lib_filter_unused: 'Unbenutzt',
    lib_tags_label: 'Tags:',
    lib_collections_heading: 'Sammlungen',
    lib_filters_label: 'Filter',
    lib_tags_heading: 'Nach Tags filtern',
    lib_tags_search_placeholder: 'Tags suchen…',
    lib_clear_all: 'Alle löschen',
    lib_tags_all_hint: '(zeige Bilder mit ALLEN ausgewählten Tags)',
    lib_download_one_tag: '„{tag}" herunterladen',
    lib_download_n_tags: '{count} Tags herunterladen',
    lib_exporting: 'Exportieren...',
    lib_no_filtered_title: 'Noch keine Bilder: {filter}',
    lib_no_filtered_hint: 'Probiere einen anderen Filter oder lade neue Bilder hoch und tagge sie, damit sie hier erscheinen.',
    lib_empty_eyebrow: 'Bilderbibliothek',
    lib_empty_title: 'Hier lebt dein visuelles Archiv.',
    lib_empty_body: 'Lade Bilder von deinem Computer hoch oder füge einen direkten Link ein. Hier gespeicherte Bilder kannst du in jedem Projekt wiederverwenden, ohne Dateien zu duplizieren.',
    lib_drag_to_reorder: 'Zum Umsortieren ziehen',
    lib_selected_count: '{count} ausgewählt',
    lib_exit_select: 'Auswahl beenden',
    lib_select_btn: 'Auswählen',
    lib_reorder_btn: 'Umsortieren',
    lib_reorder_on: '✓ Sortiermodus AN',
    lib_show_details: 'Details anzeigen',
    lib_details_title: 'Bilddetails',
    lib_close_details: 'Details schließen',
    lib_close_details_aria: 'Bilddetails schließen',
    lib_external_ref_badge: 'Externe Referenz',
    lib_uploaded_badge: 'Hochgeladenes Bild',
    lib_name_label: 'Name',
    lib_source_url_label: 'Quell-URL',
    lib_edit_url: 'URL bearbeiten',
    lib_save_url: 'Speichern',
    lib_saving_url: 'Wird gespeichert...',
    lib_url_load_error: 'Bild konnte nicht von dieser URL geladen werden',
    lib_url_ext_error: 'URL muss auf .jpg, .png, .webp oder .gif enden',
    lib_usage_label: 'Verwendung',
    lib_used_in_n_moodboards: 'Verwendet in {count} Moodboard',
    lib_used_in_n_moodboards_plural: 'Verwendet in {count} Moodboards',
    lib_boards_using: 'Boards, die dieses Bild verwenden',
    lib_tags_section_label: 'Tags',
    lib_no_tags: 'Keine Tags',
    lib_edit_tags: 'Tags bearbeiten',
    lib_tags_comma_placeholder: 'Kommagetrennte Tags',
    lib_delete_from_library: 'Aus Bibliothek löschen',
    lib_will_remove_from_n_boards: 'Wird auch aus {count} Board entfernt',
    lib_will_remove_from_n_boards_plural: 'Wird auch aus {count} Boards entfernt',
    lib_card_used_in_n: 'Verwendet in {count} Board',
    lib_card_used_in_n_plural: 'Verwendet in {count} Boards',
    lib_card_broken_link: 'Defekter Link',
    lib_card_external: 'Extern',
    lib_card_demo: 'Beispiel',
    lib_card_image_unavailable: 'Bild nicht verfügbar',
    lib_card_remove: 'Entfernen',
    lib_add_to_board_btn: '+ Board',
    // Library Collections (Phase 1/2)
    lib_collection_all: 'Alle',
    lib_collection_uncategorized: 'Ohne Kategorie',
    lib_collection_new: 'Neue Sammlung',
    lib_collection_new_placeholder: 'Name der Sammlung',
    lib_collection_rename: 'Umbenennen',
    lib_collection_delete: 'Löschen',
    lib_collection_delete_confirm: 'Diese Sammlung löschen? Bilder bleiben in der Bibliothek.',
    lib_add_to_board_short: 'Board',
    lib_pin_used_singular: 'In 1 Board',
    lib_pin_used_plural: 'In {count} Boards',
    // Library Preview Modal (Phase 3)
    lib_preview_title_label: 'Referenz',
    lib_preview_untitled: 'Referenz ohne Titel',
    lib_preview_source_label: 'Quelle',
    lib_preview_source_uploaded: 'In die Bibliothek hochgeladen',
    lib_preview_source_external: 'Externer Link',
    lib_preview_collections_label: 'Sammlungen',
    lib_preview_no_collections: 'In keiner Sammlung.',
    lib_preview_tags_label: 'Tags',
    lib_preview_no_tags: 'Keine Tags.',
    lib_preview_usage_label: 'Nutzung',
    lib_preview_unused: 'Noch in keinem Board verwendet.',
    lib_preview_edit: 'Bearbeiten',
    lib_preview_done: 'Fertig',
    lib_preview_action_add_to_board: 'Zum Board hinzufügen',
    lib_preview_action_edit: 'Bearbeiten',
    lib_preview_action_download: 'Herunterladen',
    lib_preview_action_delete: 'Löschen',
    // Bulk Action Bar (Phase 4)
    lib_bulk_selected_singular: 'ausgewählt',
    lib_bulk_selected_plural: 'ausgewählt',
    lib_bulk_select_all: 'Alle auswählen',
    lib_bulk_add_to_collection: 'Zur Sammlung hinzufügen',
    lib_bulk_manage_collections: 'Sammlungen verwalten',
    lib_bulk_move_here: 'Verschieben',
    lib_bulk_move_confirm: '{count} Bild(er) nach \u201e{name}\u201c verschieben? Sie werden aus allen anderen Sammlungen entfernt.',
    toast_bulk_moved_to_collection: '{count} nach {name} verschoben.',
    toast_bulk_removed_from_collection: '{count} aus {name} entfernt.',
    lib_bulk_add_to_board: 'Zum Board hinzufügen',
    lib_bulk_new_board: 'Neues Board',
    // Duplicates finder
    lib_find_duplicates: 'Duplikate finden',
    lib_duplicates_eyebrow: 'Bibliotheks-Aufräumung',
    lib_duplicates_title: 'Duplikate finden',
    lib_duplicates_scanning: 'Bibliothek wird durchsucht...',
    lib_duplicates_none: 'Deine Bibliothek ist sauber — keine Duplikate gefunden.',
    lib_duplicates_found: '{dup} Duplikate in {groups} Gruppen gefunden.',
    lib_duplicates_description: 'Wir behalten das älteste Bild jeder Gruppe. Tags und Sammlungen der entfernten Kopien werden auf das Original übertragen. Client-Boards, die Duplikate verwendeten, werden auf das Original umgeleitet — kein Bildmaterial geht verloren.',
    lib_duplicates_same_file: 'gleiche Datei',
    lib_duplicates_same_url: 'gleicher Link',
    lib_duplicates_same_filename: 'gleicher Dateiname',
    lib_duplicates_more_groups: '+ {n} weitere Gruppen...',
    lib_duplicates_confirm: 'Duplikate entfernen',
    lib_duplicates_removing: 'Wird entfernt...',
    lib_duplicates_ok: 'OK',
    toast_duplicates_removed: '{count} Duplikate entfernt.',
    toast_duplicates_failed: 'Duplikate konnten nicht entfernt werden.',
    lib_bulk_no_collections: 'Noch keine Sammlungen.',
    lib_bulk_add_tags: 'Tags hinzufügen',
    lib_bulk_remove_tags: 'Tags entfernen',
    lib_bulk_tag_placeholder: 'tag1, tag2, ...',
    lib_bulk_tag_hint: 'Kommagetrennt',
    lib_bulk_apply: 'Anwenden',
    lib_bulk_delete: 'Löschen',
    lib_bulk_cancel: 'Abbrechen',
    toast_bulk_added_to_collection: '{count} zu {name} hinzugefügt.',
    toast_bulk_tags_added: '{count} Bilder markiert.',
    toast_bulk_tags_removed: 'Tags von {count} Bildern entfernt.',
    toast_bulk_action_failed: 'Aktualisierung fehlgeschlagen.',
    lib_add_tag_title: 'Tag hinzufügen',
    lib_add_tag_placeholder: 'Tag hinzufügen...',
    lib_board_selector_title: 'Zum Board hinzufügen',
    lib_board_selector_single: 'Wähle ein Board für dieses Bild',
    lib_board_selector_bulk: '{count} Bild zu einem Board hinzufügen',
    lib_board_selector_bulk_plural: '{count} Bilder zu einem Board hinzufügen',
    lib_no_active_boards: 'Keine aktiven Boards gefunden.',
    lib_create_new_board: 'Neues Board erstellen',
    lib_new_board_btn: '+ Neues Board',
    lib_no_client_label: 'Kein Kunde',
    lib_images_label: 'Bilder',
    lib_create_board_title: 'Neues Board erstellen',
    lib_create_board_with_selection: 'Ein neues Board wird mit {count} ausgewählten Bild erstellt.',
    lib_create_board_with_selection_plural: 'Ein neues Board wird mit {count} ausgewählten Bildern erstellt.',
    lib_create_board_with_one: 'Ein neues Board wird mit 1 Bild erstellt.',
    lib_create_board_empty: 'Leeres Board erstellen.',
    lib_board_name_label: 'Board-Name *',
    lib_board_name_placeholder: 'z. B. Frühjahrskollektion — Anna',
    lib_client_name_label: 'Kundenname',
    lib_client_name_placeholder: 'z. B. Anna Kowalska',
    lib_creating: 'Wird erstellt...',
    lib_create_board: 'Board erstellen',
    lib_board_created_title: 'Board erstellt',
    lib_board_created_text: '{name} wurde mit {count} Bild erstellt.',
    lib_board_created_text_plural: '{name} wurde mit {count} Bildern erstellt.',
    lib_stay_in_library: 'In Bibliothek bleiben',
    lib_open_board: 'Board öffnen',
    lib_delete_title: 'Aus Bibliothek löschen?',
    lib_delete_used_warning: 'Dieses Bild wird in {count} Moodboard verwendet. Beim Löschen wird es aus allen Boards entfernt.',
    lib_delete_used_warning_plural: 'Dieses Bild wird in {count} Moodboards verwendet. Beim Löschen wird es aus allen Boards entfernt.',
    lib_delete_unused_text: 'Das Bild wird dauerhaft aus deiner Bibliothek entfernt.',
    lib_bulk_delete_title: '{count} ausgewähltes Bild aus der Bibliothek löschen?',
    lib_bulk_delete_title_plural: '{count} ausgewählte Bilder aus der Bibliothek löschen?',
    lib_bulk_delete_all_used: 'Alle {count} ausgewählten Bilder werden derzeit in Boards verwendet. Es wird nichts gelöscht.',
    lib_bulk_delete_some: '{count} unbenutztes Bild wird dauerhaft aus deiner Bibliothek entfernt.',
    lib_bulk_delete_some_plural: '{count} unbenutzte Bilder werden dauerhaft aus deiner Bibliothek entfernt.',
    lib_bulk_delete_skipped: '{count} ausgewähltes Bild wird in Boards verwendet und übersprungen.',
    lib_bulk_delete_skipped_plural: '{count} ausgewählte Bilder werden in Boards verwendet und übersprungen.',
    lib_deleting: 'Wird gelöscht...',
    lib_delete_n: '{count} löschen',
    lib_dup_title: 'Duplikat gefunden',
    lib_dup_text: 'Dieses Bild existiert bereits in deiner Bibliothek.',
    lib_dup_used_in_n: 'Verwendet in {count} Board',
    lib_dup_used_in_n_plural: 'Verwendet in {count} Boards',
    lib_dup_add_tags_label: 'Tags zum vorhandenen Bild hinzufügen (optional)',
    lib_dup_tag_placeholder: 'z. B. Hochzeit, Outdoor',
    lib_dup_upload_anyway: 'Trotzdem hochladen',
    lib_dup_use_existing: 'Vorhandenes verwenden',

    // ── CreateBoardModal ─────────────────────────────────────────────
    cbm_title: 'Neues Moodboard erstellen',
    cbm_board_name: 'Board-Name',
    cbm_board_name_placeholder: 'z. B. Frühjahrskollektion 2026',
    cbm_client_name: 'Kundenname',
    cbm_client_name_placeholder: 'z. B. Anna Kowalska',
    cbm_project_date: 'Projektdatum (optional)',
    cbm_autolock_hint: 'Board sperrt sich automatisch vor diesem Datum',
    cbm_link_expires: 'Link läuft ab nach',
    cbm_lock_before: 'Sperren vor Projektdatum',
    cbm_days: '{n} Tage',
    cbm_editable_later: 'Du kannst diese Einstellungen später in den Board-Einstellungen ändern.',
    cbm_creating: 'Wird erstellt...',
    cbm_create_board: 'Board erstellen',
    // ── Board Type selection ─────────────────────────────────────────
    cbm_board_type_label: 'Board-Typ',
    cbm_board_type_client: 'Kunden-Board',
    cbm_board_type_client_desc: 'Mit Kunden zusammenarbeiten, Feedback sammeln und Entscheidungen finalisieren.',
    cbm_board_type_inspiration: 'Inspirations-Board',
    cbm_board_type_inspiration_desc: 'Ein Konzept, eine Stimmung, einen Stil oder eine visuelle Richtung präsentieren.',
    bs_board_type_panel_title: 'Board-Typ',
    bs_board_type_inspiration_summary: 'Ein kuratiertes, rein präsentatives Board — keine Kollaborations-Funktionen.',
    bs_board_type_client_summary: 'Vollständiger Kollaborations-Workspace mit Feedback, Entscheidungen und Dokumenten.',
    bs_convert_to_client_btn: 'In Kunden-Board umwandeln',
    bs_convert_confirm: 'Dieses Inspirations-Board in ein Kunden-Board umwandeln? Damit werden Kommentare, Uploads, Dokumente und Genehmigungs-Workflows aktiviert.',
    bs_converting: 'Wird umgewandelt...',
    bs_convert_success: 'Board in ein Kunden-Board umgewandelt.',
    bs_inspiration_features_hidden: 'Diese Funktionen gehören zum Kunden-Board. Wandeln Sie dieses Board um, um sie zu aktivieren.',
    concept_panel_title: 'Konzept',
    concept_panel_desc: 'Eine kurze Beschreibung am Anfang des Boards — die Stimmung, Geschichte oder Richtung dieses Konzepts.',
    concept_description_label: 'Konzeptbeschreibung',
    concept_description_placeholder: 'z.B. Eine Studie über weiches Nachmittagslicht und natürliche Materialien für editorische Porträts.',
    concept_description_hint: 'Wird am Anfang des Boards unter dem Titel angezeigt.',
    dash_section_client_title: 'KUNDEN-BOARDS',
    dash_section_client_subtitle: 'Aktive Projekte und Kunden-Kollaboration — Feedback, Entscheidungen und Workflows.',
    dash_section_inspiration_title: 'INSPIRATIONS-BOARDS',
    dash_section_inspiration_subtitle: 'Konzepte, Portfolio-Beispiele und visuelle Richtungen.',
    dash_empty_client: 'Erstellen Sie Ihr erstes Kunden-Board.',
    dash_empty_inspiration: 'Erstellen Sie Ihr erstes Inspirations-Board.',

    // ── LibraryModal (Choose from Library) ───────────────────────────
    lm_title: 'Aus Bibliothek wählen',
    lm_subtitle: 'Wähle mehrere Bilder, um sie auf einmal hinzuzufügen',
    lm_no_match: 'Keine Bilder passen zu deinen Filtern',
    lm_empty: 'Deine Bibliothek ist leer',
    lm_clear_filters: 'Filter zurücksetzen',
    lm_select_status_count: '{count}{plus} Bilder · Tippe zum Auswählen',
    lm_select_status_one: '{count} Bild ausgewählt',
    lm_select_status_many: '{count} Bilder ausgewählt',
    lm_select_visible: 'Sichtbare auswählen',
    lm_clear: 'Zurücksetzen',
    lm_load_more: 'Mehr Bilder laden',
    lm_section_label_for_selected: 'Abschnittsbezeichnung für ausgewählte Bilder',
    lm_section_none: 'Keine (ohne Bezeichnung)',
    lm_section_helper: 'Alle ausgewählten Bilder werden mit dieser Bezeichnung hinzugefügt',
    lm_select_images_btn: 'Bilder auswählen',
    lm_add_one_to_board: '{count} Bild zum Board hinzufügen',
    lm_add_many_to_board: '{count} Bilder zum Board hinzufügen',
    lm_density_label: 'Dichte',
    lm_density_comfortable: 'Komfortabel',
    lm_density_compact: 'Kompakt',
    lm_density_tiny: 'Klein',
    lm_filters_btn: 'Filter',
    lm_close_aria: 'Schließen',
    lm_ext_badge: 'Ext',
    lm_preview_aria: 'In voller Größe anzeigen',
    lm_preview_close: 'Vorschau schließen',
    lm_preview_select: 'Dieses Bild auswählen',
    lm_preview_deselect: 'Abwählen',
    lm_preview_no_tags: 'Keine Tags',
    notes_jump_to_input: 'Neue Notiz hinzufügen',
    nav_inspirations: 'Inspirationen',
    nav_gallery: 'Galerie',
    nav_final_decisions: 'Finale Auswahl',
    nav_notes: 'Notizen',
    nav_documents: 'Dokumente',
    lib_floating_n_selected: '{count} Bild ausgewählt',
    lib_floating_n_selected_plural: '{count} Bilder ausgewählt',
    lib_select_all: 'Alle auswählen',
    lib_deselect_all: 'Alle abwählen',
    lib_add_to_board: 'Zum Board hinzufügen',
    lib_new_board_short: 'Neues Board',
    lib_delete_selected: 'Auswahl löschen',

    // ── Library toasts ───────────────────────────────────────────────
    toast_image_reused: 'Bild erfolgreich wiederverwendet',
    toast_more_images_added: '{count} weitere Bilder zur Bibliothek hinzugefügt',
    toast_some_uploads_failed: 'Einige Uploads sind fehlgeschlagen',
    toast_images_added: '{count} Bild(er) zur Bibliothek hinzugefügt',
    toast_upload_failed: 'Upload fehlgeschlagen',
    toast_added_to_board_one: '{count} Bild zu „{board}" hinzugefügt',
    toast_added_to_board_many: '{count} Bilder zu „{board}" hinzugefügt',
    toast_add_to_board_failed: 'Bilder konnten nicht zum Board hinzugefügt werden',
    toast_board_limit_reached: 'Du hast dein aktuelles Board-Limit erreicht.',
    toast_create_board_failed: 'Board konnte nicht erstellt werden',
    toast_reorder_failed: 'Bilder konnten nicht umsortiert werden',
    toast_image_deleted_with_boards: 'Bild gelöscht und aus {count} Board(s) entfernt',
    toast_image_deleted: 'Bild gelöscht',
    toast_delete_failed: 'Bild konnte nicht gelöscht werden',
    toast_bulk_deleted_with_skipped: '{count} Bild(er) gelöscht. {skipped} in Verwendung — übersprungen.',
    toast_bulk_all_used: 'Einige ausgewählte Bilder werden in Boards verwendet und wurden nicht gelöscht.',
    toast_bulk_deleted: '{count} Bild(er) aus Bibliothek gelöscht',
    toast_bulk_no_deleted: 'Keine Bilder gelöscht',
    toast_bulk_delete_failed: 'Massenlöschung fehlgeschlagen',
    toast_tags_updated: 'Tags aktualisiert',
    toast_tags_update_failed: 'Tags konnten nicht aktualisiert werden',
    toast_url_updated: 'Bild-URL aktualisiert',
    toast_url_update_failed: 'URL konnte nicht aktualisiert werden',
    toast_library_export: 'Bibliotheks-Export heruntergeladen',
    toast_export_failed: 'Export fehlgeschlagen',
    toast_external_added: 'Externes Bild zur Bibliothek hinzugefügt',
    toast_external_add_failed: 'Externes Bild konnte nicht hinzugefügt werden',

    // ── BatchUploadStatus ────────────────────────────────────────────
    batch_uploading: 'Wird hochgeladen',
    batch_x_of_y: '{done} von {total}',
    batch_n_failed: '{count} fehlgeschlagen',
    batch_n_remaining: '{count} verbleibend…',
    batch_finishing: 'Abschließen…',
    batch_upload_complete: 'Upload abgeschlossen',
    batch_upload_finished: 'Upload beendet',
    batch_dismiss_aria: 'Schließen',
    batch_n_uploaded_one: '{count} Bild hochgeladen.',
    batch_n_uploaded_many: '{count} Bilder hochgeladen.',
    batch_no_uploaded: 'Keine Bilder hochgeladen.',
    batch_n_failed_text: '{count} fehlgeschlagen.',
    batch_generic_error: 'Einige Dateien konnten nicht hochgeladen werden. Du kannst sie prüfen und die gewünschten erneut versuchen.',
    batch_show_details: 'Details anzeigen ▾',
    batch_hide_details: 'Details verbergen ▴',
    batch_more: '+ {count} weitere',
    batch_retry_failed: 'Fehlgeschlagene erneut versuchen',
    batch_close: 'Schließen',
    batch_dismiss: 'Schließen',
    batch_failed_fallback: 'fehlgeschlagen',
    batch_upload_failed_fallback: 'Upload fehlgeschlagen',
  }
};

export const getTranslation = (lang = 'en') => {
  return translations[lang] || translations.en;
};

export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'pl', label: 'Polski' },
  { value: 'de', label: 'Deutsch' },
];

export default translations;
